{
  "master": {
    "width": 460,
    "height": 120
  },
  "placements": {
    "t": {
      "x": 22,
      "y": -0.222,
      "scaleX": 0.86,
      "scaleY": 1.03,
      "width": 86
    },
    "h": {
      "x": 98.475,
      "y": 0,
      "scaleX": 1,
      "scaleY": 1,
      "width": 69
    },
    "o": {
      "x": 182.5,
      "y": -8.4,
      "scaleX": 0.88,
      "scaleY": 1.14,
      "width": 77
    },
    "m": {
      "x": 274.6,
      "y": -26.7,
      "scaleX": 1,
      "scaleY": 1.49,
      "width": 121
    }
  },
  "pi": {
    "display": {
      "commands": [
        {
          "type": "M",
          "x": 2,
          "y": 30.2
        },
        {
          "type": "C",
          "x1": 5,
          "y1": 21,
          "x2": 16,
          "y2": 13.415,
          "x": 29,
          "y": 13.415
        },
        {
          "type": "C",
          "x1": 48,
          "y1": 13.415,
          "x2": 71,
          "y2": 13.87,
          "x": 91,
          "y": 12.96
        },
        {
          "type": "C",
          "x1": 95,
          "y1": 12.687,
          "x2": 97,
          "y2": 10.1,
          "x": 97.5,
          "y": 8.25
        },
        {
          "type": "L",
          "x": 99,
          "y": 8.25
        },
        {
          "type": "C",
          "x1": 98.5,
          "y1": 13.3,
          "x2": 94,
          "y2": 18.05,
          "x": 86,
          "y": 18.63
        },
        {
          "type": "L",
          "x": 64.51,
          "y": 18.63
        },
        {
          "type": "L",
          "x": 60.79,
          "y": 18.63
        },
        {
          "type": "L",
          "x": 41.36,
          "y": 18.63
        },
        {
          "type": "L",
          "x": 37.64,
          "y": 18.63
        },
        {
          "type": "C",
          "x1": 18,
          "y1": 18.63,
          "x2": 8,
          "y2": 21,
          "x": 3,
          "y": 29.8
        },
        {
          "type": "Z"
        },
        {
          "type": "M",
          "x": 37.64,
          "y": 18.63
        },
        {
          "type": "C",
          "x1": 36.99,
          "y1": 27,
          "x2": 35.07,
          "y2": 42.535,
          "x": 33.37,
          "y": 55.275
        },
        {
          "type": "C",
          "x1": 30.57,
          "y1": 70.745,
          "x2": 24.44,
          "y2": 86.22,
          "x": 10.5,
          "y": 101.1864
        },
        {
          "type": "L",
          "x": 20.6,
          "y": 101.1864
        },
        {
          "type": "C",
          "x1": 26.8,
          "y1": 94.65,
          "x2": 30.33,
          "y2": 83.03,
          "x": 35.13,
          "y": 66.195
        },
        {
          "type": "C",
          "x1": 37.93,
          "y1": 50.725,
          "x2": 40.28,
          "y2": 30,
          "x": 41.36,
          "y": 18.63
        },
        {
          "type": "Z"
        },
        {
          "type": "M",
          "x": 60.79,
          "y": 18.63
        },
        {
          "type": "C",
          "x1": 60.18283713,
          "y1": 26.44838958,
          "x2": 58.46755266,
          "y2": 40.51850456,
          "x": 56.85854676,
          "y": 52.72260962
        },
        {
          "type": "C",
          "x1": 41.30673423,
          "y1": 138.79746558,
          "x2": 86.80571662,
          "y2": 83.98950826,
          "x": 86.80571662,
          "y": 83.98950826
        },
        {
          "type": "C",
          "x1": 46.75198157,
          "y1": 120.82021715,
          "x2": 60.45031492,
          "y2": 52.68602707,
          "x": 60.45031492,
          "y": 52.68602707
        },
        {
          "type": "C",
          "x1": 62.26545535,
          "y1": 40.13351436,
          "x2": 63.72403346,
          "y2": 26.90448112,
          "x": 64.51,
          "y": 18.63
        },
        {
          "type": "Z"
        }
      ]
    },
    "displayContours": [
      {
        "commands": [
          {
            "type": "M",
            "x": 2,
            "y": 30.2
          },
          {
            "type": "C",
            "x1": 5,
            "y1": 21,
            "x2": 16,
            "y2": 13.415,
            "x": 29,
            "y": 13.415
          },
          {
            "type": "C",
            "x1": 48,
            "y1": 13.415,
            "x2": 71,
            "y2": 13.87,
            "x": 91,
            "y": 12.96
          },
          {
            "type": "C",
            "x1": 95,
            "y1": 12.687,
            "x2": 97,
            "y2": 10.1,
            "x": 97.5,
            "y": 8.25
          },
          {
            "type": "L",
            "x": 99,
            "y": 8.25
          },
          {
            "type": "C",
            "x1": 98.5,
            "y1": 13.3,
            "x2": 94,
            "y2": 18.05,
            "x": 86,
            "y": 18.63
          },
          {
            "type": "L",
            "x": 64.51,
            "y": 18.63
          },
          {
            "type": "L",
            "x": 60.79,
            "y": 18.63
          },
          {
            "type": "L",
            "x": 41.36,
            "y": 18.63
          },
          {
            "type": "L",
            "x": 37.64,
            "y": 18.63
          },
          {
            "type": "C",
            "x1": 18,
            "y1": 18.63,
            "x2": 8,
            "y2": 21,
            "x": 3,
            "y": 29.8
          },
          {
            "type": "Z"
          }
        ]
      },
      {
        "commands": [
          {
            "type": "M",
            "x": 37.64,
            "y": 18.63
          },
          {
            "type": "C",
            "x1": 36.99,
            "y1": 27,
            "x2": 35.07,
            "y2": 42.535,
            "x": 33.37,
            "y": 55.275
          },
          {
            "type": "C",
            "x1": 30.57,
            "y1": 70.745,
            "x2": 24.44,
            "y2": 86.22,
            "x": 10.5,
            "y": 101.1864
          },
          {
            "type": "L",
            "x": 20.6,
            "y": 101.1864
          },
          {
            "type": "C",
            "x1": 26.8,
            "y1": 94.65,
            "x2": 30.33,
            "y2": 83.03,
            "x": 35.13,
            "y": 66.195
          },
          {
            "type": "C",
            "x1": 37.93,
            "y1": 50.725,
            "x2": 40.28,
            "y2": 30,
            "x": 41.36,
            "y": 18.63
          },
          {
            "type": "Z"
          }
        ]
      },
      {
        "commands": [
          {
            "type": "M",
            "x": 60.79,
            "y": 18.63
          },
          {
            "type": "C",
            "x1": 60.18283713,
            "y1": 26.44838958,
            "x2": 58.46755266,
            "y2": 40.51850456,
            "x": 56.85854676,
            "y": 52.72260962
          },
          {
            "type": "C",
            "x1": 41.30673423,
            "y1": 138.79746558,
            "x2": 86.80571662,
            "y2": 83.98950826,
            "x": 86.80571662,
            "y": 83.98950826
          },
          {
            "type": "C",
            "x1": 46.75198157,
            "y1": 120.82021715,
            "x2": 60.45031492,
            "y2": 52.68602707,
            "x": 60.45031492,
            "y": 52.68602707
          },
          {
            "type": "C",
            "x1": 62.26545535,
            "y1": 40.13351436,
            "x2": 63.72403346,
            "y2": 26.90448112,
            "x": 64.51,
            "y": 18.63
          },
          {
            "type": "Z"
          }
        ]
      }
    ],
    "compact": {
      "commands": [
        {
          "type": "M",
          "x": 2,
          "y": 30.2
        },
        {
          "type": "C",
          "x1": 5,
          "y1": 21,
          "x2": 16,
          "y2": 13.415,
          "x": 29,
          "y": 13.415
        },
        {
          "type": "C",
          "x1": 48,
          "y1": 13.415,
          "x2": 71,
          "y2": 13.87,
          "x": 91,
          "y": 12.96
        },
        {
          "type": "C",
          "x1": 95,
          "y1": 12.687,
          "x2": 97,
          "y2": 10.1,
          "x": 97.5,
          "y": 8.25
        },
        {
          "type": "L",
          "x": 99,
          "y": 8.25
        },
        {
          "type": "C",
          "x1": 98.5,
          "y1": 13.3,
          "x2": 94,
          "y2": 18.05,
          "x": 86,
          "y": 18.63
        },
        {
          "type": "L",
          "x": 64.51,
          "y": 18.63
        },
        {
          "type": "L",
          "x": 60.79,
          "y": 18.63
        },
        {
          "type": "L",
          "x": 41.36,
          "y": 18.63
        },
        {
          "type": "L",
          "x": 37.64,
          "y": 18.63
        },
        {
          "type": "C",
          "x1": 18,
          "y1": 18.63,
          "x2": 8,
          "y2": 21,
          "x": 3,
          "y": 29.8
        },
        {
          "type": "Z"
        },
        {
          "type": "M",
          "x": 37.64,
          "y": 18.63
        },
        {
          "type": "C",
          "x1": 36.99,
          "y1": 27,
          "x2": 35.07,
          "y2": 42.535,
          "x": 33.37,
          "y": 55.275
        },
        {
          "type": "C",
          "x1": 30.57,
          "y1": 70.745,
          "x2": 24.44,
          "y2": 86.22,
          "x": 10.5,
          "y": 101.1864
        },
        {
          "type": "L",
          "x": 20.6,
          "y": 101.1864
        },
        {
          "type": "C",
          "x1": 26.8,
          "y1": 94.65,
          "x2": 30.33,
          "y2": 83.03,
          "x": 35.13,
          "y": 66.195
        },
        {
          "type": "C",
          "x1": 37.93,
          "y1": 50.725,
          "x2": 40.28,
          "y2": 30,
          "x": 41.36,
          "y": 18.63
        },
        {
          "type": "Z"
        },
        {
          "type": "M",
          "x": 60.79,
          "y": 18.63
        },
        {
          "type": "C",
          "x1": 60.18283713,
          "y1": 26.44838958,
          "x2": 58.46755266,
          "y2": 40.51850456,
          "x": 56.85854676,
          "y": 52.72260962
        },
        {
          "type": "C",
          "x1": 41.30673423,
          "y1": 138.79746558,
          "x2": 86.80571662,
          "y2": 83.98950826,
          "x": 86.80571662,
          "y": 83.98950826
        },
        {
          "type": "C",
          "x1": 46.75198157,
          "y1": 120.82021715,
          "x2": 60.45031492,
          "y2": 52.68602707,
          "x": 60.45031492,
          "y": 52.68602707
        },
        {
          "type": "C",
          "x1": 62.26545535,
          "y1": 40.13351436,
          "x2": 63.72403346,
          "y2": 26.90448112,
          "x": 64.51,
          "y": 18.63
        },
        {
          "type": "Z"
        }
      ]
    }
  },
  "h": {
    "paths": [
      {
        "commands": [
          {
            "type": "M",
            "x": 22.228,
            "y": 104
          },
          {
            "type": "C",
            "x1": 24.152,
            "y1": 103.7,
            "x2": 25.706,
            "y2": 101.8,
            "x": 26.349800000000002,
            "y": 98.5
          },
          {
            "type": "L",
            "x": 26.349800000000002,
            "y": 23
          },
          {
            "type": "C",
            "x1": 26.15,
            "y1": 20.2,
            "x2": 24.522,
            "y2": 18.5,
            "x": 22.524,
            "y": 18.2
          },
          {
            "type": "L",
            "x": 22.524,
            "y": 15
          },
          {
            "type": "L",
            "x": 33.476,
            "y": 15
          },
          {
            "type": "L",
            "x": 33.476,
            "y": 18.2
          },
          {
            "type": "C",
            "x1": 31.478,
            "y1": 18.5,
            "x2": 29.85,
            "y2": 20.2,
            "x": 29.650199999999998,
            "y": 23
          },
          {
            "type": "L",
            "x": 29.650199999999998,
            "y": 98.5
          },
          {
            "type": "C",
            "x1": 30.294,
            "y1": 101.8,
            "x2": 31.848,
            "y2": 103.7,
            "x": 33.772,
            "y": 104
          },
          {
            "type": "Z"
          }
        ]
      },
      {
        "commands": [
          {
            "type": "M",
            "x": 66.228,
            "y": 104
          },
          {
            "type": "C",
            "x1": 68.152,
            "y1": 103.7,
            "x2": 69.706,
            "y2": 101.8,
            "x": 70.3498,
            "y": 98.5
          },
          {
            "type": "L",
            "x": 70.3498,
            "y": 23
          },
          {
            "type": "C",
            "x1": 70.15,
            "y1": 20.2,
            "x2": 68.522,
            "y2": 18.5,
            "x": 66.524,
            "y": 18.2
          },
          {
            "type": "L",
            "x": 66.524,
            "y": 15
          },
          {
            "type": "L",
            "x": 77.476,
            "y": 15
          },
          {
            "type": "L",
            "x": 77.476,
            "y": 18.2
          },
          {
            "type": "C",
            "x1": 75.478,
            "y1": 18.5,
            "x2": 73.85,
            "y2": 20.2,
            "x": 73.6502,
            "y": 23
          },
          {
            "type": "L",
            "x": 73.6502,
            "y": 98.5
          },
          {
            "type": "C",
            "x1": 74.294,
            "y1": 101.8,
            "x2": 75.848,
            "y2": 103.7,
            "x": 77.772,
            "y": 104
          },
          {
            "type": "Z"
          }
        ]
      }
    ],
    "proportion": {
      "ratio": 1.618033988749895,
      "totalLength": 45.53999999999999,
      "aLength": 28.145267847670205,
      "bLength": 17.394732152329787,
      "a": [
        {
          "x": 27.23,
          "y": 60
        },
        {
          "x": 55.3752678476702,
          "y": 60
        }
      ],
      "b": [
        {
          "x": 55.3752678476702,
          "y": 60
        },
        {
          "x": 72.77,
          "y": 60
        }
      ],
      "ratioPoint": {
        "x": 55.3752678476702,
        "y": 60
      },
      "ticks": [
        [
          {
            "x": 27.23,
            "y": 57.2
          },
          {
            "x": 27.23,
            "y": 62.8
          }
        ],
        [
          {
            "x": 55.3752678476702,
            "y": 57.2
          },
          {
            "x": 55.3752678476702,
            "y": 62.8
          }
        ],
        [
          {
            "x": 72.77,
            "y": 57.2
          },
          {
            "x": 72.77,
            "y": 62.8
          }
        ]
      ],
      "brace": [
        {
          "x": 27.23,
          "y": 64.6
        },
        {
          "x": 27.40182916666667,
          "y": 65.95277777777777
        },
        {
          "x": 27.921533333333336,
          "y": 67.02222222222223
        },
        {
          "x": 28.795437500000002,
          "y": 67.82499999999999
        },
        {
          "x": 30.029866666666667,
          "y": 68.37777777777777
        },
        {
          "x": 31.631145833333335,
          "y": 68.69722222222222
        },
        {
          "x": 33.6056,
          "y": 68.8
        },
        {
          "x": 35.80880833333334,
          "y": 68.77569444444445
        },
        {
          "x": 37.87286666666667,
          "y": 68.72222222222223
        },
        {
          "x": 39.810424999999995,
          "y": 68.66875
        },
        {
          "x": 41.63413333333334,
          "y": 68.64444444444445
        },
        {
          "x": 43.356641666666675,
          "y": 68.67847222222223
        },
        {
          "x": 44.9906,
          "y": 68.8
        },
        {
          "x": 46.16177916666667,
          "y": 69.11018518518519
        },
        {
          "x": 47.17989333333334,
          "y": 69.81481481481482
        },
        {
          "x": 48.0588575,
          "y": 70.8
        },
        {
          "x": 48.81258666666666,
          "y": 71.95185185185184
        },
        {
          "x": 49.454995833333335,
          "y": 73.15648148148148
        },
        {
          "x": 50,
          "y": 74.3
        },
        {
          "x": 50.54500416666667,
          "y": 73.15648148148148
        },
        {
          "x": 51.187413333333346,
          "y": 71.95185185185186
        },
        {
          "x": 51.9411425,
          "y": 70.8
        },
        {
          "x": 52.82010666666667,
          "y": 69.81481481481481
        },
        {
          "x": 53.83822083333334,
          "y": 69.11018518518519
        },
        {
          "x": 55.0094,
          "y": 68.8
        },
        {
          "x": 56.64335833333334,
          "y": 68.67847222222223
        },
        {
          "x": 58.365866666666676,
          "y": 68.64444444444445
        },
        {
          "x": 60.189575000000005,
          "y": 68.66875
        },
        {
          "x": 62.12713333333333,
          "y": 68.72222222222221
        },
        {
          "x": 64.19119166666667,
          "y": 68.77569444444444
        },
        {
          "x": 66.39439999999999,
          "y": 68.8
        },
        {
          "x": 68.36885416666667,
          "y": 68.69722222222222
        },
        {
          "x": 69.97013333333334,
          "y": 68.37777777777778
        },
        {
          "x": 71.2045625,
          "y": 67.825
        },
        {
          "x": 72.07846666666666,
          "y": 67.02222222222221
        },
        {
          "x": 72.59817083333334,
          "y": 65.95277777777778
        },
        {
          "x": 72.77,
          "y": 64.6
        }
      ]
    }
  },
  "o": {
    "canonical": {
      "seed": "THOM-01",
      "profile": "display",
      "anchors": [
        {
          "x": 50,
          "y": 18.82
        },
        {
          "x": 78.41155046807549,
          "y": 30.588449531924525
        },
        {
          "x": 81.22572473134109,
          "y": 33.71390668761754
        },
        {
          "x": 90.18,
          "y": 59
        },
        {
          "x": 85.47683428107169,
          "y": 77.86336739273709
        },
        {
          "x": 71.8835964269038,
          "y": 92.69778342004713
        },
        {
          "x": 50,
          "y": 99.18
        },
        {
          "x": 28.70784396310983,
          "y": 93.07457250356521
        },
        {
          "x": 16.30221657995287,
          "y": 80.8835964269038
        },
        {
          "x": 9.972897030673664,
          "y": 55.4980822563991
        },
        {
          "x": 22.088626674957478,
          "y": 30.09692682239301
        },
        {
          "x": 29.909999999999982,
          "y": 24.20309927594127
        }
      ],
      "chords": [
        {
          "a": 0,
          "b": 2,
          "weight": 0.35
        },
        {
          "a": 0,
          "b": 5,
          "weight": 0.05
        },
        {
          "a": 0,
          "b": 7,
          "weight": 1
        },
        {
          "a": 0,
          "b": 10,
          "weight": 0.8
        },
        {
          "a": 1,
          "b": 6,
          "weight": 0.05
        },
        {
          "a": 2,
          "b": 4,
          "weight": 0.32
        },
        {
          "a": 2,
          "b": 7,
          "weight": 0.08
        },
        {
          "a": 2,
          "b": 10,
          "weight": 0.04
        },
        {
          "a": 2,
          "b": 11,
          "weight": 0.45
        },
        {
          "a": 3,
          "b": 5,
          "weight": 0.7
        },
        {
          "a": 3,
          "b": 9,
          "weight": 0.93
        },
        {
          "a": 3,
          "b": 10,
          "weight": 0.12
        },
        {
          "a": 4,
          "b": 6,
          "weight": 0.24
        },
        {
          "a": 5,
          "b": 7,
          "weight": 0.05
        },
        {
          "a": 5,
          "b": 9,
          "weight": 0.52
        },
        {
          "a": 6,
          "b": 8,
          "weight": 0.6
        },
        {
          "a": 7,
          "b": 9,
          "weight": 0.35
        },
        {
          "a": 8,
          "b": 10,
          "weight": 0.55
        },
        {
          "a": 9,
          "b": 11,
          "weight": 0.38
        }
      ],
      "intersections": [
        {
          "x": 77.79479216250277,
          "y": 32.07743579794442
        },
        {
          "x": 63.87872560427564,
          "y": 65.67379241770305
        },
        {
          "x": 61.13748767582035,
          "y": 56.41952826337678
        },
        {
          "x": 53.91701904916018,
          "y": 32.04363469517694
        },
        {
          "x": 52.85418046573841,
          "y": 28.455551770197992
        },
        {
          "x": 61.531346321394246,
          "y": 57.74917276733266
        },
        {
          "x": 57.83494760360936,
          "y": 45.27033982875204
        },
        {
          "x": 70.20718123372468,
          "y": 87.03830057510208
        },
        {
          "x": 46.34105183209784,
          "y": 31.58026869000723
        },
        {
          "x": 47.520508600303714,
          "y": 27.467014120680133
        },
        {
          "x": 39.11784680153508,
          "y": 56.77057824441612
        },
        {
          "x": 44.0886358617423,
          "y": 39.435376678563095
        },
        {
          "x": 35.14561980528309,
          "y": 70.6233800453601
        },
        {
          "x": 30.061384652222873,
          "y": 88.35421515402601
        },
        {
          "x": 34.54852849274731,
          "y": 25.062799716674768
        },
        {
          "x": 27.56472854648346,
          "y": 27.884438050951523
        },
        {
          "x": 73.49979072063003,
          "y": 42.44648652932559
        },
        {
          "x": 77.21846518873795,
          "y": 33.4688121943689
        },
        {
          "x": 77.40988549766801,
          "y": 33.00668268843629
        },
        {
          "x": 67.06120332667655,
          "y": 57.99061153833253
        },
        {
          "x": 70.16262107074903,
          "y": 50.50312675800818
        },
        {
          "x": 52.615371492728755,
          "y": 92.86593467161029
        },
        {
          "x": 56.5110198603644,
          "y": 83.4610075482277
        },
        {
          "x": 84.6425271277188,
          "y": 69.1987563183676
        },
        {
          "x": 83.63297443107665,
          "y": 58.71415069041467
        },
        {
          "x": 83.38267650690435,
          "y": 56.11470735955099
        },
        {
          "x": 60.019516462270616,
          "y": 57.68316485016608
        },
        {
          "x": 67.40680618838637,
          "y": 49.3333527423096
        },
        {
          "x": 43.91121879318471,
          "y": 75.890283279378
        },
        {
          "x": 31.96812766309528,
          "y": 89.38949213952492
        },
        {
          "x": 26.002706088242114,
          "y": 30.336322174786567
        },
        {
          "x": 77.25608377987867,
          "y": 82.80289262775506
        },
        {
          "x": 19.148884299197093,
          "y": 55.89871451265934
        },
        {
          "x": 25.289607587264626,
          "y": 31.455662606835038
        },
        {
          "x": 60.624696386599,
          "y": 92.79603835216825
        },
        {
          "x": 66.33590824053586,
          "y": 89.36439606221421
        },
        {
          "x": 38.59626586269398,
          "y": 92.9882775529883
        },
        {
          "x": 18.603672682587778,
          "y": 60.68397545729621
        },
        {
          "x": 24.978341572904096,
          "y": 85.59434794260216
        },
        {
          "x": 17.479195238540452,
          "y": 70.55338731904064
        },
        {
          "x": 21.20294738496566,
          "y": 37.870434184963784
        }
      ],
      "highlights": [
        {
          "x": 44.0886358617423,
          "y": 39.435376678563095
        },
        {
          "x": 19.148884299197093,
          "y": 55.89871451265934
        },
        {
          "x": 61.531346321394246,
          "y": 57.74917276733266
        },
        {
          "x": 73.49979072063003,
          "y": 42.44648652932559
        },
        {
          "x": 35.14561980528309,
          "y": 70.6233800453601
        },
        {
          "x": 43.91121879318471,
          "y": 75.890283279378
        },
        {
          "x": 56.5110198603644,
          "y": 83.4610075482277
        },
        {
          "x": 84.6425271277188,
          "y": 69.1987563183676
        }
      ]
    },
    "compact": {
      "seed": "THOM-01",
      "profile": "compact",
      "anchors": [
        {
          "x": 89.079281502657,
          "y": 68.34035102317308
        },
        {
          "x": 72.93730539601344,
          "y": 91.9895804939986
        },
        {
          "x": 44.43626863091993,
          "y": 98.79293019184078
        },
        {
          "x": 28.238803152088703,
          "y": 92.77695533564942
        },
        {
          "x": 10.649848229237094,
          "y": 67.1239125806427
        },
        {
          "x": 10.79626579118046,
          "y": 50.19661291977728
        },
        {
          "x": 26.444867107631456,
          "y": 26.448684904863562
        },
        {
          "x": 55.793069660774265,
          "y": 19.239809558989577
        },
        {
          "x": 75.29996267364393,
          "y": 27.785511557736154
        },
        {
          "x": 88.00950865273951,
          "y": 45.97273428622414
        }
      ],
      "chords": [
        {
          "a": 1,
          "b": 4
        },
        {
          "a": 5,
          "b": 8
        },
        {
          "a": 6,
          "b": 9
        },
        {
          "a": 4,
          "b": 9
        },
        {
          "a": 0,
          "b": 5
        },
        {
          "a": 5,
          "b": 9
        },
        {
          "a": 7,
          "b": 9
        },
        {
          "a": 1,
          "b": 5
        },
        {
          "a": 0,
          "b": 4
        },
        {
          "a": 0,
          "b": 3
        },
        {
          "a": 1,
          "b": 3
        },
        {
          "a": 2,
          "b": 4
        },
        {
          "a": 0,
          "b": 6
        }
      ],
      "intersections": [
        {
          "x": 51.50306506208342,
          "y": 83.4328545276214
        },
        {
          "x": 53.9980154348734,
          "y": 35.18663927366911
        },
        {
          "x": 68.80934689513668,
          "y": 30.04060475618097
        },
        {
          "x": 44.462758346580074,
          "y": 38.4995596712124
        },
        {
          "x": 44.224179091566405,
          "y": 57.94423606322636
        },
        {
          "x": 28.648184184053665,
          "y": 62.202923906453606
        },
        {
          "x": 65.03013900116628,
          "y": 52.255604996009644
        },
        {
          "x": 58.08393149992222,
          "y": 47.6097851501435
        },
        {
          "x": 36.56268060942494,
          "y": 67.52581992775073
        },
        {
          "x": 56.95723835522525,
          "y": 81.24218347720324
        },
        {
          "x": 35.08460394776787,
          "y": 90.02733649994406
        },
        {
          "x": 37.83767180941004,
          "y": 92.60786896117
        }
      ],
      "highlights": [
        {
          "x": 44.462758346580074,
          "y": 38.4995596712124
        },
        {
          "x": 68.80934689513668,
          "y": 30.04060475618097
        },
        {
          "x": 37.83767180941004,
          "y": 92.60786896117
        },
        {
          "x": 51.50306506208342,
          "y": 83.4328545276214
        },
        {
          "x": 28.648184184053665,
          "y": 62.202923906453606
        },
        {
          "x": 65.03013900116628,
          "y": 52.255604996009644
        },
        {
          "x": 44.224179091566405,
          "y": 57.94423606322636
        },
        {
          "x": 53.9980154348734,
          "y": 35.18663927366911
        }
      ]
    },
    "alternates": [
      {
        "seed": "THOM-02",
        "profile": "display",
        "anchors": [
          {
            "x": 89.37238736489053,
            "y": 67.01545464643206
          },
          {
            "x": 82.66082382189973,
            "y": 82.40305508421555
          },
          {
            "x": 59.94320232677103,
            "y": 97.93025979220914
          },
          {
            "x": 39.83688153428767,
            "y": 97.8734282389899
          },
          {
            "x": 27.730078671025804,
            "y": 92.44372891890646
          },
          {
            "x": 11.33796686305589,
            "y": 69.93981689599215
          },
          {
            "x": 9.945296287108647,
            "y": 55.82933595717123
          },
          {
            "x": 16.88330786840261,
            "y": 36.2466024018171
          },
          {
            "x": 32.48918923241408,
            "y": 22.83642846369019
          },
          {
            "x": 58.70555311388284,
            "y": 19.774424861050605
          },
          {
            "x": 72.17271241004116,
            "y": 25.49174393702939
          },
          {
            "x": 88.58924045630508,
            "y": 47.8061212707361
          }
        ],
        "chords": [
          {
            "a": 2,
            "b": 7
          },
          {
            "a": 5,
            "b": 11
          },
          {
            "a": 4,
            "b": 9
          },
          {
            "a": 1,
            "b": 5
          },
          {
            "a": 1,
            "b": 8
          },
          {
            "a": 3,
            "b": 10
          },
          {
            "a": 0,
            "b": 8
          },
          {
            "a": 2,
            "b": 6
          },
          {
            "a": 3,
            "b": 7
          },
          {
            "a": 4,
            "b": 11
          },
          {
            "a": 6,
            "b": 9
          },
          {
            "a": 2,
            "b": 10
          },
          {
            "a": 0,
            "b": 10
          },
          {
            "a": 1,
            "b": 9
          },
          {
            "a": 6,
            "b": 8
          },
          {
            "a": 0,
            "b": 4
          },
          {
            "a": 5,
            "b": 7
          },
          {
            "a": 9,
            "b": 11
          },
          {
            "a": 1,
            "b": 3
          }
        ],
        "intersections": [
          {
            "x": 35.55924779083923,
            "y": 63.00004186351651
          },
          {
            "x": 38.49060672442551,
            "y": 67.19923794660075
          },
          {
            "x": 44.441911141385006,
            "y": 75.72453108303836
          },
          {
            "x": 47.66746645436955,
            "y": 80.34516592951393
          },
          {
            "x": 46.5018602069714,
            "y": 78.6754252735975
          },
          {
            "x": 23.537515118252962,
            "y": 45.77880969975353
          },
          {
            "x": 20.139165116844524,
            "y": 40.91064502317297
          },
          {
            "x": 49.767238378686514,
            "y": 83.35310669682717
          },
          {
            "x": 55.86220453975944,
            "y": 92.08419647804213
          },
          {
            "x": 40.9373403625797,
            "y": 61.459134400241275
          },
          {
            "x": 60.33828319720379,
            "y": 55.900461467474415
          },
          {
            "x": 58.330974545274024,
            "y": 56.47558672640139
          },
          {
            "x": 71.09348970043146,
            "y": 52.81892693663117
          },
          {
            "x": 22.801841438654904,
            "y": 66.65523790149653
          },
          {
            "x": 27.687910179654036,
            "y": 65.2553029452552
          },
          {
            "x": 67.37952198545804,
            "y": 53.88303665471915
          },
          {
            "x": 82.17666106687088,
            "y": 49.64342535358982
          },
          {
            "x": 35.52114288169986,
            "y": 74.16568074552937
          },
          {
            "x": 49.02969223852217,
            "y": 42.47425718388496
          },
          {
            "x": 51.20456322139692,
            "y": 37.371950808152334
          },
          {
            "x": 34.51743794752509,
            "y": 76.52039977268979
          },
          {
            "x": 33.11188926689354,
            "y": 79.81785513949487
          },
          {
            "x": 49.34864598191888,
            "y": 76.58195334080511
          },
          {
            "x": 30.72592993335015,
            "y": 73.32774626439912
          },
          {
            "x": 63.14047564896786,
            "y": 78.99199221923963
          },
          {
            "x": 61.17281303476764,
            "y": 78.64815506968475
          },
          {
            "x": 59.194541903799205,
            "y": 54.54254655933654
          },
          {
            "x": 66.91215746810593,
            "y": 63.70534000789113
          },
          {
            "x": 40.961350818295664,
            "y": 32.89506199206095
          },
          {
            "x": 65.9201075274513,
            "y": 62.52752172695608
          },
          {
            "x": 74.7728224241436,
            "y": 73.03796985454697
          },
          {
            "x": 62.83126672994573,
            "y": 46.4019711935549
          },
          {
            "x": 45.314507861062204,
            "y": 85.61211288785117
          },
          {
            "x": 66.09560332108497,
            "y": 39.094963017298404
          },
          {
            "x": 45.545730964702216,
            "y": 85.0945347945188
          },
          {
            "x": 69.9956882376413,
            "y": 30.364872973665328
          },
          {
            "x": 76.2716117195195,
            "y": 56.84057824614349
          },
          {
            "x": 43.25581627038435,
            "y": 31.198460020047712
          },
          {
            "x": 67.96887365931272,
            "y": 50.39215596693093
          },
          {
            "x": 71.45126453927415,
            "y": 53.09679710729117
          },
          {
            "x": 41.464446334643696,
            "y": 82.37015417551287
          },
          {
            "x": 44.977981031764415,
            "y": 85.32873921221216
          },
          {
            "x": 13.208127391597756,
            "y": 58.5768150957519
          },
          {
            "x": 53.85968987761059,
            "y": 92.80761537449229
          },
          {
            "x": 35.65073429998684,
            "y": 86.63426477398039
          },
          {
            "x": 21.103917025833944,
            "y": 47.57829084640895
          },
          {
            "x": 19.156258268240855,
            "y": 42.34912571545479
          },
          {
            "x": 36.471461655036634,
            "y": 88.83779188072587
          },
          {
            "x": 65.55295554235201,
            "y": 64.70225683186086
          },
          {
            "x": 83.0871911201885,
            "y": 51.841640530645684
          },
          {
            "x": 73.62558156622525,
            "y": 58.781328863522944
          },
          {
            "x": 14.175072947466955,
            "y": 52.70170227822135
          },
          {
            "x": 68.7184609465555,
            "y": 45.95215876164157
          },
          {
            "x": 63.350161409711895,
            "y": 77.74996983233787
          },
          {
            "x": 71.16484895530526,
            "y": 31.46157693513267
          },
          {
            "x": 61.25933760819464,
            "y": 90.13445392575922
          },
          {
            "x": 76.85723435479404,
            "y": 36.80118638616845
          },
          {
            "x": 78.49189173533652,
            "y": 71.5038041737478
          },
          {
            "x": 14.839064352510988,
            "y": 48.66732372316647
          }
        ],
        "highlights": [
          {
            "x": 23.537515118252962,
            "y": 45.77880969975353
          },
          {
            "x": 40.961350818295664,
            "y": 32.89506199206095
          },
          {
            "x": 67.37952198545804,
            "y": 53.88303665471915
          },
          {
            "x": 66.09560332108497,
            "y": 39.094963017298404
          },
          {
            "x": 44.441911141385006,
            "y": 75.72453108303836
          },
          {
            "x": 22.801841438654904,
            "y": 66.65523790149653
          },
          {
            "x": 61.17281303476764,
            "y": 78.64815506968475
          },
          {
            "x": 66.91215746810593,
            "y": 63.70534000789113
          }
        ]
      },
      {
        "seed": "THOM-03",
        "profile": "display",
        "anchors": [
          {
            "x": 86.58589476755711,
            "y": 75.61037940738375
          },
          {
            "x": 74.69137425332224,
            "y": 90.69808255214147
          },
          {
            "x": 55.19463129484049,
            "y": 98.8427936484211
          },
          {
            "x": 34.2840431315433,
            "y": 95.9789277793287
          },
          {
            "x": 18.472392224481382,
            "y": 83.90868017284453
          },
          {
            "x": 10.125956800781807,
            "y": 63.94904828698218
          },
          {
            "x": 13.202481174530938,
            "y": 42.86386018004151
          },
          {
            "x": 21.555177319834232,
            "y": 30.62176075416364
          },
          {
            "x": 39.01139313520876,
            "y": 20.351805745014907
          },
          {
            "x": 67.6928056028176,
            "y": 22.925119128389262
          },
          {
            "x": 81.73091612228363,
            "y": 34.350834455491174
          },
          {
            "x": 88.86573848112718,
            "y": 48.80751392855354
          }
        ],
        "chords": [
          {
            "a": 4,
            "b": 8
          },
          {
            "a": 1,
            "b": 9
          },
          {
            "a": 0,
            "b": 6
          },
          {
            "a": 3,
            "b": 11
          },
          {
            "a": 4,
            "b": 10
          },
          {
            "a": 7,
            "b": 11
          },
          {
            "a": 2,
            "b": 9
          },
          {
            "a": 2,
            "b": 8
          },
          {
            "a": 6,
            "b": 10
          },
          {
            "a": 5,
            "b": 7
          },
          {
            "a": 3,
            "b": 7
          },
          {
            "a": 0,
            "b": 8
          },
          {
            "a": 1,
            "b": 6
          },
          {
            "a": 5,
            "b": 9
          },
          {
            "a": 1,
            "b": 11
          },
          {
            "a": 2,
            "b": 4
          },
          {
            "a": 3,
            "b": 10
          },
          {
            "a": 0,
            "b": 2
          },
          {
            "a": 3,
            "b": 5
          }
        ],
        "intersections": [
          {
            "x": 29.400549043174905,
            "y": 50.09206496004854
          },
          {
            "x": 34.55733963604336,
            "y": 34.13464358468008
          },
          {
            "x": 32.51157199577385,
            "y": 40.46516557970159
          },
          {
            "x": 26.871417394356975,
            "y": 57.91833184196953
          },
          {
            "x": 28.013081629116442,
            "y": 54.38551100405556
          },
          {
            "x": 20.484374496692883,
            "y": 77.68270524924553
          },
          {
            "x": 72.48349415250223,
            "y": 69.31734246236401
          },
          {
            "x": 71.88132516392012,
            "y": 63.48603910933467
          },
          {
            "x": 69.83505116056604,
            "y": 43.670265326178175
          },
          {
            "x": 69.03553989984297,
            "y": 35.92793255275373
          },
          {
            "x": 71.29987972112401,
            "y": 57.85541909324231
          },
          {
            "x": 70.39337788460263,
            "y": 49.07700755251994
          },
          {
            "x": 74.08846625918375,
            "y": 84.85962279341788
          },
          {
            "x": 67.63660659189901,
            "y": 67.15447364876138
          },
          {
            "x": 49.93905433482623,
            "y": 59.25714090164859
          },
          {
            "x": 60.90587787491296,
            "y": 64.15096200283061
          },
          {
            "x": 46.73840137257403,
            "y": 57.82888567834017
          },
          {
            "x": 16.80550607308807,
            "y": 44.47166933391286
          },
          {
            "x": 24.961382550975515,
            "y": 48.111137066773274
          },
          {
            "x": 80.6872037005198,
            "y": 72.97815516235018
          },
          {
            "x": 59.3296179169683,
            "y": 63.44757380524165
          },
          {
            "x": 59.212916001196504,
            "y": 74.43452225223403
          },
          {
            "x": 51.53097168359492,
            "y": 81.0735277331614
          },
          {
            "x": 74.32745990139922,
            "y": 61.37200374826075
          },
          {
            "x": 56.6417042717848,
            "y": 76.65665353286255
          },
          {
            "x": 38.72180099602666,
            "y": 92.14366191859774
          },
          {
            "x": 63.454681789359185,
            "y": 48.66875946475199
          },
          {
            "x": 47.43701897997531,
            "y": 61.21727962216928
          },
          {
            "x": 30.151320405034717,
            "y": 74.75920141088403
          },
          {
            "x": 42.134719159028535,
            "y": 65.3711950201661
          },
          {
            "x": 22.68881890562035,
            "y": 80.60545698540501
          },
          {
            "x": 64.51493040123117,
            "y": 42.228490106767566
          },
          {
            "x": 42.28351908169937,
            "y": 36.22207815595124
          },
          {
            "x": 49.96387592618747,
            "y": 38.29713252268583
          },
          {
            "x": 55.82453221724842,
            "y": 39.88054598574962
          },
          {
            "x": 47.178157736975514,
            "y": 37.54449604887867
          },
          {
            "x": 73.7458862421212,
            "y": 44.72248037500877
          },
          {
            "x": 65.47945261920779,
            "y": 36.3696916929103
          },
          {
            "x": 58.596713881642124,
            "y": 78.17751949312104
          },
          {
            "x": 61.481905456144176,
            "y": 60.651997006114144
          },
          {
            "x": 42.892472062984375,
            "y": 39.1755860149045
          },
          {
            "x": 49.4700063149051,
            "y": 71.07755497248785
          },
          {
            "x": 43.14828392350097,
            "y": 40.41630962357275
          },
          {
            "x": 50.311852181785916,
            "y": 75.16062617876231
          },
          {
            "x": 17.54174757734047,
            "y": 42.324809688943056
          },
          {
            "x": 23.6857961564185,
            "y": 41.5615580015748
          },
          {
            "x": 54.02676952821145,
            "y": 37.792414769004296
          },
          {
            "x": 45.310913785241254,
            "y": 38.87515223715084
          },
          {
            "x": 16.481972601091613,
            "y": 45.415083893964685
          },
          {
            "x": 25.856651795921323,
            "y": 52.70795365985832
          },
          {
            "x": 33.09112029553097,
            "y": 89.8537899866377
          },
          {
            "x": 51.29035092692878,
            "y": 34.61401912297953
          },
          {
            "x": 81.71205528373649,
            "y": 69.94933391253954
          },
          {
            "x": 67.25344719086445,
            "y": 53.15542051477867
          },
          {
            "x": 51.9625360912238,
            "y": 73.01657546252547
          },
          {
            "x": 70.55134411640167,
            "y": 87.477417611192
          },
          {
            "x": 77.52833223839333,
            "y": 82.31380645722273
          },
          {
            "x": 37.59086888050069,
            "y": 91.68373711624353
          },
          {
            "x": 28.148052449048343,
            "y": 87.84355482653739
          }
        ],
        "highlights": [
          {
            "x": 24.961382550975515,
            "y": 48.111137066773274
          },
          {
            "x": 45.310913785241254,
            "y": 38.87515223715084
          },
          {
            "x": 55.82453221724842,
            "y": 39.88054598574962
          },
          {
            "x": 73.7458862421212,
            "y": 44.72248037500877
          },
          {
            "x": 30.151320405034717,
            "y": 74.75920141088403
          },
          {
            "x": 49.4700063149051,
            "y": 71.07755497248785
          },
          {
            "x": 59.212916001196504,
            "y": 74.43452225223403
          },
          {
            "x": 74.32745990139922,
            "y": 61.37200374826075
          }
        ]
      },
      {
        "seed": "THOM-04",
        "profile": "display",
        "anchors": [
          {
            "x": 89.74490708821182,
            "y": 64.89701284969003
          },
          {
            "x": 82.9923496511525,
            "y": 81.9333221425963
          },
          {
            "x": 67.47218315122302,
            "y": 95.18225001198957
          },
          {
            "x": 47.82957649334022,
            "y": 99.12133673996591
          },
          {
            "x": 25.50971013478889,
            "y": 90.85369840878667
          },
          {
            "x": 11.682232294860306,
            "y": 71.09053671657935
          },
          {
            "x": 9.841839733759429,
            "y": 57.675400426190286
          },
          {
            "x": 18.59367982601054,
            "y": 33.938566419119944
          },
          {
            "x": 31.8524041414921,
            "y": 23.151748096228367
          },
          {
            "x": 58.855167246427285,
            "y": 19.807929207073002
          },
          {
            "x": 74.10740193880356,
            "y": 26.85555146279578
          },
          {
            "x": 85.8375412817671,
            "y": 40.83126215507421
          }
        ],
        "chords": [
          {
            "a": 6,
            "b": 11
          },
          {
            "a": 2,
            "b": 8
          },
          {
            "a": 5,
            "b": 9
          },
          {
            "a": 1,
            "b": 5
          },
          {
            "a": 4,
            "b": 10
          },
          {
            "a": 7,
            "b": 11
          },
          {
            "a": 0,
            "b": 3
          },
          {
            "a": 3,
            "b": 7
          },
          {
            "a": 1,
            "b": 8
          },
          {
            "a": 0,
            "b": 2
          },
          {
            "a": 0,
            "b": 4
          },
          {
            "a": 2,
            "b": 6
          },
          {
            "a": 9,
            "b": 11
          },
          {
            "a": 8,
            "b": 10
          },
          {
            "a": 5,
            "b": 10
          },
          {
            "a": 4,
            "b": 6
          },
          {
            "a": 1,
            "b": 9
          },
          {
            "a": 5,
            "b": 7
          },
          {
            "a": 3,
            "b": 11
          }
        ],
        "intersections": [
          {
            "x": 45.0641096422546,
            "y": 49.86852750474651
          },
          {
            "x": 27.65389883091576,
            "y": 53.72742994609334
          },
          {
            "x": 58.97329134891565,
            "y": 46.785613930258705
          },
          {
            "x": 53.47424852845682,
            "y": 48.004454413862675
          },
          {
            "x": 40.068523451194025,
            "y": 50.97577887335643
          },
          {
            "x": 68.51495738848216,
            "y": 44.67074244630062
          },
          {
            "x": 14.36435170493004,
            "y": 56.67300403503318
          },
          {
            "x": 40.21801729356257,
            "y": 40.06873441475974
          },
          {
            "x": 59.12592570913395,
            "y": 78.30440491060374
          },
          {
            "x": 49.626427225727106,
            "y": 59.09446979222815
          },
          {
            "x": 38.17936302778797,
            "y": 35.94615718157884
          },
          {
            "x": 63.20993388659568,
            "y": 86.56310743568893
          },
          {
            "x": 58.69950457667361,
            "y": 77.44209388418736
          },
          {
            "x": 44.173290130544416,
            "y": 48.06710766642276
          },
          {
            "x": 60.10812471088484,
            "y": 80.29061282778224
          },
          {
            "x": 43.50780871143172,
            "y": 36.492338707264715
          },
          {
            "x": 18.712047530060115,
            "y": 63.44828897555503
          },
          {
            "x": 53.994050088688816,
            "y": 25.092543435845897
          },
          {
            "x": 14.652201065377996,
            "y": 67.86182637811247
          },
          {
            "x": 37.53238066766184,
            "y": 75.02108153165189
          },
          {
            "x": 71.09556646015825,
            "y": 80.1244025645329
          },
          {
            "x": 36.982590748151665,
            "y": 74.93748534155095
          },
          {
            "x": 77.79684326229454,
            "y": 81.14333941584769
          },
          {
            "x": 57.265559665331665,
            "y": 78.02153411225669
          },
          {
            "x": 36.17741011642874,
            "y": 74.81505669968888
          },
          {
            "x": 16.524602071214446,
            "y": 71.82682461491646
          },
          {
            "x": 61.19781224393132,
            "y": 78.61943764307868
          },
          {
            "x": 65.10829092048492,
            "y": 38.706452358588216
          },
          {
            "x": 37.2103155087889,
            "y": 75.44520812282532
          },
          {
            "x": 55.91627759744315,
            "y": 50.81138569060577
          },
          {
            "x": 71.80012326307971,
            "y": 29.893999468306347
          },
          {
            "x": 65.82896179772233,
            "y": 37.75740315503477
          },
          {
            "x": 58.3594534239793,
            "y": 38.014676448821064
          },
          {
            "x": 66.24287441788032,
            "y": 38.82275054053791
          },
          {
            "x": 77.131137271774,
            "y": 75.19629326925023
          },
          {
            "x": 59.22637147125134,
            "y": 89.81572952896558
          },
          {
            "x": 79.59365959451745,
            "y": 73.18561697576733
          },
          {
            "x": 41.265705762036134,
            "y": 84.48688638727911
          },
          {
            "x": 29.57147831606723,
            "y": 58.41407082208622
          },
          {
            "x": 79.86201368090838,
            "y": 78.33523313817695
          },
          {
            "x": 73.78246794176317,
            "y": 71.34724626270526
          },
          {
            "x": 49.96081342543235,
            "y": 43.96602137277686
          },
          {
            "x": 69.29952096872978,
            "y": 66.19443124080568
          },
          {
            "x": 80.9955614503286,
            "y": 76.79389660795243
          },
          {
            "x": 47.29494153051432,
            "y": 82.0505433163997
          },
          {
            "x": 78.187784149116,
            "y": 69.56710993548946
          },
          {
            "x": 63.13389334882553,
            "y": 75.65020967639086
          },
          {
            "x": 20.669390859381636,
            "y": 64.72216272829036
          },
          {
            "x": 13.709594282937758,
            "y": 60.192603682467656
          },
          {
            "x": 55.48499412705405,
            "y": 87.38077479902375
          },
          {
            "x": 67.11363959490771,
            "y": 26.242522901333118
          },
          {
            "x": 70.85676368683039,
            "y": 29.15898028744407
          },
          {
            "x": 61.15213691055858,
            "y": 25.719975632060798
          },
          {
            "x": 15.049965751199482,
            "y": 68.70413327339237
          },
          {
            "x": 64.2948410010152,
            "y": 33.808812316721784
          },
          {
            "x": 12.952469275371698,
            "y": 64.26247264490726
          },
          {
            "x": 74.04802161199213,
            "y": 58.91199825069597
          }
        ],
        "highlights": [
          {
            "x": 38.17936302778797,
            "y": 35.94615718157884
          },
          {
            "x": 49.96081342543235,
            "y": 43.96602137277686
          },
          {
            "x": 64.2948410010152,
            "y": 33.808812316721784
          },
          {
            "x": 74.04802161199213,
            "y": 58.91199825069597
          },
          {
            "x": 37.53238066766184,
            "y": 75.02108153165189
          },
          {
            "x": 20.669390859381636,
            "y": 64.72216272829036
          },
          {
            "x": 57.265559665331665,
            "y": 78.02153411225669
          },
          {
            "x": 73.78246794176317,
            "y": 71.34724626270526
          }
        ]
      }
    ],
    "circle": [
      {
        "x": 90.18,
        "y": 59
      },
      {
        "x": 90.13083640348901,
        "y": 60.98705046649565
      },
      {
        "x": 89.98346592551516,
        "y": 62.96923828752681
      },
      {
        "x": 89.7382492063331,
        "y": 64.94171271733727
      },
      {
        "x": 89.395786332346,
        "y": 66.89964678046681
      },
      {
        "x": 88.95691536759355,
        "y": 68.83824908416908
      },
      {
        "x": 88.42271030286872,
        "y": 70.75277554375245
      },
      {
        "x": 87.79447842748245,
        "y": 72.6385409921503
      },
      {
        "x": 87.07375713010754,
        "y": 74.49093064530989
      },
      {
        "x": 86.26231013653099,
        "y": 76.30541139534226
      },
      {
        "x": 85.36212319352147,
        "y": 78.07754290379688
      },
      {
        "x": 84.37539920937417,
        "y": 79.80298846791388
      },
      {
        "x": 83.3045528630251,
        "y": 81.47752563326236
      },
      {
        "x": 82.1522046949271,
        "y": 83.09705652679406
      },
      {
        "x": 80.92117469414814,
        "y": 84.65761788502536
      },
      {
        "x": 79.61447539738568,
        "y": 86.15539075280705
      },
      {
        "x": 78.23530451678442,
        "y": 87.58670982894766
      },
      {
        "x": 76.7870371145989,
        "y": 88.94807243581965
      },
      {
        "x": 75.27321734385058,
        "y": 90.23614709099844
      },
      {
        "x": 73.69754977519148,
        "y": 91.44778165995825
      },
      {
        "x": 72.06389033119905,
        "y": 92.58001106987342
      },
      {
        "x": 70.37623685028748,
        "y": 93.63006456564854
      },
      {
        "x": 68.63871930332715,
        "y": 94.59537249042043
      },
      {
        "x": 66.85558968691385,
        "y": 95.47357257393912
      },
      {
        "x": 65.03121161802059,
        "y": 96.26251571343892
      },
      {
        "x": 63.1700496554957,
        "y": 96.96027123285313
      },
      {
        "x": 61.27665837453914,
        "y": 97.56513160750183
      },
      {
        "x": 59.35567122089377,
        "y": 98.07561664269087
      },
      {
        "x": 57.411789172027234,
        "y": 98.49047709599645
      },
      {
        "x": 55.44976923305228,
        "y": 98.80869773437053
      },
      {
        "x": 53.474412795538164,
        "y": 99.02949981858629
      },
      {
        "x": 51.49055388770088,
        "y": 99.15234300894357
      },
      {
        "x": 49.50304734472608,
        "y": 99.17692668757053
      },
      {
        "x": 47.51675692817383,
        "y": 99.10319069408601
      },
      {
        "x": 45.53654342353903,
        "y": 98.93131547282218
      },
      {
        "x": 43.567252745094855,
        "y": 98.66172163124679
      },
      {
        "x": 41.613704077128396,
        "y": 98.29506891066647
      },
      {
        "x": 39.6806780805892,
        "y": 97.83225457172901
      },
      {
        "x": 37.772905194010825,
        "y": 97.27441119867623
      },
      {
        "x": 35.895054057335045,
        "y": 96.62290392772067
      },
      {
        "x": 34.0517200869676,
        "y": 95.87932710632839
      },
      {
        "x": 32.24741423002416,
        "y": 95.04550039158357
      },
      {
        "x": 30.486551925286886,
        "y": 94.1234642971828
      },
      {
        "x": 28.773442297885754,
        "y": 93.11547519995602
      },
      {
        "x": 27.11227761414735,
        "y": 92.02399981813437
      },
      {
        "x": 25.50712302241656,
        "y": 90.8517091748773
      },
      {
        "x": 23.961906604957502,
        "y": 89.60147206183134
      },
      {
        "x": 22.480409765277894,
        "y": 88.27634801871619
      },
      {
        "x": 21.066257974401058,
        "y": 86.87957984611836
      },
      {
        "x": 19.722911898730747,
        "y": 85.4145856698147
      },
      {
        "x": 18.45365893122063,
        "y": 83.88495057604584
      },
      {
        "x": 17.261605146572805,
        "y": 82.29441783820947
      },
      {
        "x": 16.1496677001525,
        "y": 80.64687975644298
      },
      {
        "x": 15.120567689220117,
        "y": 78.94636813251286
      },
      {
        "x": 14.176823493950224,
        "y": 77.19704440332009
      },
      {
        "x": 13.320744614533247,
        "y": 75.4031894571668
      },
      {
        "x": 12.554426019441522,
        "y": 73.56919315770513
      },
      {
        "x": 11.879743018690384,
        "y": 71.69954360120533
      },
      {
        "x": 11.298346674640278,
        "y": 69.79881613343207
      },
      {
        "x": 10.811659761570567,
        "y": 67.87166215300677
      },
      {
        "x": 10.420873283912364,
        "y": 65.9227977286555
      },
      {
        "x": 10.126943561661164,
        "y": 63.95699205819878
      },
      {
        "x": 9.930589890101551,
        "y": 61.97905579752514
      },
      {
        "x": 9.83229277957112,
        "y": 59.993829288110206
      },
      {
        "x": 9.83229277957112,
        "y": 58.00617071188981
      },
      {
        "x": 9.930589890101551,
        "y": 56.02094420247487
      },
      {
        "x": 10.126943561661157,
        "y": 54.04300794180124
      },
      {
        "x": 10.420873283912357,
        "y": 52.07720227134453
      },
      {
        "x": 10.811659761570567,
        "y": 50.12833784699325
      },
      {
        "x": 11.298346674640285,
        "y": 48.201183866567916
      },
      {
        "x": 11.879743018690377,
        "y": 46.30045639879468
      },
      {
        "x": 12.554426019441522,
        "y": 44.430806842294885
      },
      {
        "x": 13.320744614533247,
        "y": 42.596810542833204
      },
      {
        "x": 14.176823493950216,
        "y": 40.802955596679915
      },
      {
        "x": 15.120567689220117,
        "y": 39.053631867487155
      },
      {
        "x": 16.149667700152484,
        "y": 37.353120243557036
      },
      {
        "x": 17.261605146572798,
        "y": 35.70558216179053
      },
      {
        "x": 18.453658931220634,
        "y": 34.11504942395416
      },
      {
        "x": 19.72291189873074,
        "y": 32.585414330185316
      },
      {
        "x": 21.06625797440105,
        "y": 31.120420153881636
      },
      {
        "x": 22.480409765277887,
        "y": 29.723651981283812
      },
      {
        "x": 23.96190660495749,
        "y": 28.398527938168666
      },
      {
        "x": 25.50712302241655,
        "y": 27.1482908251227
      },
      {
        "x": 27.112277614147338,
        "y": 25.97600018186563
      },
      {
        "x": 28.773442297885758,
        "y": 24.88452480004397
      },
      {
        "x": 30.486551925286893,
        "y": 23.876535702817193
      },
      {
        "x": 32.24741423002418,
        "y": 22.95449960841642
      },
      {
        "x": 34.05172008696758,
        "y": 22.12067289367163
      },
      {
        "x": 35.89505405733503,
        "y": 21.377096072279336
      },
      {
        "x": 37.77290519401082,
        "y": 20.725588801323774
      },
      {
        "x": 39.680678080589196,
        "y": 20.167745428271004
      },
      {
        "x": 41.61370407712836,
        "y": 19.704931089333527
      },
      {
        "x": 43.56725274509486,
        "y": 19.3382783687532
      },
      {
        "x": 45.536543423539044,
        "y": 19.06868452717783
      },
      {
        "x": 47.516756928173834,
        "y": 18.896809305913983
      },
      {
        "x": 49.50304734472606,
        "y": 18.82307331242948
      },
      {
        "x": 51.49055388770087,
        "y": 18.847656991056425
      },
      {
        "x": 53.47441279553816,
        "y": 18.970500181413698
      },
      {
        "x": 55.44976923305227,
        "y": 19.191302265629474
      },
      {
        "x": 57.4117891720272,
        "y": 19.509522904003546
      },
      {
        "x": 59.35567122089378,
        "y": 19.924383357309132
      },
      {
        "x": 61.27665837453915,
        "y": 20.434868392498174
      },
      {
        "x": 63.17004965549568,
        "y": 21.039728767146855
      },
      {
        "x": 65.03121161802058,
        "y": 21.73748428656107
      },
      {
        "x": 66.85558968691383,
        "y": 22.526427426060877
      },
      {
        "x": 68.63871930332715,
        "y": 23.404627509579562
      },
      {
        "x": 70.37623685028748,
        "y": 24.36993543435146
      },
      {
        "x": 72.06389033119902,
        "y": 25.41998893012657
      },
      {
        "x": 73.69754977519148,
        "y": 26.55221834004176
      },
      {
        "x": 75.27321734385058,
        "y": 27.763852909001567
      },
      {
        "x": 76.78703711459889,
        "y": 29.051927564180335
      },
      {
        "x": 78.23530451678441,
        "y": 30.413290171052324
      },
      {
        "x": 79.61447539738568,
        "y": 31.84460924719295
      },
      {
        "x": 80.92117469414814,
        "y": 33.34238211497464
      },
      {
        "x": 82.15220469492706,
        "y": 34.90294347320591
      },
      {
        "x": 83.3045528630251,
        "y": 36.52247436673762
      },
      {
        "x": 84.37539920937418,
        "y": 38.19701153208614
      },
      {
        "x": 85.36212319352148,
        "y": 39.922457096203125
      },
      {
        "x": 86.26231013653097,
        "y": 41.69458860465772
      },
      {
        "x": 87.07375713010754,
        "y": 43.509069354690105
      },
      {
        "x": 87.79447842748245,
        "y": 45.361459007849696
      },
      {
        "x": 88.42271030286872,
        "y": 47.24722445624755
      },
      {
        "x": 88.95691536759354,
        "y": 49.16175091583089
      },
      {
        "x": 89.395786332346,
        "y": 51.10035321953316
      },
      {
        "x": 89.7382492063331,
        "y": 53.05828728266275
      },
      {
        "x": 89.98346592551515,
        "y": 55.03076171247317
      },
      {
        "x": 90.13083640348901,
        "y": 57.01294953350433
      },
      {
        "x": 90.18,
        "y": 58.99999999999999
      }
    ]
  },
  "m": {
    "controls": [
      {
        "x": 0,
        "y": 86.832
      },
      {
        "x": 0.04,
        "y": 86.31703200000001
      },
      {
        "x": 0.12,
        "y": 52.775999999999996
      },
      {
        "x": 0.2,
        "y": 28.008
      },
      {
        "x": 0.32,
        "y": 50.712
      },
      {
        "x": 0.5,
        "y": 76.512
      },
      {
        "x": 0.68,
        "y": 50.712
      },
      {
        "x": 0.8,
        "y": 28.008
      },
      {
        "x": 0.88,
        "y": 52.775999999999996
      },
      {
        "x": 0.96,
        "y": 86.31703200000001
      },
      {
        "x": 1,
        "y": 86.832
      }
    ],
    "fftBins": [
      {
        "re": 7309.715880636322,
        "im": 0
      },
      {
        "re": -40.999586451461894,
        "im": 1.9773072068574038e-13
      },
      {
        "re": 1575.0367769755171,
        "im": -7.105427357601002e-15
      },
      {
        "re": 543.7760778446147,
        "im": 6.661338147750939e-14
      },
      {
        "re": 95.56969364684699,
        "im": 1.8740564655672642e-13
      },
      {
        "re": -108.24608233438174,
        "im": 2.042810365310288e-13
      },
      {
        "re": -20.200595284776735,
        "im": 7.605027718682322e-15
      },
      {
        "re": 24.14215619446737,
        "im": -9.370282327836321e-14
      },
      {
        "re": -5.163094912350312,
        "im": -6.861178292183466e-14
      },
      {
        "re": -27.176742381513964,
        "im": 1.7319479184152442e-14
      },
      {
        "re": -29.697165832398674,
        "im": -3.8469227803261674e-14
      },
      {
        "re": -32.955078791821535,
        "im": 1.9539925233402755e-14
      },
      {
        "re": -20.5328235852096,
        "im": -6.8833827526759706e-15
      },
      {
        "re": -6.052221535891105,
        "im": -1.2673195826096162e-13
      },
      {
        "re": -5.684675289533717,
        "im": -1.720221187717641e-13
      },
      {
        "re": -8.866695217283599,
        "im": 1.84297022087776e-14
      },
      {
        "re": -7.077341632315226,
        "im": 1.1146639167236579e-13
      },
      {
        "re": -6.871515609412761,
        "im": -6.920158890366679e-14
      },
      {
        "re": -6.450798910241057,
        "im": -9.3119956190435e-14
      },
      {
        "re": -4.247489434410033,
        "im": -7.08461067588928e-14
      },
      {
        "re": -3.6798364270730217,
        "im": -1.9984014443252818e-14
      },
      {
        "re": -3.283767588216519,
        "im": 3.785860513971784e-14
      },
      {
        "re": -0.49115789281191213,
        "im": -3.916658664060435e-14
      },
      {
        "re": 1.005632995569469,
        "im": -1.426636586643326e-14
      },
      {
        "re": 0.3685175521064211,
        "im": 1.1773915176149785e-13
      },
      {
        "re": -0.008513438917436056,
        "im": -5.776715911176566e-14
      },
      {
        "re": -0.21623037911589227,
        "im": 1.9914625504213745e-14
      },
      {
        "re": -0.44855890250477204,
        "im": -4.6873963044369304e-14
      },
      {
        "re": 0.3681799047868926,
        "im": 1.2165268792330153e-13
      },
      {
        "re": 0.9691699145758587,
        "im": 1.119243586700236e-13
      },
      {
        "re": 0.5989267487517824,
        "im": 4.805669751029029e-13
      },
      {
        "re": 0.5214695089463135,
        "im": 1.44953493652622e-14
      },
      {
        "re": 0.7408510420577841,
        "im": 0
      },
      {
        "re": 0.4056963079758234,
        "im": 7.075937058509396e-15
      },
      {
        "re": 0.05971735672769041,
        "im": 1.6826817716975029e-15
      },
      {
        "re": -0.14692491566349886,
        "im": 2.4119595209981526e-14
      },
      {
        "re": -0.4669019742952855,
        "im": 9.006684287271582e-15
      },
      {
        "re": -0.39517612012904335,
        "im": 2.893605494103113e-14
      },
      {
        "re": 0.025315753425170173,
        "im": -2.2620794126737565e-14
      },
      {
        "re": 0.013877551112409153,
        "im": -1.3570308071697568e-14
      },
      {
        "re": -0.2274321445505766,
        "im": -7.588374373312944e-14
      },
      {
        "re": -0.29735679930002934,
        "im": -2.65898414397725e-14
      },
      {
        "re": -0.38280086148217357,
        "im": -1.8231943732516243e-14
      },
      {
        "re": -0.4195210517756991,
        "im": 2.0761170560490427e-14
      },
      {
        "re": -0.27335016690247693,
        "im": 1.2434497875801753e-14
      },
      {
        "re": -0.24095365740690378,
        "im": -1.0008660566995786e-13
      },
      {
        "re": -0.23751843638530357,
        "im": -4.2695014190741176e-14
      },
      {
        "re": -0.02444287271528678,
        "im": -2.6645352591003757e-14
      },
      {
        "re": 0.1421694094147088,
        "im": -1.143529715363912e-13
      },
      {
        "re": 0.09083297406420687,
        "im": -2.028238688112083e-14
      },
      {
        "re": 0.019497404357193382,
        "im": -4.2549297418759124e-14
      },
      {
        "re": -0.04479587556950637,
        "im": -1.5529244556944377e-14
      },
      {
        "re": -0.06871480398644536,
        "im": -4.729550084903167e-14
      },
      {
        "re": 0.053418930823458055,
        "im": -2.7533531010703882e-14
      },
      {
        "re": 0.17357035188046765,
        "im": -8.798517470154366e-14
      },
      {
        "re": 0.14024036390765993,
        "im": -1.7319479184152442e-14
      },
      {
        "re": 0.08734297823831305,
        "im": -3.552713678800502e-14
      },
      {
        "re": 0.07000620892466891,
        "im": 1.2878587085651816e-14
      },
      {
        "re": 0.025090377614644055,
        "im": -1.659783421814609e-14
      },
      {
        "re": -0.040096376743818496,
        "im": 4.263256414560601e-14
      },
      {
        "re": -0.10444678867578716,
        "im": 2.398081733190338e-14
      },
      {
        "re": -0.15638227418736506,
        "im": 4.440892098500626e-15
      },
      {
        "re": -0.12461874819723562,
        "im": 9.237055564881302e-14
      },
      {
        "re": -0.026677165676005643,
        "im": -2.3869795029440866e-14
      },
      {
        "re": 0.027828500827581593,
        "im": 0
      },
      {
        "re": -0.026677165676037617,
        "im": 2.0095036745715333e-14
      },
      {
        "re": -0.12461874819666718,
        "im": -9.237055564881302e-14
      },
      {
        "re": -0.15638227418713768,
        "im": -3.2862601528904634e-14
      },
      {
        "re": -0.10444678867573032,
        "im": -2.5757174171303632e-14
      },
      {
        "re": -0.04009637674387534,
        "im": -3.019806626980426e-14
      },
      {
        "re": 0.025090377614599646,
        "im": -5.717648576819556e-15
      },
      {
        "re": 0.07000620892467779,
        "im": -1.554312234475219e-14
      },
      {
        "re": 0.08734297823831172,
        "im": 3.5971225997855085e-14
      },
      {
        "re": 0.1402403639076546,
        "im": 1.7319479184152442e-14
      },
      {
        "re": 0.17357035188044279,
        "im": 8.942846463355636e-14
      },
      {
        "re": 0.053418930823443844,
        "im": 3.552713678800501e-14
      },
      {
        "re": -0.06871480398644714,
        "im": 4.6407322429331543e-14
      },
      {
        "re": -0.044795875569448196,
        "im": 1.226796442210798e-14
      },
      {
        "re": 0.019497404357285752,
        "im": -2.824129818890242e-15
      },
      {
        "re": 0.09083297406420332,
        "im": 2.1094237467877974e-14
      },
      {
        "re": 0.14216940941470657,
        "im": 1.1590728377086642e-13
      },
      {
        "re": -0.024442872715285446,
        "im": 2.050443148604586e-14
      },
      {
        "re": -0.23751843638534353,
        "im": -6.078471059822732e-15
      },
      {
        "re": -0.2409536574069544,
        "im": 9.080236562652999e-14
      },
      {
        "re": -0.2733501669024805,
        "im": -6.217248937900877e-15
      },
      {
        "re": -0.41952105177571686,
        "im": -9.43689570931383e-15
      },
      {
        "re": -0.38280086148218173,
        "im": 7.0811412289373266e-15
      },
      {
        "re": -0.29735679930002057,
        "im": 2.758904216193514e-14
      },
      {
        "re": -0.2274321445505757,
        "im": 7.654987754790453e-14
      },
      {
        "re": 0.013877551112404185,
        "im": 7.140989188858526e-15
      },
      {
        "re": 0.02531575342519364,
        "im": 1.6167622796103842e-14
      },
      {
        "re": -0.39517612012901493,
        "im": 1.4899539935164796e-14
      },
      {
        "re": -0.4669019742953116,
        "im": -3.4611202792689255e-14
      },
      {
        "re": -0.14692491566366173,
        "im": -2.1672941219463837e-13
      },
      {
        "re": 0.059717356727301496,
        "im": -5.231995392485089e-13
      },
      {
        "re": 0.4056963079758418,
        "im": 1.7139067942650854e-15
      },
      {
        "re": 0.7408510420577841,
        "im": 0
      },
      {
        "re": 0.5214695089462998,
        "im": -2.7281996106687245e-14
      },
      {
        "re": 0.598926748752303,
        "im": -1.0115866477811153e-13
      },
      {
        "re": 0.9691699145760369,
        "im": 3.805289416902724e-14
      },
      {
        "re": 0.36817990478691626,
        "im": -9.604816941788386e-14
      },
      {
        "re": -0.44855890250480046,
        "im": 1.014379552577438e-14
      },
      {
        "re": -0.21623037911588833,
        "im": -2.167710455580618e-14
      },
      {
        "re": -0.008513438917416155,
        "im": 5.35383369582032e-14
      },
      {
        "re": 0.36851755210642023,
        "im": -1.18849374786123e-13
      },
      {
        "re": 1.0056329955694903,
        "im": 1.326716514427062e-14
      },
      {
        "re": -0.49115789281192207,
        "im": 6.386211004461018e-14
      },
      {
        "re": -3.283767588216546,
        "im": -1.1879386363489175e-14
      },
      {
        "re": -3.6798364270730146,
        "im": 2.9753977059954195e-14
      },
      {
        "re": -4.2474894344099745,
        "im": 1.1862733018119798e-13
      },
      {
        "re": -6.450798910240905,
        "im": 2.459629722117995e-13
      },
      {
        "re": -6.871515609412761,
        "im": 6.128431095930864e-14
      },
      {
        "re": -7.077341632315228,
        "im": -1.1302070390684101e-13
      },
      {
        "re": -8.866695217283592,
        "im": -2.028238688112083e-14
      },
      {
        "re": -5.6846752895336605,
        "im": -5.720424134381119e-14
      },
      {
        "re": -6.052221535891108,
        "im": 3.46528361561127e-14
      },
      {
        "re": -20.53282358520962,
        "im": -1.1102230246251565e-15
      },
      {
        "re": -32.955078791821606,
        "im": -3.6415315207705135e-14
      },
      {
        "re": -29.697165832398742,
        "im": -8.049116928532385e-15
      },
      {
        "re": -27.17674238151396,
        "im": -2.0872192862952943e-14
      },
      {
        "re": -5.163094912350315,
        "im": 6.861178292183466e-14
      },
      {
        "re": 24.14215619446744,
        "im": 9.281464485866309e-14
      },
      {
        "re": -20.20059528477661,
        "im": 5.445643935786393e-14
      },
      {
        "re": -108.24608233438185,
        "im": -1.9539925233402755e-13
      },
      {
        "re": 95.56969364684706,
        "im": -1.9273471707492718e-13
      },
      {
        "re": 543.7760778446152,
        "im": 6.128431095930864e-14
      },
      {
        "re": 1575.0367769755187,
        "im": 3.197442310920451e-13
      },
      {
        "re": -40.999586451461894,
        "im": -2.1393997684526767e-13
      }
    ],
    "coefficients": [
      {
        "n": 0,
        "a": 114.21431063494254,
        "b": 0
      },
      {
        "n": 1,
        "a": -0.6406185383040921,
        "b": -3.0895425107146934e-15
      },
      {
        "n": 2,
        "a": 24.609949640242455,
        "b": 1.1102230246251565e-16
      },
      {
        "n": 3,
        "a": 8.496501216322105,
        "b": -1.0408340855860843e-15
      },
      {
        "n": 4,
        "a": 1.4932764632319842,
        "b": -2.9282132274488504e-15
      },
      {
        "n": 5,
        "a": -1.6913450364747147,
        "b": -3.191891195797325e-15
      },
      {
        "n": 6,
        "a": -0.3156343013246365,
        "b": -1.1882855810441129e-16
      },
      {
        "n": 7,
        "a": 0.37722119053855263,
        "b": 1.4641066137244252e-15
      },
      {
        "n": 8,
        "a": -0.08067335800547362,
        "b": 1.0720591081536666e-15
      },
      {
        "n": 9,
        "a": -0.4246365997111557,
        "b": -2.706168622523819e-16
      },
      {
        "n": 10,
        "a": -0.4640182161312293,
        "b": 6.010816844259637e-16
      },
      {
        "n": 11,
        "a": -0.5149231061222115,
        "b": -3.0531133177191805e-16
      },
      {
        "n": 12,
        "a": -0.3208253685189,
        "b": 1.0755285551056204e-16
      }
    ],
    "harmonicOrder": [
      2,
      5,
      4,
      12,
      9,
      6,
      10,
      8,
      3,
      11,
      7,
      1
    ],
    "displayHarmonicCount": 12,
    "compactHarmonicCount": 4,
    "restingPartialIndices": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10
    ],
    "restingLayers": [
      {
        "partialIndex": 0,
        "amplitudeScale": 1,
        "width": 0.914,
        "opacity": 0.5,
        "haloWidth": 3.83,
        "haloOpacity": 0.045
      },
      {
        "partialIndex": 1,
        "amplitudeScale": 1,
        "width": 0.875,
        "opacity": 0.472,
        "haloWidth": 3.584,
        "haloOpacity": 0.045
      },
      {
        "partialIndex": 2,
        "amplitudeScale": 1,
        "width": 0.85,
        "opacity": 0.444,
        "haloWidth": 3.577,
        "haloOpacity": 0.045
      },
      {
        "partialIndex": 3,
        "amplitudeScale": 1,
        "width": 0.821,
        "opacity": 0.416,
        "haloWidth": 3.508,
        "haloOpacity": 0.045
      },
      {
        "partialIndex": 4,
        "amplitudeScale": 1,
        "width": 0.797,
        "opacity": 0.388,
        "haloWidth": 3.518,
        "haloOpacity": 0.045
      },
      {
        "partialIndex": 5,
        "amplitudeScale": 1,
        "width": 0.771,
        "opacity": 0.36,
        "haloWidth": 3.51,
        "haloOpacity": 0.045
      },
      {
        "partialIndex": 6,
        "amplitudeScale": 1,
        "width": 0.747,
        "opacity": 0.332,
        "haloWidth": 3.523,
        "haloOpacity": 0.045
      },
      {
        "partialIndex": 7,
        "amplitudeScale": 1,
        "width": 0.721,
        "opacity": 0.304,
        "haloWidth": 3.492,
        "haloOpacity": 0.045
      },
      {
        "partialIndex": 8,
        "amplitudeScale": 1,
        "width": 0.71,
        "opacity": 0.276,
        "haloWidth": 3.731,
        "haloOpacity": 0.045
      },
      {
        "partialIndex": 9,
        "amplitudeScale": 1,
        "width": 0.673,
        "opacity": 0.248,
        "haloWidth": 3.531,
        "haloOpacity": 0.045
      },
      {
        "partialIndex": 10,
        "amplitudeScale": 1,
        "width": 0.648,
        "opacity": 0.22,
        "haloWidth": 3.522,
        "haloOpacity": 0.045
      }
    ],
    "target": [
      {
        "x": 2,
        "y": 86.832
      },
      {
        "x": 2.7559055118110236,
        "y": 87.13328935604328
      },
      {
        "x": 3.5118110236220472,
        "y": 87.7222119281404
      },
      {
        "x": 4.26771653543307,
        "y": 88.12634947224225
      },
      {
        "x": 5.0236220472440944,
        "y": 87.8732837442998
      },
      {
        "x": 5.7795275590551185,
        "y": 86.49059650026388
      },
      {
        "x": 6.535433070866142,
        "y": 84.05877694859093
      },
      {
        "x": 7.291338582677165,
        "y": 81.19857475611154
      },
      {
        "x": 8.047244094488189,
        "y": 78.00066743780852
      },
      {
        "x": 8.803149606299213,
        "y": 74.5521485465599
      },
      {
        "x": 9.559055118110237,
        "y": 70.94011163524377
      },
      {
        "x": 10.31496062992126,
        "y": 67.25165025673812
      },
      {
        "x": 11.070866141732283,
        "y": 63.57385796392106
      },
      {
        "x": 11.826771653543307,
        "y": 59.993828309670604
      },
      {
        "x": 12.58267716535433,
        "y": 56.59865484686482
      },
      {
        "x": 13.338582677165354,
        "y": 53.475431128381736
      },
      {
        "x": 14.094488188976378,
        "y": 50.51845535674358
      },
      {
        "x": 14.850393700787404,
        "y": 47.37206440406895
      },
      {
        "x": 15.606299212598426,
        "y": 44.12867294660593
      },
      {
        "x": 16.36220472440945,
        "y": 40.90015972755094
      },
      {
        "x": 17.118110236220474,
        "y": 37.79840349010048
      },
      {
        "x": 17.874015748031496,
        "y": 34.93528297745099
      },
      {
        "x": 18.62992125984252,
        "y": 32.42267693279895
      },
      {
        "x": 19.385826771653544,
        "y": 30.372464099340792
      },
      {
        "x": 20.141732283464567,
        "y": 28.896523220273014
      },
      {
        "x": 20.897637795275593,
        "y": 28.106733038792058
      },
      {
        "x": 21.653543307086615,
        "y": 28.036921833465712
      },
      {
        "x": 22.409448818897637,
        "y": 28.41065463636439
      },
      {
        "x": 23.16535433070866,
        "y": 29.151274556239397
      },
      {
        "x": 23.921259842519685,
        "y": 30.21259882355985
      },
      {
        "x": 24.677165354330707,
        "y": 31.548444668794854
      },
      {
        "x": 25.433070866141733,
        "y": 33.1126293224135
      },
      {
        "x": 26.188976377952756,
        "y": 34.85897001488491
      },
      {
        "x": 26.944881889763778,
        "y": 36.741283976678176
      },
      {
        "x": 27.700787401574807,
        "y": 38.71338843826244
      },
      {
        "x": 28.45669291338583,
        "y": 40.72910063010677
      },
      {
        "x": 29.212598425196852,
        "y": 42.742237782680284
      },
      {
        "x": 29.968503937007874,
        "y": 44.7066171264521
      },
      {
        "x": 30.7244094488189,
        "y": 46.576055891891315
      },
      {
        "x": 31.480314960629922,
        "y": 48.30437130946704
      },
      {
        "x": 32.23622047244095,
        "y": 49.845380609648366
      },
      {
        "x": 32.99212598425197,
        "y": 51.17497806611361
      },
      {
        "x": 33.74803149606299,
        "y": 52.506577971528515
      },
      {
        "x": 34.503937007874015,
        "y": 53.896273831377776
      },
      {
        "x": 35.25984251968504,
        "y": 55.33276615771779
      },
      {
        "x": 36.01574803149606,
        "y": 56.804755462604994
      },
      {
        "x": 36.77165354330709,
        "y": 58.300942258095795
      },
      {
        "x": 37.52755905511811,
        "y": 59.81002705624659
      },
      {
        "x": 38.28346456692913,
        "y": 61.320710369113826
      },
      {
        "x": 39.039370078740156,
        "y": 62.82169270875388
      },
      {
        "x": 39.795275590551185,
        "y": 64.30167458722319
      },
      {
        "x": 40.55118110236221,
        "y": 65.74935651657817
      },
      {
        "x": 41.30708661417323,
        "y": 67.15343900887524
      },
      {
        "x": 42.06299212598425,
        "y": 68.5026225761708
      },
      {
        "x": 42.818897637795274,
        "y": 69.78560773052126
      },
      {
        "x": 43.574803149606296,
        "y": 70.99109498398305
      },
      {
        "x": 44.33070866141732,
        "y": 72.10778484861257
      },
      {
        "x": 45.08661417322834,
        "y": 73.12437783646625
      },
      {
        "x": 45.84251968503937,
        "y": 74.02957445960048
      },
      {
        "x": 46.59842519685039,
        "y": 74.81207523007171
      },
      {
        "x": 47.354330708661415,
        "y": 75.46058065993634
      },
      {
        "x": 48.11023622047244,
        "y": 75.96379126125076
      },
      {
        "x": 48.86614173228347,
        "y": 76.31040754607145
      },
      {
        "x": 49.62204724409449,
        "y": 76.48913002645473
      },
      {
        "x": 50.37795275590551,
        "y": 76.48913002645473
      },
      {
        "x": 51.13385826771653,
        "y": 76.31040754607145
      },
      {
        "x": 51.889763779527556,
        "y": 75.96379126125078
      },
      {
        "x": 52.64566929133858,
        "y": 75.46058065993635
      },
      {
        "x": 53.401574803149614,
        "y": 74.8120752300717
      },
      {
        "x": 54.15748031496064,
        "y": 74.0295744596005
      },
      {
        "x": 54.91338582677166,
        "y": 73.12437783646624
      },
      {
        "x": 55.66929133858268,
        "y": 72.10778484861258
      },
      {
        "x": 56.425196850393704,
        "y": 70.99109498398305
      },
      {
        "x": 57.181102362204726,
        "y": 69.78560773052125
      },
      {
        "x": 57.93700787401575,
        "y": 68.50262257617081
      },
      {
        "x": 58.69291338582677,
        "y": 67.15343900887525
      },
      {
        "x": 59.4488188976378,
        "y": 65.74935651657817
      },
      {
        "x": 60.20472440944882,
        "y": 64.30167458722319
      },
      {
        "x": 60.960629921259844,
        "y": 62.82169270875388
      },
      {
        "x": 61.71653543307087,
        "y": 61.320710369113826
      },
      {
        "x": 62.47244094488189,
        "y": 59.8100270562466
      },
      {
        "x": 63.22834645669291,
        "y": 58.3009422580958
      },
      {
        "x": 63.98425196850393,
        "y": 56.80475546260501
      },
      {
        "x": 64.74015748031496,
        "y": 55.33276615771782
      },
      {
        "x": 65.49606299212599,
        "y": 53.896273831377776
      },
      {
        "x": 66.25196850393701,
        "y": 52.50657797152852
      },
      {
        "x": 67.00787401574803,
        "y": 51.17497806611362
      },
      {
        "x": 67.76377952755905,
        "y": 49.84538060964837
      },
      {
        "x": 68.51968503937007,
        "y": 48.30437130946705
      },
      {
        "x": 69.2755905511811,
        "y": 46.57605589189133
      },
      {
        "x": 70.03149606299212,
        "y": 44.70661712645212
      },
      {
        "x": 70.78740157480314,
        "y": 42.74223778268032
      },
      {
        "x": 71.54330708661418,
        "y": 40.72910063010678
      },
      {
        "x": 72.2992125984252,
        "y": 38.71338843826245
      },
      {
        "x": 73.05511811023622,
        "y": 36.7412839766782
      },
      {
        "x": 73.81102362204724,
        "y": 34.858970014884925
      },
      {
        "x": 74.56692913385827,
        "y": 33.11262932241352
      },
      {
        "x": 75.32283464566929,
        "y": 31.54844466879487
      },
      {
        "x": 76.07874015748031,
        "y": 30.212598823559865
      },
      {
        "x": 76.83464566929133,
        "y": 29.15127455623941
      },
      {
        "x": 77.59055118110237,
        "y": 28.41065463636439
      },
      {
        "x": 78.34645669291339,
        "y": 28.036921833465712
      },
      {
        "x": 79.10236220472441,
        "y": 28.106733038792058
      },
      {
        "x": 79.85826771653544,
        "y": 28.896523220273007
      },
      {
        "x": 80.61417322834646,
        "y": 30.37246409934078
      },
      {
        "x": 81.37007874015748,
        "y": 32.42267693279892
      },
      {
        "x": 82.1259842519685,
        "y": 34.935282977450974
      },
      {
        "x": 82.88188976377953,
        "y": 37.798403490100455
      },
      {
        "x": 83.63779527559055,
        "y": 40.900159727550964
      },
      {
        "x": 84.39370078740157,
        "y": 44.12867294660593
      },
      {
        "x": 85.14960629921259,
        "y": 47.372064404068965
      },
      {
        "x": 85.90551181102362,
        "y": 50.51845535674359
      },
      {
        "x": 86.66141732283464,
        "y": 53.47543112838174
      },
      {
        "x": 87.41732283464566,
        "y": 56.59865484686481
      },
      {
        "x": 88.17322834645668,
        "y": 59.99382830967058
      },
      {
        "x": 88.9291338582677,
        "y": 63.57385796392103
      },
      {
        "x": 89.68503937007874,
        "y": 67.25165025673815
      },
      {
        "x": 90.44094488188976,
        "y": 70.94011163524377
      },
      {
        "x": 91.19685039370079,
        "y": 74.55214854655993
      },
      {
        "x": 91.95275590551181,
        "y": 78.00066743780852
      },
      {
        "x": 92.70866141732283,
        "y": 81.19857475611154
      },
      {
        "x": 93.46456692913385,
        "y": 84.05877694859092
      },
      {
        "x": 94.22047244094487,
        "y": 86.49059650026389
      },
      {
        "x": 94.9763779527559,
        "y": 87.87328374429978
      },
      {
        "x": 95.73228346456693,
        "y": 88.12634947224227
      },
      {
        "x": 96.48818897637796,
        "y": 87.72221192814038
      },
      {
        "x": 97.24409448818898,
        "y": 87.13328935604328
      },
      {
        "x": 98,
        "y": 86.832
      }
    ],
    "components": [
      [
        {
          "x": 2,
          "y": 81.71710495771373
        },
        {
          "x": 2.7559055118110236,
          "y": 81.5967293062537
        },
        {
          "x": 3.5118110236220472,
          "y": 81.23677994855109
        },
        {
          "x": 4.26771653543307,
          "y": 80.64077815458486
        },
        {
          "x": 5.0236220472440944,
          "y": 79.81455442017227
        },
        {
          "x": 5.7795275590551185,
          "y": 78.76619142908433
        },
        {
          "x": 6.535433070866142,
          "y": 77.50594498272365
        },
        {
          "x": 7.291338582677165,
          "y": 76.04614367088404
        },
        {
          "x": 8.047244094488189,
          "y": 74.40106826508139
        },
        {
          "x": 8.803149606299213,
          "y": 72.5868120143121
        },
        {
          "x": 9.559055118110237,
          "y": 70.62112320992127
        },
        {
          "x": 10.31496062992126,
          "y": 68.52323155971855
        },
        {
          "x": 11.070866141732283,
          "y": 66.31366006986833
        },
        {
          "x": 11.826771653543307,
          "y": 64.01402427485371
        },
        {
          "x": 12.58267716535433,
          "y": 61.64682077958388
        },
        {
          "x": 13.338582677165354,
          "y": 59.23520718226988
        },
        {
          "x": 14.094488188976378,
          "y": 56.80277553101343
        },
        {
          "x": 14.850393700787404,
          "y": 54.373321530310655
        },
        {
          "x": 15.606299212598426,
          "y": 51.970611755250246
        },
        {
          "x": 16.36220472440945,
          "y": 49.61815115067525
        },
        {
          "x": 17.118110236220474,
          "y": 47.338953089790394
        },
        {
          "x": 17.874015748031496,
          "y": 45.15531424165803
        },
        {
          "x": 18.62992125984252,
          "y": 43.08859644998287
        },
        {
          "x": 19.385826771653544,
          "y": 41.15901775699527
        },
        {
          "x": 20.141732283464567,
          "y": 39.385454616780464
        },
        {
          "x": 20.897637795275593,
          "y": 37.785257232937354
        },
        {
          "x": 21.653543307086615,
          "y": 36.37407982706013
        },
        {
          "x": 22.409448818897637,
          "y": 35.165727498471725
        },
        {
          "x": 23.16535433070866,
          "y": 34.17202117333196
        },
        {
          "x": 23.921259842519685,
          "y": 33.402681964280006
        },
        {
          "x": 24.677165354330707,
          "y": 32.86523607188413
        },
        {
          "x": 25.433070866141733,
          "y": 32.564941158217344
        },
        {
          "x": 26.188976377952756,
          "y": 32.50473491282324
        },
        {
          "x": 26.944881889763778,
          "y": 32.685206314234236
        },
        {
          "x": 27.700787401574807,
          "y": 33.10458986818219
        },
        {
          "x": 28.45669291338583,
          "y": 33.758782878866725
        },
        {
          "x": 29.212598425196852,
          "y": 34.64138558432222
        },
        {
          "x": 29.968503937007874,
          "y": 35.74376376325179
        },
        {
          "x": 30.7244094488189,
          "y": 37.05513320086559
        },
        {
          "x": 31.480314960629922,
          "y": 38.562665187420976
        },
        {
          "x": 32.23622047244095,
          "y": 40.251612017406075
        },
        {
          "x": 32.99212598425197,
          "y": 42.10545126164791
        },
        {
          "x": 33.74803149606299,
          "y": 44.10604740097719
        },
        {
          "x": 34.503937007874015,
          "y": 46.23382924023906
        },
        {
          "x": 35.25984251968504,
          "y": 48.467981367064915
        },
        {
          "x": 36.01574803149606,
          "y": 50.78664778242522
        },
        {
          "x": 36.77165354330709,
          "y": 53.167145710910205
        },
        {
          "x": 37.52755905511811,
          "y": 55.58618749910086
        },
        {
          "x": 38.28346456692913,
          "y": 58.02010843126883
        },
        {
          "x": 39.039370078740156,
          "y": 60.445098233756966
        },
        {
          "x": 39.795275590551185,
          "y": 62.83743400330655
        },
        {
          "x": 40.55118110236221,
          "y": 65.17371228066791
        },
        {
          "x": 41.30708661417323,
          "y": 67.43107799919201
        },
        {
          "x": 42.06299212598425,
          "y": 69.58744806867155
        },
        {
          "x": 42.818897637795274,
          "y": 71.62172740718259
        },
        {
          "x": 43.574803149606296,
          "y": 73.5140153075555
        },
        {
          "x": 44.33070866141732,
          "y": 75.24580011965794
        },
        {
          "x": 45.08661417322834,
          "y": 76.80014034397504
        },
        {
          "x": 45.84251968503937,
          "y": 78.16183036490602
        },
        {
          "x": 46.59842519685039,
          "y": 79.31754920246084
        },
        {
          "x": 47.354330708661415,
          "y": 80.25599082716695
        },
        {
          "x": 48.11023622047244,
          "y": 80.9679747633564
        },
        {
          "x": 48.86614173228347,
          "y": 81.44653589883667
        },
        {
          "x": 49.62204724409449,
          "y": 81.68699262236608
        },
        {
          "x": 50.37795275590551,
          "y": 81.68699262236608
        },
        {
          "x": 51.13385826771653,
          "y": 81.44653589883669
        },
        {
          "x": 51.889763779527556,
          "y": 80.96797476335641
        },
        {
          "x": 52.64566929133858,
          "y": 80.25599082716697
        },
        {
          "x": 53.401574803149614,
          "y": 79.31754920246084
        },
        {
          "x": 54.15748031496064,
          "y": 78.16183036490602
        },
        {
          "x": 54.91338582677166,
          "y": 76.80014034397506
        },
        {
          "x": 55.66929133858268,
          "y": 75.24580011965796
        },
        {
          "x": 56.425196850393704,
          "y": 73.5140153075555
        },
        {
          "x": 57.181102362204726,
          "y": 71.6217274071826
        },
        {
          "x": 57.93700787401575,
          "y": 69.58744806867156
        },
        {
          "x": 58.69291338582677,
          "y": 67.43107799919204
        },
        {
          "x": 59.4488188976378,
          "y": 65.17371228066793
        },
        {
          "x": 60.20472440944882,
          "y": 62.83743400330654
        },
        {
          "x": 60.960629921259844,
          "y": 60.44509823375697
        },
        {
          "x": 61.71653543307087,
          "y": 58.02010843126884
        },
        {
          "x": 62.47244094488189,
          "y": 55.58618749910087
        },
        {
          "x": 63.22834645669291,
          "y": 53.16714571091022
        },
        {
          "x": 63.98425196850393,
          "y": 50.786647782425234
        },
        {
          "x": 64.74015748031496,
          "y": 48.46798136706493
        },
        {
          "x": 65.49606299212599,
          "y": 46.233829240239054
        },
        {
          "x": 66.25196850393701,
          "y": 44.10604740097718
        },
        {
          "x": 67.00787401574803,
          "y": 42.1054512616479
        },
        {
          "x": 67.76377952755905,
          "y": 40.2516120174061
        },
        {
          "x": 68.51968503937007,
          "y": 38.562665187421
        },
        {
          "x": 69.2755905511811,
          "y": 37.0551332008656
        },
        {
          "x": 70.03149606299212,
          "y": 35.7437637632518
        },
        {
          "x": 70.78740157480314,
          "y": 34.64138558432224
        },
        {
          "x": 71.54330708661418,
          "y": 33.75878287886672
        },
        {
          "x": 72.2992125984252,
          "y": 33.10458986818218
        },
        {
          "x": 73.05511811023622,
          "y": 32.685206314234236
        },
        {
          "x": 73.81102362204724,
          "y": 32.50473491282324
        },
        {
          "x": 74.56692913385827,
          "y": 32.564941158217344
        },
        {
          "x": 75.32283464566929,
          "y": 32.86523607188412
        },
        {
          "x": 76.07874015748031,
          "y": 33.402681964280006
        },
        {
          "x": 76.83464566929133,
          "y": 34.17202117333194
        },
        {
          "x": 77.59055118110237,
          "y": 35.165727498471725
        },
        {
          "x": 78.34645669291339,
          "y": 36.374079827060136
        },
        {
          "x": 79.10236220472441,
          "y": 37.78525723293734
        },
        {
          "x": 79.85826771653544,
          "y": 39.38545461678044
        },
        {
          "x": 80.61417322834646,
          "y": 41.15901775699526
        },
        {
          "x": 81.37007874015748,
          "y": 43.08859644998286
        },
        {
          "x": 82.1259842519685,
          "y": 45.15531424165803
        },
        {
          "x": 82.88188976377953,
          "y": 47.33895308979035
        },
        {
          "x": 83.63779527559055,
          "y": 49.61815115067527
        },
        {
          "x": 84.39370078740157,
          "y": 51.97061175525026
        },
        {
          "x": 85.14960629921259,
          "y": 54.37332153031063
        },
        {
          "x": 85.90551181102362,
          "y": 56.80277553101341
        },
        {
          "x": 86.66141732283464,
          "y": 59.23520718226987
        },
        {
          "x": 87.41732283464566,
          "y": 61.64682077958387
        },
        {
          "x": 88.17322834645668,
          "y": 64.01402427485367
        },
        {
          "x": 88.9291338582677,
          "y": 66.31366006986829
        },
        {
          "x": 89.68503937007874,
          "y": 68.52323155971857
        },
        {
          "x": 90.44094488188976,
          "y": 70.62112320992128
        },
        {
          "x": 91.19685039370079,
          "y": 72.58681201431209
        },
        {
          "x": 91.95275590551181,
          "y": 74.40106826508139
        },
        {
          "x": 92.70866141732283,
          "y": 76.04614367088404
        },
        {
          "x": 93.46456692913385,
          "y": 77.50594498272365
        },
        {
          "x": 94.22047244094487,
          "y": 78.76619142908432
        },
        {
          "x": 94.9763779527559,
          "y": 79.81455442017224
        },
        {
          "x": 95.73228346456693,
          "y": 80.64077815458486
        },
        {
          "x": 96.48818897637796,
          "y": 81.23677994855109
        },
        {
          "x": 97.24409448818898,
          "y": 81.59672930625369
        },
        {
          "x": 98,
          "y": 81.71710495771373
        }
      ],
      [
        {
          "x": 2,
          "y": 55.41581028099655
        },
        {
          "x": 2.7559055118110236,
          "y": 55.46729505257966
        },
        {
          "x": 3.5118110236220472,
          "y": 55.61861496051333
        },
        {
          "x": 4.26771653543307,
          "y": 55.860557607885134
        },
        {
          "x": 5.0236220472440944,
          "y": 56.178393460900935
        },
        {
          "x": 5.7795275590551185,
          "y": 56.5527725868852
        },
        {
          "x": 6.535433070866142,
          "y": 56.96090268341458
        },
        {
          "x": 7.291338582677165,
          "y": 57.37793667985255
        },
        {
          "x": 8.047244094488189,
          "y": 57.77848543372853
        },
        {
          "x": 8.803149606299213,
          "y": 58.13816342859674
        },
        {
          "x": 9.559055118110237,
          "y": 58.43507337087143
        },
        {
          "x": 10.31496062992126,
          "y": 58.65113930298141
        },
        {
          "x": 11.070866141732283,
          "y": 58.773207072554854
        },
        {
          "x": 11.826771653543307,
          "y": 58.79384516077258
        },
        {
          "x": 12.58267716535433,
          "y": 58.71179711524326
        },
        {
          "x": 13.338582677165354,
          "y": 58.53205804316482
        },
        {
          "x": 14.094488188976378,
          "y": 58.26557050784746
        },
        {
          "x": 14.850393700787404,
          "y": 57.928558342500466
        },
        {
          "x": 15.606299212598426,
          "y": 57.541538938879434
        },
        {
          "x": 16.36220472440945,
          "y": 57.12807414292822
        },
        {
          "x": 17.118110236220474,
          "y": 56.71333580322667
        },
        {
          "x": 17.874015748031496,
          "y": 56.3225733020425
        },
        {
          "x": 18.62992125984252,
          "y": 55.97957636611137
        },
        {
          "x": 19.385826771653544,
          "y": 55.705226741640324
        },
        {
          "x": 20.141732283464567,
          "y": 55.51622690795227
        },
        {
          "x": 20.897637795275593,
          "y": 55.424083226028365
        },
        {
          "x": 21.653543307086615,
          "y": 55.43440542814009
        },
        {
          "x": 22.409448818897637,
          "y": 55.54656509583173
        },
        {
          "x": 23.16535433070866,
          "y": 55.75373391820586
        },
        {
          "x": 23.921259842519685,
          "y": 56.043299401337165
        },
        {
          "x": 24.677165354330707,
          "y": 56.39763272031308
        },
        {
          "x": 25.433070866141733,
          "y": 56.79516196686138
        },
        {
          "x": 26.188976377952756,
          "y": 57.21168545295891
        },
        {
          "x": 26.944881889763778,
          "y": 57.62184511614264
        },
        {
          "x": 27.700787401574807,
          "y": 58.00067032520932
        },
        {
          "x": 28.45669291338583,
          "y": 58.325098098995326
        },
        {
          "x": 29.212598425196852,
          "y": 58.575377186906145
        },
        {
          "x": 29.968503937007874,
          "y": 58.736270530393426
        },
        {
          "x": 30.7244094488189,
          "y": 58.79798289919954
        },
        {
          "x": 31.480314960629922,
          "y": 58.75675722762433
        },
        {
          "x": 32.23622047244095,
          "y": 58.61510334570086
        },
        {
          "x": 32.99212598425197,
          "y": 58.38164518006434
        },
        {
          "x": 33.74803149606299,
          "y": 58.070595726966616
        },
        {
          "x": 34.503937007874015,
          "y": 57.70089176122116
        },
        {
          "x": 35.25984251968504,
          "y": 57.29504096023179
        },
        {
          "x": 36.01574803149606,
          "y": 56.877751630506225
        },
        {
          "x": 36.77165354330709,
          "y": 56.47442845927465
        },
        {
          "x": 37.52755905511811,
          "y": 56.109625870261645
        },
        {
          "x": 38.28346456692913,
          "y": 55.80555314373023
        },
        {
          "x": 39.039370078740156,
          "y": 55.58072230949396
        },
        {
          "x": 39.795275590551185,
          "y": 55.44882112953618
        },
        {
          "x": 40.55118110236221,
          "y": 55.417879783359275
        },
        {
          "x": 41.30708661417323,
          "y": 55.489781988485134
        },
        {
          "x": 42.06299212598425,
          "y": 55.660150319223085
        },
        {
          "x": 42.818897637795274,
          "y": 55.91861270552962
        },
        {
          "x": 43.574803149606296,
          "y": 56.24943388743725
        },
        {
          "x": 44.33070866141732,
          "y": 56.63247338193623
        },
        {
          "x": 45.08661417322834,
          "y": 57.044411641026244
        },
        {
          "x": 45.84251968503937,
          "y": 57.46016975210434
        },
        {
          "x": 46.59842519685039,
          "y": 57.85443624894564
        },
        {
          "x": 47.354330708661415,
          "y": 58.20320808061139
        },
        {
          "x": 48.11023622047244,
          "y": 58.48525192368066
        },
        {
          "x": 48.86614173228347,
          "y": 58.68339687272175
        },
        {
          "x": 49.62204724409449,
          "y": 58.78557980965794
        },
        {
          "x": 50.37795275590551,
          "y": 58.78557980965794
        },
        {
          "x": 51.13385826771653,
          "y": 58.68339687272175
        },
        {
          "x": 51.889763779527556,
          "y": 58.485251923680664
        },
        {
          "x": 52.64566929133858,
          "y": 58.20320808061139
        },
        {
          "x": 53.401574803149614,
          "y": 57.85443624894564
        },
        {
          "x": 54.15748031496064,
          "y": 57.46016975210434
        },
        {
          "x": 54.91338582677166,
          "y": 57.044411641026244
        },
        {
          "x": 55.66929133858268,
          "y": 56.63247338193624
        },
        {
          "x": 56.425196850393704,
          "y": 56.24943388743725
        },
        {
          "x": 57.181102362204726,
          "y": 55.918612705529625
        },
        {
          "x": 57.93700787401575,
          "y": 55.66015031922309
        },
        {
          "x": 58.69291338582677,
          "y": 55.489781988485134
        },
        {
          "x": 59.4488188976378,
          "y": 55.417879783359275
        },
        {
          "x": 60.20472440944882,
          "y": 55.44882112953618
        },
        {
          "x": 60.960629921259844,
          "y": 55.58072230949396
        },
        {
          "x": 61.71653543307087,
          "y": 55.80555314373023
        },
        {
          "x": 62.47244094488189,
          "y": 56.109625870261645
        },
        {
          "x": 63.22834645669291,
          "y": 56.47442845927465
        },
        {
          "x": 63.98425196850393,
          "y": 56.87775163050622
        },
        {
          "x": 64.74015748031496,
          "y": 57.29504096023178
        },
        {
          "x": 65.49606299212599,
          "y": 57.70089176122116
        },
        {
          "x": 66.25196850393701,
          "y": 58.070595726966616
        },
        {
          "x": 67.00787401574803,
          "y": 58.38164518006433
        },
        {
          "x": 67.76377952755905,
          "y": 58.61510334570086
        },
        {
          "x": 68.51968503937007,
          "y": 58.75675722762433
        },
        {
          "x": 69.2755905511811,
          "y": 58.79798289919954
        },
        {
          "x": 70.03149606299212,
          "y": 58.736270530393426
        },
        {
          "x": 70.78740157480314,
          "y": 58.575377186906145
        },
        {
          "x": 71.54330708661418,
          "y": 58.325098098995326
        },
        {
          "x": 72.2992125984252,
          "y": 58.00067032520933
        },
        {
          "x": 73.05511811023622,
          "y": 57.62184511614264
        },
        {
          "x": 73.81102362204724,
          "y": 57.21168545295891
        },
        {
          "x": 74.56692913385827,
          "y": 56.79516196686138
        },
        {
          "x": 75.32283464566929,
          "y": 56.397632720313084
        },
        {
          "x": 76.07874015748031,
          "y": 56.043299401337165
        },
        {
          "x": 76.83464566929133,
          "y": 55.75373391820587
        },
        {
          "x": 77.59055118110237,
          "y": 55.54656509583173
        },
        {
          "x": 78.34645669291339,
          "y": 55.43440542814009
        },
        {
          "x": 79.10236220472441,
          "y": 55.424083226028365
        },
        {
          "x": 79.85826771653544,
          "y": 55.51622690795227
        },
        {
          "x": 80.61417322834646,
          "y": 55.705226741640324
        },
        {
          "x": 81.37007874015748,
          "y": 55.97957636611137
        },
        {
          "x": 82.1259842519685,
          "y": 56.32257330204249
        },
        {
          "x": 82.88188976377953,
          "y": 56.71333580322666
        },
        {
          "x": 83.63779527559055,
          "y": 57.12807414292822
        },
        {
          "x": 84.39370078740157,
          "y": 57.541538938879434
        },
        {
          "x": 85.14960629921259,
          "y": 57.92855834250046
        },
        {
          "x": 85.90551181102362,
          "y": 58.26557050784746
        },
        {
          "x": 86.66141732283464,
          "y": 58.53205804316482
        },
        {
          "x": 87.41732283464566,
          "y": 58.71179711524326
        },
        {
          "x": 88.17322834645668,
          "y": 58.79384516077258
        },
        {
          "x": 88.9291338582677,
          "y": 58.773207072554854
        },
        {
          "x": 89.68503937007874,
          "y": 58.65113930298141
        },
        {
          "x": 90.44094488188976,
          "y": 58.43507337087143
        },
        {
          "x": 91.19685039370079,
          "y": 58.13816342859674
        },
        {
          "x": 91.95275590551181,
          "y": 57.778485433728534
        },
        {
          "x": 92.70866141732283,
          "y": 57.37793667985256
        },
        {
          "x": 93.46456692913385,
          "y": 56.96090268341459
        },
        {
          "x": 94.22047244094487,
          "y": 56.552772586885204
        },
        {
          "x": 94.9763779527559,
          "y": 56.17839346090094
        },
        {
          "x": 95.73228346456693,
          "y": 55.860557607885134
        },
        {
          "x": 96.48818897637796,
          "y": 55.618614960513334
        },
        {
          "x": 97.24409448818898,
          "y": 55.46729505257966
        },
        {
          "x": 98,
          "y": 55.41581028099655
        }
      ],
      [
        {
          "x": 2,
          "y": 58.60043178070325
        },
        {
          "x": 2.7559055118110236,
          "y": 58.57128673809368
        },
        {
          "x": 3.5118110236220472,
          "y": 58.48498928775421
        },
        {
          "x": 4.26771653543307,
          "y": 58.34490805288244
        },
        {
          "x": 5.0236220472440944,
          "y": 58.156511108091024
        },
        {
          "x": 5.7795275590551185,
          "y": 57.92715253297429
        },
        {
          "x": 6.535433070866142,
          "y": 57.665785345421725
        },
        {
          "x": 7.291338582677165,
          "y": 57.38261202033404
        },
        {
          "x": 8.047244094488189,
          "y": 57.08868623575247
        },
        {
          "x": 8.803149606299213,
          "y": 56.795481392251695
        },
        {
          "x": 9.559055118110237,
          "y": 56.51444274845268
        },
        {
          "x": 10.31496062992126,
          "y": 56.25654065505759
        },
        {
          "x": 11.070866141732283,
          "y": 56.03184232692739
        },
        {
          "x": 11.826771653543307,
          "y": 55.84911886909039
        },
        {
          "x": 12.58267716535433,
          "y": 55.715502896431445
        },
        {
          "x": 13.338582677165354,
          "y": 55.63621011188615
        },
        {
          "x": 14.094488188976378,
          "y": 55.61433571134235
        },
        {
          "x": 14.850393700787404,
          "y": 55.6507335625889
        },
        {
          "x": 15.606299212598426,
          "y": 55.74398287456454
        },
        {
          "x": 16.36220472440945,
          "y": 55.890443657973556
        },
        {
          "x": 17.118110236220474,
          "y": 56.084398812361776
        },
        {
          "x": 17.874015748031496,
          "y": 56.31827729328006
        },
        {
          "x": 18.62992125984252,
          "y": 56.58294964819947
        },
        {
          "x": 19.385826771653544,
          "y": 56.86808438492597
        },
        {
          "x": 20.141732283464567,
          "y": 57.16255126166446
        },
        {
          "x": 20.897637795275593,
          "y": 57.454855756294
        },
        {
          "x": 21.653543307086615,
          "y": 57.73358775533499
        },
        {
          "x": 22.409448818897637,
          "y": 57.987866948022834
        },
        {
          "x": 23.16535433070866,
          "y": 58.20776753951902
        },
        {
          "x": 23.921259842519685,
          "y": 58.384705704568375
        },
        {
          "x": 24.677165354330707,
          "y": 58.511774657339075
        },
        {
          "x": 25.433070866141733,
          "y": 58.58401425798556
        },
        {
          "x": 26.188976377952756,
          "y": 58.598604631835215
        },
        {
          "x": 26.944881889763778,
          "y": 58.554976243268875
        },
        {
          "x": 27.700787401574807,
          "y": 58.45483212755838
        },
        {
          "x": 28.45669291338583,
          "y": 58.30208141284089
        },
        {
          "x": 29.212598425196852,
          "y": 58.10268672720129
        },
        {
          "x": 29.968503937007874,
          "y": 57.86443144733126
        },
        {
          "x": 30.7244094488189,
          "y": 57.59661587421961
        },
        {
          "x": 31.480314960629922,
          "y": 57.309694195663475
        },
        {
          "x": 32.23622047244095,
          "y": 57.01486640677834
        },
        {
          "x": 32.99212598425197,
          "y": 56.72364111790009
        },
        {
          "x": 33.74803149606299,
          "y": 56.447386315684014
        },
        {
          "x": 34.503937007874015,
          "y": 56.1968856134528
        },
        {
          "x": 35.25984251968504,
          "y": 55.98191731257265
        },
        {
          "x": 36.01574803149606,
          "y": 55.810872706207434
        },
        {
          "x": 36.77165354330709,
          "y": 55.690428524973896
        },
        {
          "x": 37.52755905511811,
          "y": 55.625286310589935
        },
        {
          "x": 38.28346456692913,
          "y": 55.617988891072535
        },
        {
          "x": 39.039370078740156,
          "y": 55.66882112138059
        },
        {
          "x": 39.795275590551185,
          "y": 55.77579876409423
        },
        {
          "x": 40.55118110236221,
          "y": 55.934745944173685
        },
        {
          "x": 41.30708661417323,
          "y": 56.139458154348986
        },
        {
          "x": 42.06299212598425,
          "y": 56.38194444822118
        },
        {
          "x": 42.818897637795274,
          "y": 56.652739367060875
        },
        {
          "x": 43.574803149606296,
          "y": 56.94127242423366
        },
        {
          "x": 44.33070866141732,
          "y": 57.236280724418236
        },
        {
          "x": 45.08661417322834,
          "y": 57.5262486110155
        },
        {
          "x": 45.84251968503937,
          "y": 57.79985718010059
        },
        {
          "x": 46.59842519685039,
          "y": 58.04642611412927
        },
        {
          "x": 47.354330708661415,
          "y": 58.256330588408446
        },
        {
          "x": 48.11023622047244,
          "y": 58.42137697637608
        },
        {
          "x": 48.86614173228347,
          "y": 58.53512268802515
        },
        {
          "x": 49.62204724409449,
          "y": 58.593127656570566
        },
        {
          "x": 50.37795275590551,
          "y": 58.593127656570566
        },
        {
          "x": 51.13385826771653,
          "y": 58.53512268802515
        },
        {
          "x": 51.889763779527556,
          "y": 58.42137697637608
        },
        {
          "x": 52.64566929133858,
          "y": 58.256330588408446
        },
        {
          "x": 53.401574803149614,
          "y": 58.04642611412927
        },
        {
          "x": 54.15748031496064,
          "y": 57.79985718010059
        },
        {
          "x": 54.91338582677166,
          "y": 57.5262486110155
        },
        {
          "x": 55.66929133858268,
          "y": 57.236280724418236
        },
        {
          "x": 56.425196850393704,
          "y": 56.94127242423366
        },
        {
          "x": 57.181102362204726,
          "y": 56.652739367060875
        },
        {
          "x": 57.93700787401575,
          "y": 56.38194444822118
        },
        {
          "x": 58.69291338582677,
          "y": 56.13945815434899
        },
        {
          "x": 59.4488188976378,
          "y": 55.934745944173685
        },
        {
          "x": 60.20472440944882,
          "y": 55.77579876409423
        },
        {
          "x": 60.960629921259844,
          "y": 55.66882112138059
        },
        {
          "x": 61.71653543307087,
          "y": 55.617988891072535
        },
        {
          "x": 62.47244094488189,
          "y": 55.625286310589935
        },
        {
          "x": 63.22834645669291,
          "y": 55.690428524973896
        },
        {
          "x": 63.98425196850393,
          "y": 55.810872706207434
        },
        {
          "x": 64.74015748031496,
          "y": 55.98191731257265
        },
        {
          "x": 65.49606299212599,
          "y": 56.19688561345281
        },
        {
          "x": 66.25196850393701,
          "y": 56.447386315684014
        },
        {
          "x": 67.00787401574803,
          "y": 56.72364111790009
        },
        {
          "x": 67.76377952755905,
          "y": 57.01486640677833
        },
        {
          "x": 68.51968503937007,
          "y": 57.30969419566347
        },
        {
          "x": 69.2755905511811,
          "y": 57.5966158742196
        },
        {
          "x": 70.03149606299212,
          "y": 57.86443144733126
        },
        {
          "x": 70.78740157480314,
          "y": 58.10268672720128
        },
        {
          "x": 71.54330708661418,
          "y": 58.30208141284089
        },
        {
          "x": 72.2992125984252,
          "y": 58.45483212755838
        },
        {
          "x": 73.05511811023622,
          "y": 58.554976243268875
        },
        {
          "x": 73.81102362204724,
          "y": 58.598604631835215
        },
        {
          "x": 74.56692913385827,
          "y": 58.58401425798556
        },
        {
          "x": 75.32283464566929,
          "y": 58.511774657339075
        },
        {
          "x": 76.07874015748031,
          "y": 58.384705704568375
        },
        {
          "x": 76.83464566929133,
          "y": 58.207767539519025
        },
        {
          "x": 77.59055118110237,
          "y": 57.98786694802283
        },
        {
          "x": 78.34645669291339,
          "y": 57.73358775533499
        },
        {
          "x": 79.10236220472441,
          "y": 57.45485575629401
        },
        {
          "x": 79.85826771653544,
          "y": 57.16255126166447
        },
        {
          "x": 80.61417322834646,
          "y": 56.86808438492597
        },
        {
          "x": 81.37007874015748,
          "y": 56.58294964819947
        },
        {
          "x": 82.1259842519685,
          "y": 56.31827729328006
        },
        {
          "x": 82.88188976377953,
          "y": 56.08439881236178
        },
        {
          "x": 83.63779527559055,
          "y": 55.890443657973556
        },
        {
          "x": 84.39370078740157,
          "y": 55.74398287456454
        },
        {
          "x": 85.14960629921259,
          "y": 55.6507335625889
        },
        {
          "x": 85.90551181102362,
          "y": 55.61433571134235
        },
        {
          "x": 86.66141732283464,
          "y": 55.63621011188615
        },
        {
          "x": 87.41732283464566,
          "y": 55.715502896431445
        },
        {
          "x": 88.17322834645668,
          "y": 55.84911886909039
        },
        {
          "x": 88.9291338582677,
          "y": 56.03184232692739
        },
        {
          "x": 89.68503937007874,
          "y": 56.25654065505759
        },
        {
          "x": 90.44094488188976,
          "y": 56.51444274845269
        },
        {
          "x": 91.19685039370079,
          "y": 56.79548139225169
        },
        {
          "x": 91.95275590551181,
          "y": 57.08868623575247
        },
        {
          "x": 92.70866141732283,
          "y": 57.38261202033403
        },
        {
          "x": 93.46456692913385,
          "y": 57.665785345421725
        },
        {
          "x": 94.22047244094487,
          "y": 57.92715253297428
        },
        {
          "x": 94.9763779527559,
          "y": 58.156511108091024
        },
        {
          "x": 95.73228346456693,
          "y": 58.34490805288244
        },
        {
          "x": 96.48818897637796,
          "y": 58.4849892877542
        },
        {
          "x": 97.24409448818898,
          "y": 58.57128673809368
        },
        {
          "x": 98,
          "y": 58.60043178070325
        }
      ],
      [
        {
          "x": 2,
          "y": 56.78632994895237
        },
        {
          "x": 2.7559055118110236,
          "y": 56.84122835267193
        },
        {
          "x": 3.5118110236220472,
          "y": 56.987135556230925
        },
        {
          "x": 4.26771653543307,
          "y": 57.17411740009854
        },
        {
          "x": 5.0236220472440944,
          "y": 57.338182655649305
        },
        {
          "x": 5.7795275590551185,
          "y": 57.4231828912479
        },
        {
          "x": 6.535433070866142,
          "y": 57.400028279791854
        },
        {
          "x": 7.291338582677165,
          "y": 57.276643077480436
        },
        {
          "x": 8.047244094488189,
          "y": 57.09525368729907
        },
        {
          "x": 8.803149606299213,
          "y": 56.91793741952152
        },
        {
          "x": 9.559055118110237,
          "y": 56.805377630326504
        },
        {
          "x": 10.31496062992126,
          "y": 56.796095916546236
        },
        {
          "x": 11.070866141732283,
          "y": 56.89326878054193
        },
        {
          "x": 11.826771653543307,
          "y": 57.0636405284584
        },
        {
          "x": 12.58267716535433,
          "y": 57.24890444320088
        },
        {
          "x": 13.338582677165354,
          "y": 57.38565722699929
        },
        {
          "x": 14.094488188976378,
          "y": 57.42709765855746
        },
        {
          "x": 14.850393700787404,
          "y": 57.359043483195855
        },
        {
          "x": 15.606299212598426,
          "y": 57.204785038652126
        },
        {
          "x": 16.36220472440945,
          "y": 57.017114548962724
        },
        {
          "x": 17.118110236220474,
          "y": 56.86025891960448
        },
        {
          "x": 17.874015748031496,
          "y": 56.78789921517619
        },
        {
          "x": 18.62992125984252,
          "y": 56.82479926457997
        },
        {
          "x": 19.385826771653544,
          "y": 56.95833067861586
        },
        {
          "x": 20.141732283464567,
          "y": 57.142794692807534
        },
        {
          "x": 20.897637795275593,
          "y": 57.315061761199345
        },
        {
          "x": 21.653543307086615,
          "y": 57.416176526789314
        },
        {
          "x": 22.409448818897637,
          "y": 57.411534249628154
        },
        {
          "x": 23.16535433070866,
          "y": 57.3027236669591
        },
        {
          "x": 23.921259842519685,
          "y": 57.12698327599891
        },
        {
          "x": 24.677165354330707,
          "y": 56.94445711696052
        },
        {
          "x": 25.433070866141733,
          "y": 56.81761153915123
        },
        {
          "x": 26.188976377952756,
          "y": 56.78985719786157
        },
        {
          "x": 26.944881889763778,
          "y": 56.870692525463795
        },
        {
          "x": 27.700787401574807,
          "y": 57.03245306094601
        },
        {
          "x": 28.45669291338583,
          "y": 57.21977912234918
        },
        {
          "x": 29.212598425196852,
          "y": 57.368561678685005
        },
        {
          "x": 29.968503937007874,
          "y": 57.42788253179564
        },
        {
          "x": 30.7244094488189,
          "y": 57.37744016900402
        },
        {
          "x": 31.480314960629922,
          "y": 57.234497596723166
        },
        {
          "x": 32.23622047244095,
          "y": 57.047974381868976
        },
        {
          "x": 32.99212598425197,
          "y": 56.88170479539957
        },
        {
          "x": 33.74803149606299,
          "y": 56.79259166221575
        },
        {
          "x": 34.503937007874015,
          "y": 56.81113237586731
        },
        {
          "x": 35.25984251968504,
          "y": 56.930981705065406
        },
        {
          "x": 36.01574803149606,
          "y": 57.11112333685317
        },
        {
          "x": 36.77165354330709,
          "y": 57.289906984195994
        },
        {
          "x": 37.52755905511811,
          "y": 57.40614710621478
        },
        {
          "x": 38.28346456692913,
          "y": 57.42006257726813
        },
        {
          "x": 39.039370078740156,
          "y": 57.326891073532586
        },
        {
          "x": 39.795275590551185,
          "y": 57.158518894092566
        },
        {
          "x": 40.55118110236221,
          "y": 56.972568439101245
        },
        {
          "x": 41.30708661417323,
          "y": 56.83267796258496
        },
        {
          "x": 42.06299212598425,
          "y": 56.78672250567134
        },
        {
          "x": 42.818897637795274,
          "y": 56.85042951060355
        },
        {
          "x": 43.574803149606296,
          "y": 57.00199638182825
        },
        {
          "x": 44.33070866141732,
          "y": 57.18955203866739
        },
        {
          "x": 45.08661417322834,
          "y": 57.34890887515591
        },
        {
          "x": 45.84251968503937,
          "y": 57.42552983279742
        },
        {
          "x": 46.59842519685039,
          "y": 57.39319274415298
        },
        {
          "x": 47.354330708661415,
          "y": 57.26296440581483
        },
        {
          "x": 48.11023622047244,
          "y": 57.07941316302838
        },
        {
          "x": 48.86614173228347,
          "y": 56.905356181881444
        },
        {
          "x": 49.62204724409449,
          "y": 56.800361385355465
        },
        {
          "x": 50.37795275590551,
          "y": 56.800361385355465
        },
        {
          "x": 51.13385826771653,
          "y": 56.905356181881444
        },
        {
          "x": 51.889763779527556,
          "y": 57.07941316302838
        },
        {
          "x": 52.64566929133858,
          "y": 57.26296440581483
        },
        {
          "x": 53.401574803149614,
          "y": 57.39319274415298
        },
        {
          "x": 54.15748031496064,
          "y": 57.42552983279742
        },
        {
          "x": 54.91338582677166,
          "y": 57.34890887515591
        },
        {
          "x": 55.66929133858268,
          "y": 57.18955203866739
        },
        {
          "x": 56.425196850393704,
          "y": 57.00199638182825
        },
        {
          "x": 57.181102362204726,
          "y": 56.85042951060355
        },
        {
          "x": 57.93700787401575,
          "y": 56.78672250567134
        },
        {
          "x": 58.69291338582677,
          "y": 56.83267796258496
        },
        {
          "x": 59.4488188976378,
          "y": 56.972568439101245
        },
        {
          "x": 60.20472440944882,
          "y": 57.158518894092566
        },
        {
          "x": 60.960629921259844,
          "y": 57.326891073532586
        },
        {
          "x": 61.71653543307087,
          "y": 57.42006257726813
        },
        {
          "x": 62.47244094488189,
          "y": 57.40614710621478
        },
        {
          "x": 63.22834645669291,
          "y": 57.289906984195994
        },
        {
          "x": 63.98425196850393,
          "y": 57.11112333685317
        },
        {
          "x": 64.74015748031496,
          "y": 56.930981705065406
        },
        {
          "x": 65.49606299212599,
          "y": 56.81113237586731
        },
        {
          "x": 66.25196850393701,
          "y": 56.79259166221575
        },
        {
          "x": 67.00787401574803,
          "y": 56.88170479539957
        },
        {
          "x": 67.76377952755905,
          "y": 57.047974381868976
        },
        {
          "x": 68.51968503937007,
          "y": 57.23449759672316
        },
        {
          "x": 69.2755905511811,
          "y": 57.37744016900401
        },
        {
          "x": 70.03149606299212,
          "y": 57.42788253179564
        },
        {
          "x": 70.78740157480314,
          "y": 57.368561678685005
        },
        {
          "x": 71.54330708661418,
          "y": 57.21977912234918
        },
        {
          "x": 72.2992125984252,
          "y": 57.03245306094601
        },
        {
          "x": 73.05511811023622,
          "y": 56.870692525463795
        },
        {
          "x": 73.81102362204724,
          "y": 56.78985719786157
        },
        {
          "x": 74.56692913385827,
          "y": 56.81761153915123
        },
        {
          "x": 75.32283464566929,
          "y": 56.94445711696052
        },
        {
          "x": 76.07874015748031,
          "y": 57.12698327599891
        },
        {
          "x": 76.83464566929133,
          "y": 57.3027236669591
        },
        {
          "x": 77.59055118110237,
          "y": 57.411534249628154
        },
        {
          "x": 78.34645669291339,
          "y": 57.416176526789314
        },
        {
          "x": 79.10236220472441,
          "y": 57.315061761199345
        },
        {
          "x": 79.85826771653544,
          "y": 57.142794692807534
        },
        {
          "x": 80.61417322834646,
          "y": 56.95833067861586
        },
        {
          "x": 81.37007874015748,
          "y": 56.82479926457997
        },
        {
          "x": 82.1259842519685,
          "y": 56.78789921517619
        },
        {
          "x": 82.88188976377953,
          "y": 56.86025891960448
        },
        {
          "x": 83.63779527559055,
          "y": 57.017114548962724
        },
        {
          "x": 84.39370078740157,
          "y": 57.204785038652126
        },
        {
          "x": 85.14960629921259,
          "y": 57.35904348319586
        },
        {
          "x": 85.90551181102362,
          "y": 57.42709765855746
        },
        {
          "x": 86.66141732283464,
          "y": 57.38565722699929
        },
        {
          "x": 87.41732283464566,
          "y": 57.24890444320088
        },
        {
          "x": 88.17322834645668,
          "y": 57.0636405284584
        },
        {
          "x": 88.9291338582677,
          "y": 56.89326878054194
        },
        {
          "x": 89.68503937007874,
          "y": 56.796095916546236
        },
        {
          "x": 90.44094488188976,
          "y": 56.805377630326504
        },
        {
          "x": 91.19685039370079,
          "y": 56.91793741952152
        },
        {
          "x": 91.95275590551181,
          "y": 57.09525368729907
        },
        {
          "x": 92.70866141732283,
          "y": 57.276643077480436
        },
        {
          "x": 93.46456692913385,
          "y": 57.400028279791854
        },
        {
          "x": 94.22047244094487,
          "y": 57.4231828912479
        },
        {
          "x": 94.9763779527559,
          "y": 57.338182655649305
        },
        {
          "x": 95.73228346456693,
          "y": 57.17411740009854
        },
        {
          "x": 96.48818897637796,
          "y": 56.987135556230925
        },
        {
          "x": 97.24409448818898,
          "y": 56.84122835267193
        },
        {
          "x": 98,
          "y": 56.78632994895237
        }
      ],
      [
        {
          "x": 2,
          "y": 56.68251871776011
        },
        {
          "x": 2.7559055118110236,
          "y": 56.723922264359075
        },
        {
          "x": 3.5118110236220472,
          "y": 56.84005892432409
        },
        {
          "x": 4.26771653543307,
          "y": 57.008281240436524
        },
        {
          "x": 5.0236220472440944,
          "y": 57.195784689916756
        },
        {
          "x": 5.7795275590551185,
          "y": 57.366004794746146
        },
        {
          "x": 6.535433070866142,
          "y": 57.48574744943696
        },
        {
          "x": 7.291338582677165,
          "y": 57.53166200269467
        },
        {
          "x": 8.047244094488189,
          "y": 57.494794796984
        },
        {
          "x": 8.803149606299213,
          "y": 57.38233519408233
        },
        {
          "x": 9.559055118110237,
          "y": 57.216213599481804
        },
        {
          "x": 10.31496062992126,
          "y": 57.02882488064236
        },
        {
          "x": 11.070866141732283,
          "y": 56.85671114230892
        },
        {
          "x": 11.826771653543307,
          "y": 56.733435761685705
        },
        {
          "x": 12.58267716535433,
          "y": 56.68303829621835
        },
        {
          "x": 13.338582677165354,
          "y": 56.71534660253234
        },
        {
          "x": 14.094488188976378,
          "y": 56.824060335971026
        },
        {
          "x": 14.850393700787404,
          "y": 56.987979561665675
        },
        {
          "x": 15.606299212598426,
          "y": 57.175138889425575
        },
        {
          "x": 16.36220472440945,
          "y": 57.349040947363285
        },
        {
          "x": 17.118110236220474,
          "y": 57.47577362350175
        },
        {
          "x": 17.874015748031496,
          "y": 57.53062316370071
        },
        {
          "x": 18.62992125984252,
          "y": 57.502893525767355
        },
        {
          "x": 19.385826771653544,
          "y": 57.39799218214814
        },
        {
          "x": 20.141732283464567,
          "y": 57.236375625155716
        },
        {
          "x": 20.897637795275593,
          "y": 57.04956020855305
        },
        {
          "x": 21.653543307086615,
          "y": 56.87397623915767
        },
        {
          "x": 22.409448818897637,
          "y": 56.74386381339008
        },
        {
          "x": 23.16535433070866,
          "y": 56.68459576009751
        },
        {
          "x": 23.921259842519685,
          "y": 56.70772976228703
        },
        {
          "x": 24.677165354330707,
          "y": 56.808754528476335
        },
        {
          "x": 25.433070866141733,
          "y": 56.96796952593974
        },
        {
          "x": 26.188976377952756,
          "y": 57.15432672174172
        },
        {
          "x": 26.944881889763778,
          "y": 57.33148516531095
        },
        {
          "x": 27.700787401574807,
          "y": 57.46489772680178
        },
        {
          "x": 28.45669291338583,
          "y": 57.5285480279259
        },
        {
          "x": 29.212598425196852,
          "y": 57.51002381684057
        },
        {
          "x": 29.968503937007874,
          "y": 57.412937443670124
        },
        {
          "x": 30.7244094488189,
          "y": 57.25622142708309
        },
        {
          "x": 31.480314960629922,
          "y": 57.07043648134657
        },
        {
          "x": 32.23622047244095,
          "y": 56.891811964285225
        },
        {
          "x": 32.99212598425197,
          "y": 56.755180900282234
        },
        {
          "x": 33.74803149606299,
          "y": 56.687187298022494
        },
        {
          "x": 34.503937007874015,
          "y": 56.70109038330758
        },
        {
          "x": 35.25984251968504,
          "y": 56.79417895771578
        },
        {
          "x": 36.01574803149606,
          "y": 56.94830010116925
        },
        {
          "x": 36.77165354330709,
          "y": 57.13339911772703
        },
        {
          "x": 37.52755905511811,
          "y": 57.31338041052966
        },
        {
          "x": 38.28346456692913,
          "y": 57.45314637447875
        },
        {
          "x": 39.039370078740156,
          "y": 57.52544167357521
        },
        {
          "x": 39.795275590551185,
          "y": 57.51616822118657
        },
        {
          "x": 40.55118110236221,
          "y": 57.42713440508894
        },
        {
          "x": 41.30708661417323,
          "y": 57.27570243926101
        },
        {
          "x": 42.06299212598425,
          "y": 57.09140261128512
        },
        {
          "x": 42.818897637795274,
          "y": 56.910174670683425
        },
        {
          "x": 43.574803149606296,
          "y": 56.767359327554125
        },
        {
          "x": 44.33070866141732,
          "y": 56.690806568065724
        },
        {
          "x": 45.08661417322834,
          "y": 56.69544471326693
        },
        {
          "x": 45.84251968503937,
          "y": 56.78036929255345
        },
        {
          "x": 46.59842519685039,
          "y": 56.929019421732654
        },
        {
          "x": 47.354330708661415,
          "y": 57.112407290735405
        },
        {
          "x": 48.11023622047244,
          "y": 57.29477098838822
        },
        {
          "x": 48.86614173228347,
          "y": 57.440548324060984
        },
        {
          "x": 49.62204724409449,
          "y": 57.52131170241827
        },
        {
          "x": 50.37795275590551,
          "y": 57.52131170241827
        },
        {
          "x": 51.13385826771653,
          "y": 57.440548324060984
        },
        {
          "x": 51.889763779527556,
          "y": 57.29477098838822
        },
        {
          "x": 52.64566929133858,
          "y": 57.112407290735405
        },
        {
          "x": 53.401574803149614,
          "y": 56.929019421732654
        },
        {
          "x": 54.15748031496064,
          "y": 56.78036929255345
        },
        {
          "x": 54.91338582677166,
          "y": 56.69544471326693
        },
        {
          "x": 55.66929133858268,
          "y": 56.690806568065724
        },
        {
          "x": 56.425196850393704,
          "y": 56.767359327554125
        },
        {
          "x": 57.181102362204726,
          "y": 56.910174670683425
        },
        {
          "x": 57.93700787401575,
          "y": 57.09140261128511
        },
        {
          "x": 58.69291338582677,
          "y": 57.27570243926101
        },
        {
          "x": 59.4488188976378,
          "y": 57.42713440508894
        },
        {
          "x": 60.20472440944882,
          "y": 57.51616822118657
        },
        {
          "x": 60.960629921259844,
          "y": 57.52544167357521
        },
        {
          "x": 61.71653543307087,
          "y": 57.45314637447875
        },
        {
          "x": 62.47244094488189,
          "y": 57.31338041052967
        },
        {
          "x": 63.22834645669291,
          "y": 57.13339911772703
        },
        {
          "x": 63.98425196850393,
          "y": 56.94830010116925
        },
        {
          "x": 64.74015748031496,
          "y": 56.79417895771578
        },
        {
          "x": 65.49606299212599,
          "y": 56.70109038330758
        },
        {
          "x": 66.25196850393701,
          "y": 56.687187298022494
        },
        {
          "x": 67.00787401574803,
          "y": 56.755180900282234
        },
        {
          "x": 67.76377952755905,
          "y": 56.891811964285225
        },
        {
          "x": 68.51968503937007,
          "y": 57.070436481346576
        },
        {
          "x": 69.2755905511811,
          "y": 57.256221427083084
        },
        {
          "x": 70.03149606299212,
          "y": 57.412937443670124
        },
        {
          "x": 70.78740157480314,
          "y": 57.51002381684057
        },
        {
          "x": 71.54330708661418,
          "y": 57.5285480279259
        },
        {
          "x": 72.2992125984252,
          "y": 57.46489772680178
        },
        {
          "x": 73.05511811023622,
          "y": 57.33148516531095
        },
        {
          "x": 73.81102362204724,
          "y": 57.15432672174172
        },
        {
          "x": 74.56692913385827,
          "y": 56.96796952593974
        },
        {
          "x": 75.32283464566929,
          "y": 56.808754528476335
        },
        {
          "x": 76.07874015748031,
          "y": 56.70772976228703
        },
        {
          "x": 76.83464566929133,
          "y": 56.68459576009751
        },
        {
          "x": 77.59055118110237,
          "y": 56.74386381339008
        },
        {
          "x": 78.34645669291339,
          "y": 56.87397623915767
        },
        {
          "x": 79.10236220472441,
          "y": 57.04956020855305
        },
        {
          "x": 79.85826771653544,
          "y": 57.236375625155716
        },
        {
          "x": 80.61417322834646,
          "y": 57.39799218214814
        },
        {
          "x": 81.37007874015748,
          "y": 57.502893525767355
        },
        {
          "x": 82.1259842519685,
          "y": 57.53062316370071
        },
        {
          "x": 82.88188976377953,
          "y": 57.47577362350176
        },
        {
          "x": 83.63779527559055,
          "y": 57.349040947363285
        },
        {
          "x": 84.39370078740157,
          "y": 57.175138889425575
        },
        {
          "x": 85.14960629921259,
          "y": 56.987979561665675
        },
        {
          "x": 85.90551181102362,
          "y": 56.824060335971026
        },
        {
          "x": 86.66141732283464,
          "y": 56.71534660253234
        },
        {
          "x": 87.41732283464566,
          "y": 56.68303829621835
        },
        {
          "x": 88.17322834645668,
          "y": 56.733435761685705
        },
        {
          "x": 88.9291338582677,
          "y": 56.85671114230892
        },
        {
          "x": 89.68503937007874,
          "y": 57.028824880642354
        },
        {
          "x": 90.44094488188976,
          "y": 57.216213599481804
        },
        {
          "x": 91.19685039370079,
          "y": 57.38233519408233
        },
        {
          "x": 91.95275590551181,
          "y": 57.494794796984
        },
        {
          "x": 92.70866141732283,
          "y": 57.53166200269467
        },
        {
          "x": 93.46456692913385,
          "y": 57.485747449436964
        },
        {
          "x": 94.22047244094487,
          "y": 57.366004794746146
        },
        {
          "x": 94.9763779527559,
          "y": 57.195784689916756
        },
        {
          "x": 95.73228346456693,
          "y": 57.00828124043653
        },
        {
          "x": 96.48818897637796,
          "y": 56.84005892432409
        },
        {
          "x": 97.24409448818898,
          "y": 56.723922264359075
        },
        {
          "x": 98,
          "y": 56.68251871776011
        }
      ],
      [
        {
          "x": 2,
          "y": 56.79152101614663
        },
        {
          "x": 2.7559055118110236,
          "y": 56.80532541897836
        },
        {
          "x": 3.5118110236220472,
          "y": 56.845531144403814
        },
        {
          "x": 4.26771653543307,
          "y": 56.90862136280347
        },
        {
          "x": 5.0236220472440944,
          "y": 56.98907751814034
        },
        {
          "x": 5.7795275590551185,
          "y": 57.0798620408353
        },
        {
          "x": 6.535433070866142,
          "y": 57.17303393007249
        },
        {
          "x": 7.291338582677165,
          "y": 57.26044336001723
        },
        {
          "x": 8.047244094488189,
          "y": 57.33444455213919
        },
        {
          "x": 8.803149606299213,
          "y": 57.38856455808143
        },
        {
          "x": 9.559055118110237,
          "y": 57.41806945405841
        },
        {
          "x": 10.31496062992126,
          "y": 57.420378421269
        },
        {
          "x": 11.070866141732283,
          "y": 57.3952894923518
        },
        {
          "x": 11.826771653543307,
          "y": 57.3449972176452
        },
        {
          "x": 12.58267716535433,
          "y": 57.27390070596888
        },
        {
          "x": 13.338582677165354,
          "y": 57.18821883076587
        },
        {
          "x": 14.094488188976378,
          "y": 57.09544625985725
        },
        {
          "x": 14.850393700787404,
          "y": 57.0036978903577
        },
        {
          "x": 15.606299212598426,
          "y": 56.92099903159774
        },
        {
          "x": 16.36220472440945,
          "y": 56.854583424366986
        },
        {
          "x": 17.118110236220474,
          "y": 56.81026049934316
        },
        {
          "x": 17.874015748031496,
          "y": 56.79190722115995
        },
        {
          "x": 18.62992125984252,
          "y": 56.801128966953264
        },
        {
          "x": 19.385826771653544,
          "y": 56.83711910263288
        },
        {
          "x": 20.141732283464567,
          "y": 56.89672953986491
        },
        {
          "x": 20.897637795275593,
          "y": 56.97474610208441
        },
        {
          "x": 21.653543307086615,
          "y": 57.064344613034855
        },
        {
          "x": 22.409448818897637,
          "y": 57.1576878133747
        },
        {
          "x": 23.16535433070866,
          "y": 57.24661089253876
        },
        {
          "x": 23.921259842519685,
          "y": 57.32333567178876
        },
        {
          "x": 24.677165354330707,
          "y": 57.38115096824312
        },
        {
          "x": 25.433070866141733,
          "y": 57.41499962785526
        },
        {
          "x": 26.188976377952756,
          "y": 57.42192087905733
        },
        {
          "x": 26.944881889763778,
          "y": 57.40130931401317
        },
        {
          "x": 27.700787401574807,
          "y": 57.35496784416596
        },
        {
          "x": 28.45669291338583,
          "y": 57.2869499980131
        },
        {
          "x": 29.212598425196852,
          "y": 57.20320535545829
        },
        {
          "x": 29.968503937007874,
          "y": 57.11105913290528
        },
        {
          "x": 30.7244094488189,
          "y": 57.01857144023572
        },
        {
          "x": 31.480314960629922,
          "y": 56.93383225601802
        },
        {
          "x": 32.23622047244095,
          "y": 56.86425379007643
        },
        {
          "x": 32.99212598425197,
          "y": 56.81592213107901
        },
        {
          "x": 33.74803149606299,
          "y": 56.79306489109154
        },
        {
          "x": 34.503937007874015,
          "y": 56.79768141268917
        },
        {
          "x": 35.25984251968504,
          "y": 56.82936788473003
        },
        {
          "x": 36.01574803149606,
          "y": 56.8853526640655
        },
        {
          "x": 36.77165354330709,
          "y": 56.96073871356655
        },
        {
          "x": 37.52755905511811,
          "y": 57.04893195020202
        },
        {
          "x": 38.28346456692913,
          "y": 57.142218035191625
        },
        {
          "x": 39.039370078740156,
          "y": 57.23243715389933
        },
        {
          "x": 39.795275590551185,
          "y": 57.31169776188565
        },
        {
          "x": 40.55118110236221,
          "y": 57.37306686513352
        },
        {
          "x": 41.30708661417323,
          "y": 57.41117645503867
        },
        {
          "x": 42.06299212598425,
          "y": 57.42269305277073
        },
        {
          "x": 42.818897637795274,
          "y": 57.40660929155318
        },
        {
          "x": 43.574803149606296,
          "y": 57.364332031907594
        },
        {
          "x": 44.33070866141732,
          "y": 57.29955930234558
        },
        {
          "x": 45.08661417322834,
          "y": 57.217956829612504
        },
        {
          "x": 45.84251968503937,
          "y": 57.126662452662785
        },
        {
          "x": 46.59842519685039,
          "y": 57.03366176970547
        },
        {
          "x": 47.354330708661415,
          "y": 56.94708963101368
        },
        {
          "x": 48.11023622047244,
          "y": 56.87451857652678
        },
        {
          "x": 48.86614173228347,
          "y": 56.82229645922435
        },
        {
          "x": 49.62204724409449,
          "y": 56.794991192929075
        },
        {
          "x": 50.37795275590551,
          "y": 56.794991192929075
        },
        {
          "x": 51.13385826771653,
          "y": 56.82229645922435
        },
        {
          "x": 51.889763779527556,
          "y": 56.87451857652678
        },
        {
          "x": 52.64566929133858,
          "y": 56.94708963101368
        },
        {
          "x": 53.401574803149614,
          "y": 57.03366176970547
        },
        {
          "x": 54.15748031496064,
          "y": 57.126662452662785
        },
        {
          "x": 54.91338582677166,
          "y": 57.217956829612504
        },
        {
          "x": 55.66929133858268,
          "y": 57.29955930234558
        },
        {
          "x": 56.425196850393704,
          "y": 57.364332031907594
        },
        {
          "x": 57.181102362204726,
          "y": 57.40660929155318
        },
        {
          "x": 57.93700787401575,
          "y": 57.42269305277073
        },
        {
          "x": 58.69291338582677,
          "y": 57.41117645503867
        },
        {
          "x": 59.4488188976378,
          "y": 57.37306686513352
        },
        {
          "x": 60.20472440944882,
          "y": 57.31169776188565
        },
        {
          "x": 60.960629921259844,
          "y": 57.23243715389933
        },
        {
          "x": 61.71653543307087,
          "y": 57.142218035191625
        },
        {
          "x": 62.47244094488189,
          "y": 57.04893195020202
        },
        {
          "x": 63.22834645669291,
          "y": 56.96073871356655
        },
        {
          "x": 63.98425196850393,
          "y": 56.88535266406551
        },
        {
          "x": 64.74015748031496,
          "y": 56.82936788473003
        },
        {
          "x": 65.49606299212599,
          "y": 56.79768141268917
        },
        {
          "x": 66.25196850393701,
          "y": 56.79306489109154
        },
        {
          "x": 67.00787401574803,
          "y": 56.81592213107901
        },
        {
          "x": 67.76377952755905,
          "y": 56.86425379007643
        },
        {
          "x": 68.51968503937007,
          "y": 56.93383225601802
        },
        {
          "x": 69.2755905511811,
          "y": 57.01857144023572
        },
        {
          "x": 70.03149606299212,
          "y": 57.11105913290528
        },
        {
          "x": 70.78740157480314,
          "y": 57.20320535545829
        },
        {
          "x": 71.54330708661418,
          "y": 57.2869499980131
        },
        {
          "x": 72.2992125984252,
          "y": 57.35496784416596
        },
        {
          "x": 73.05511811023622,
          "y": 57.40130931401317
        },
        {
          "x": 73.81102362204724,
          "y": 57.42192087905733
        },
        {
          "x": 74.56692913385827,
          "y": 57.41499962785526
        },
        {
          "x": 75.32283464566929,
          "y": 57.38115096824312
        },
        {
          "x": 76.07874015748031,
          "y": 57.32333567178876
        },
        {
          "x": 76.83464566929133,
          "y": 57.24661089253876
        },
        {
          "x": 77.59055118110237,
          "y": 57.1576878133747
        },
        {
          "x": 78.34645669291339,
          "y": 57.064344613034855
        },
        {
          "x": 79.10236220472441,
          "y": 56.97474610208441
        },
        {
          "x": 79.85826771653544,
          "y": 56.89672953986491
        },
        {
          "x": 80.61417322834646,
          "y": 56.83711910263288
        },
        {
          "x": 81.37007874015748,
          "y": 56.801128966953264
        },
        {
          "x": 82.1259842519685,
          "y": 56.79190722115995
        },
        {
          "x": 82.88188976377953,
          "y": 56.81026049934316
        },
        {
          "x": 83.63779527559055,
          "y": 56.854583424366986
        },
        {
          "x": 84.39370078740157,
          "y": 56.92099903159774
        },
        {
          "x": 85.14960629921259,
          "y": 57.0036978903577
        },
        {
          "x": 85.90551181102362,
          "y": 57.095446259857255
        },
        {
          "x": 86.66141732283464,
          "y": 57.18821883076587
        },
        {
          "x": 87.41732283464566,
          "y": 57.27390070596888
        },
        {
          "x": 88.17322834645668,
          "y": 57.3449972176452
        },
        {
          "x": 88.9291338582677,
          "y": 57.3952894923518
        },
        {
          "x": 89.68503937007874,
          "y": 57.420378421269
        },
        {
          "x": 90.44094488188976,
          "y": 57.41806945405841
        },
        {
          "x": 91.19685039370079,
          "y": 57.38856455808143
        },
        {
          "x": 91.95275590551181,
          "y": 57.33444455213919
        },
        {
          "x": 92.70866141732283,
          "y": 57.26044336001723
        },
        {
          "x": 93.46456692913385,
          "y": 57.17303393007249
        },
        {
          "x": 94.22047244094487,
          "y": 57.0798620408353
        },
        {
          "x": 94.9763779527559,
          "y": 56.98907751814034
        },
        {
          "x": 95.73228346456693,
          "y": 56.90862136280347
        },
        {
          "x": 96.48818897637796,
          "y": 56.845531144403814
        },
        {
          "x": 97.24409448818898,
          "y": 56.80532541897836
        },
        {
          "x": 98,
          "y": 56.79152101614663
        }
      ],
      [
        {
          "x": 2,
          "y": 56.64313710134004
        },
        {
          "x": 2.7559055118110236,
          "y": 56.69877629002302
        },
        {
          "x": 3.5118110236220472,
          "y": 56.85235076216021
        },
        {
          "x": 4.26771653543307,
          "y": 57.067031105736845
        },
        {
          "x": 5.0236220472440944,
          "y": 57.29133382408169
        },
        {
          "x": 5.7795275590551185,
          "y": 57.47146783385261
        },
        {
          "x": 6.535433070866142,
          "y": 57.5642343561679
        },
        {
          "x": 7.291338582677165,
          "y": 57.54738661769355
        },
        {
          "x": 8.047244094488189,
          "y": 57.42496495334429
        },
        {
          "x": 8.803149606299213,
          "y": 57.22632787468204
        },
        {
          "x": 9.559055118110237,
          "y": 56.999111468028026
        },
        {
          "x": 10.31496062992126,
          "y": 56.79780556193724
        },
        {
          "x": 11.070866141732283,
          "y": 56.67068626671142
        },
        {
          "x": 11.826771653543307,
          "y": 56.648238654731074
        },
        {
          "x": 12.58267716535433,
          "y": 56.73584599275185
        },
        {
          "x": 13.338582677165354,
          "y": 56.91249875554091
        },
        {
          "x": 14.094488188976378,
          "y": 57.13583301832764
        },
        {
          "x": 14.850393700787404,
          "y": 57.35228994762412
        },
        {
          "x": 15.606299212598426,
          "y": 57.50995999543339
        },
        {
          "x": 16.36220472440945,
          "y": 57.57103157059483
        },
        {
          "x": 17.118110236220474,
          "y": 57.52085881320276
        },
        {
          "x": 17.874015748031496,
          "y": 57.37147388672936
        },
        {
          "x": 18.62992125984252,
          "y": 57.15870148866063
        },
        {
          "x": 19.385826771653544,
          "y": 56.933567562337245
        },
        {
          "x": 20.141732283464567,
          "y": 56.750062526971995
        },
        {
          "x": 20.897637795275593,
          "y": 56.6521935828515
        },
        {
          "x": 21.653543307086615,
          "y": 56.663431138933085
        },
        {
          "x": 22.409448818897637,
          "y": 56.78108026436524
        },
        {
          "x": 23.16535433070866,
          "y": 56.97692697245198
        },
        {
          "x": 23.921259842519685,
          "y": 57.2040043486828
        },
        {
          "x": 24.677165354330707,
          "y": 57.407855906038364
        },
        {
          "x": 25.433070866141733,
          "y": 57.53959504968801
        },
        {
          "x": 26.188976377952756,
          "y": 57.56762879980621
        },
        {
          "x": 26.944881889763778,
          "y": 57.48523425173924
        },
        {
          "x": 27.700787401574807,
          "y": 57.31217082719503
        },
        {
          "x": 28.45669291338583,
          "y": 57.0899416749621
        },
        {
          "x": 29.212598425196852,
          "y": 56.87184060680084
        },
        {
          "x": 29.968503937007874,
          "y": 56.71017145933457
        },
        {
          "x": 30.7244094488189,
          "y": 56.64370486650559
        },
        {
          "x": 31.480314960629922,
          "y": 56.68838049262432
        },
        {
          "x": 32.23622047244095,
          "y": 56.833484466964414
        },
        {
          "x": 32.99212598425197,
          "y": 57.044218727181374
        },
        {
          "x": 33.74803149606299,
          "y": 57.27004610529961
        },
        {
          "x": 34.503937007874015,
          "y": 57.45680988219001
        },
        {
          "x": 35.25984251968504,
          "y": 57.5597213635285
        },
        {
          "x": 36.01574803149606,
          "y": 57.55410086593724
        },
        {
          "x": 36.77165354330709,
          "y": 57.44129626721541
        },
        {
          "x": 37.52755905511811,
          "y": 57.24835976546387
        },
        {
          "x": 38.28346456692913,
          "y": 57.02156036500873
        },
        {
          "x": 39.039370078740156,
          "y": 56.81528789019923
        },
        {
          "x": 39.795275590551185,
          "y": 56.67900950739673
        },
        {
          "x": 40.55118110236221,
          "y": 56.645406772585716
        },
        {
          "x": 41.30708661417323,
          "y": 56.722538114670144
        },
        {
          "x": 42.06299212598425,
          "y": 56.89190630597051
        },
        {
          "x": 42.818897637795274,
          "y": 57.11289436885509
        },
        {
          "x": 43.574803149606296,
          "y": 57.33250612300132
        },
        {
          "x": 44.33070866141732,
          "y": 57.49807544711847
        },
        {
          "x": 45.08661417322834,
          "y": 57.56989638767101
        },
        {
          "x": 45.84251968503937,
          "y": 57.53074522919317
        },
        {
          "x": 46.59842519685039,
          "y": 57.39001099400337
        },
        {
          "x": 47.354330708661415,
          "y": 57.18144381687505
        },
        {
          "x": 48.11023622047244,
          "y": 56.95506116745875
        },
        {
          "x": 48.86614173228347,
          "y": 56.76515292708906
        },
        {
          "x": 49.62204724409449,
          "y": 56.65726187857515
        },
        {
          "x": 50.37795275590551,
          "y": 56.65726187857515
        },
        {
          "x": 51.13385826771653,
          "y": 56.76515292708906
        },
        {
          "x": 51.889763779527556,
          "y": 56.95506116745875
        },
        {
          "x": 52.64566929133858,
          "y": 57.18144381687505
        },
        {
          "x": 53.401574803149614,
          "y": 57.39001099400337
        },
        {
          "x": 54.15748031496064,
          "y": 57.53074522919317
        },
        {
          "x": 54.91338582677166,
          "y": 57.569896387671015
        },
        {
          "x": 55.66929133858268,
          "y": 57.498075447118474
        },
        {
          "x": 56.425196850393704,
          "y": 57.33250612300132
        },
        {
          "x": 57.181102362204726,
          "y": 57.11289436885509
        },
        {
          "x": 57.93700787401575,
          "y": 56.89190630597051
        },
        {
          "x": 58.69291338582677,
          "y": 56.722538114670144
        },
        {
          "x": 59.4488188976378,
          "y": 56.645406772585716
        },
        {
          "x": 60.20472440944882,
          "y": 56.67900950739673
        },
        {
          "x": 60.960629921259844,
          "y": 56.81528789019923
        },
        {
          "x": 61.71653543307087,
          "y": 57.021560365008725
        },
        {
          "x": 62.47244094488189,
          "y": 57.24835976546387
        },
        {
          "x": 63.22834645669291,
          "y": 57.44129626721541
        },
        {
          "x": 63.98425196850393,
          "y": 57.55410086593724
        },
        {
          "x": 64.74015748031496,
          "y": 57.5597213635285
        },
        {
          "x": 65.49606299212599,
          "y": 57.45680988219001
        },
        {
          "x": 66.25196850393701,
          "y": 57.270046105299606
        },
        {
          "x": 67.00787401574803,
          "y": 57.04421872718138
        },
        {
          "x": 67.76377952755905,
          "y": 56.833484466964414
        },
        {
          "x": 68.51968503937007,
          "y": 56.68838049262432
        },
        {
          "x": 69.2755905511811,
          "y": 56.64370486650559
        },
        {
          "x": 70.03149606299212,
          "y": 56.71017145933457
        },
        {
          "x": 70.78740157480314,
          "y": 56.87184060680084
        },
        {
          "x": 71.54330708661418,
          "y": 57.0899416749621
        },
        {
          "x": 72.2992125984252,
          "y": 57.31217082719503
        },
        {
          "x": 73.05511811023622,
          "y": 57.485234251739236
        },
        {
          "x": 73.81102362204724,
          "y": 57.56762879980621
        },
        {
          "x": 74.56692913385827,
          "y": 57.53959504968801
        },
        {
          "x": 75.32283464566929,
          "y": 57.407855906038364
        },
        {
          "x": 76.07874015748031,
          "y": 57.2040043486828
        },
        {
          "x": 76.83464566929133,
          "y": 56.976926972451984
        },
        {
          "x": 77.59055118110237,
          "y": 56.78108026436524
        },
        {
          "x": 78.34645669291339,
          "y": 56.663431138933085
        },
        {
          "x": 79.10236220472441,
          "y": 56.6521935828515
        },
        {
          "x": 79.85826771653544,
          "y": 56.750062526971995
        },
        {
          "x": 80.61417322834646,
          "y": 56.933567562337245
        },
        {
          "x": 81.37007874015748,
          "y": 57.15870148866063
        },
        {
          "x": 82.1259842519685,
          "y": 57.371473886729355
        },
        {
          "x": 82.88188976377953,
          "y": 57.52085881320276
        },
        {
          "x": 83.63779527559055,
          "y": 57.57103157059483
        },
        {
          "x": 84.39370078740157,
          "y": 57.50995999543339
        },
        {
          "x": 85.14960629921259,
          "y": 57.35228994762412
        },
        {
          "x": 85.90551181102362,
          "y": 57.13583301832764
        },
        {
          "x": 86.66141732283464,
          "y": 56.912498755540916
        },
        {
          "x": 87.41732283464566,
          "y": 56.73584599275185
        },
        {
          "x": 88.17322834645668,
          "y": 56.648238654731074
        },
        {
          "x": 88.9291338582677,
          "y": 56.67068626671142
        },
        {
          "x": 89.68503937007874,
          "y": 56.79780556193724
        },
        {
          "x": 90.44094488188976,
          "y": 56.999111468028026
        },
        {
          "x": 91.19685039370079,
          "y": 57.22632787468204
        },
        {
          "x": 91.95275590551181,
          "y": 57.42496495334429
        },
        {
          "x": 92.70866141732283,
          "y": 57.54738661769355
        },
        {
          "x": 93.46456692913385,
          "y": 57.5642343561679
        },
        {
          "x": 94.22047244094487,
          "y": 57.471467833852614
        },
        {
          "x": 94.9763779527559,
          "y": 57.2913338240817
        },
        {
          "x": 95.73228346456693,
          "y": 57.067031105736845
        },
        {
          "x": 96.48818897637796,
          "y": 56.85235076216021
        },
        {
          "x": 97.24409448818898,
          "y": 56.69877629002302
        },
        {
          "x": 98,
          "y": 56.64313710134004
        }
      ],
      [
        {
          "x": 2,
          "y": 57.02648195946579
        },
        {
          "x": 2.7559055118110236,
          "y": 57.03271867034421
        },
        {
          "x": 3.5118110236220472,
          "y": 57.05046450538376
        },
        {
          "x": 4.26771653543307,
          "y": 57.076975667991015
        },
        {
          "x": 5.0236220472440944,
          "y": 57.10815309844366
        },
        {
          "x": 5.7795275590551185,
          "y": 57.13917625562447
        },
        {
          "x": 6.535433070866142,
          "y": 57.16524845158946
        },
        {
          "x": 7.291338582677165,
          "y": 57.182338498045034
        },
        {
          "x": 8.047244094488189,
          "y": 57.18780399404799
        },
        {
          "x": 8.803149606299213,
          "y": 57.180799884447026
        },
        {
          "x": 9.559055118110237,
          "y": 57.16240911924254
        },
        {
          "x": 10.31496062992126,
          "y": 57.13547521178885
        },
        {
          "x": 11.070866141732283,
          "y": 57.104162585081795
        },
        {
          "x": 11.826771653543307,
          "y": 57.07331268379268
        },
        {
          "x": 12.58267716535433,
          "y": 57.04769540766844
        },
        {
          "x": 13.338582677165354,
          "y": 57.03127160694836
        },
        {
          "x": 14.094488188976378,
          "y": 57.02658067007859
        },
        {
          "x": 14.850393700787404,
          "y": 57.03434789268904
        },
        {
          "x": 15.606299212598426,
          "y": 57.053372335016014
        },
        {
          "x": 16.36220472440945,
          "y": 57.080712506848876
        },
        {
          "x": 17.118110236220474,
          "y": 57.112141170068284
        },
        {
          "x": 17.874015748031496,
          "y": 57.142798938858625
        },
        {
          "x": 18.62992125984252,
          "y": 57.167945620302454
        },
        {
          "x": 19.385826771653544,
          "y": 57.183693125801625
        },
        {
          "x": 20.141732283464567,
          "y": 57.18760663322199
        },
        {
          "x": 20.897637795275593,
          "y": 57.1790810502529
        },
        {
          "x": 21.653543307086615,
          "y": 57.159434571583716
        },
        {
          "x": 22.409448818897637,
          "y": 57.13170486442623
        },
        {
          "x": 23.16535433070866,
          "y": 57.100179395437586
        },
        {
          "x": 23.921259842519685,
          "y": 57.069732518190015
        },
        {
          "x": 24.677165354330707,
          "y": 57.045071818316195
        },
        {
          "x": 25.433070866141733,
          "y": 57.030010243708105
        },
        {
          "x": 26.188976377952756,
          "y": 57.02687656035557
        },
        {
          "x": 26.944881889763778,
          "y": 57.036155287002764
        },
        {
          "x": 27.700787401574807,
          "y": 57.05641178061884
        },
        {
          "x": 28.45669291338583,
          "y": 57.084514055695394
        },
        {
          "x": 29.212598425196852,
          "y": 57.11611704047611
        },
        {
          "x": 29.968503937007874,
          "y": 57.146334396178396
        },
        {
          "x": 30.7244094488189,
          "y": 57.17049402495769
        },
        {
          "x": 31.480314960629922,
          "y": 57.18486045271568
        },
        {
          "x": 32.23622047244095,
          "y": 57.187212394545
        },
        {
          "x": 32.99212598425197,
          "y": 57.177186201737946
        },
        {
          "x": 33.74803149606299,
          "y": 57.15633208782957
        },
        {
          "x": 34.503937007874015,
          "y": 57.12787444020841
        },
        {
          "x": 35.25984251968504,
          "y": 57.09621327704356
        },
        {
          "x": 36.01574803149606,
          "y": 57.06624393244818
        },
        {
          "x": 36.77165354330709,
          "y": 57.042600157689805
        },
        {
          "x": 37.52755905511811,
          "y": 57.02893766739066
        },
        {
          "x": 38.28346456692913,
          "y": 57.02736890620364
        },
        {
          "x": 39.039370078740156,
          "y": 57.03813643028862
        },
        {
          "x": 39.795275590551185,
          "y": 57.05957540415951
        },
        {
          "x": 40.55118110236221,
          "y": 57.088371011503504
        },
        {
          "x": 41.30708661417323,
          "y": 57.12007098004602
        },
        {
          "x": 42.06299212598425,
          "y": 57.14977397572728
        },
        {
          "x": 42.818897637795274,
          "y": 57.17288742918195
        },
        {
          "x": 43.574803149606296,
          "y": 57.18583762214262
        },
        {
          "x": 44.33070866141732,
          "y": 57.18662224278513
        },
        {
          "x": 45.08661417322834,
          "y": 57.17511997591402
        },
        {
          "x": 45.84251968503937,
          "y": 57.15310926027773
        },
        {
          "x": 46.59842519685039,
          "y": 57.12399331282531
        },
        {
          "x": 47.354330708661415,
          "y": 57.09227393565604
        },
        {
          "x": 48.11023622047244,
          "y": 57.062855463721085
        },
        {
          "x": 48.86614173228347,
          "y": 57.040286474357
        },
        {
          "x": 49.62204724409449,
          "y": 57.02805650277001
        },
        {
          "x": 50.37795275590551,
          "y": 57.02805650277001
        },
        {
          "x": 51.13385826771653,
          "y": 57.040286474357
        },
        {
          "x": 51.889763779527556,
          "y": 57.062855463721085
        },
        {
          "x": 52.64566929133858,
          "y": 57.09227393565603
        },
        {
          "x": 53.401574803149614,
          "y": 57.12399331282531
        },
        {
          "x": 54.15748031496064,
          "y": 57.15310926027773
        },
        {
          "x": 54.91338582677166,
          "y": 57.17511997591402
        },
        {
          "x": 55.66929133858268,
          "y": 57.18662224278513
        },
        {
          "x": 56.425196850393704,
          "y": 57.18583762214262
        },
        {
          "x": 57.181102362204726,
          "y": 57.17288742918195
        },
        {
          "x": 57.93700787401575,
          "y": 57.14977397572728
        },
        {
          "x": 58.69291338582677,
          "y": 57.12007098004602
        },
        {
          "x": 59.4488188976378,
          "y": 57.088371011503504
        },
        {
          "x": 60.20472440944882,
          "y": 57.05957540415951
        },
        {
          "x": 60.960629921259844,
          "y": 57.03813643028862
        },
        {
          "x": 61.71653543307087,
          "y": 57.02736890620364
        },
        {
          "x": 62.47244094488189,
          "y": 57.02893766739066
        },
        {
          "x": 63.22834645669291,
          "y": 57.042600157689805
        },
        {
          "x": 63.98425196850393,
          "y": 57.06624393244818
        },
        {
          "x": 64.74015748031496,
          "y": 57.09621327704356
        },
        {
          "x": 65.49606299212599,
          "y": 57.12787444020841
        },
        {
          "x": 66.25196850393701,
          "y": 57.15633208782957
        },
        {
          "x": 67.00787401574803,
          "y": 57.177186201737946
        },
        {
          "x": 67.76377952755905,
          "y": 57.187212394545
        },
        {
          "x": 68.51968503937007,
          "y": 57.18486045271568
        },
        {
          "x": 69.2755905511811,
          "y": 57.17049402495769
        },
        {
          "x": 70.03149606299212,
          "y": 57.146334396178396
        },
        {
          "x": 70.78740157480314,
          "y": 57.11611704047611
        },
        {
          "x": 71.54330708661418,
          "y": 57.084514055695394
        },
        {
          "x": 72.2992125984252,
          "y": 57.05641178061884
        },
        {
          "x": 73.05511811023622,
          "y": 57.036155287002764
        },
        {
          "x": 73.81102362204724,
          "y": 57.02687656035557
        },
        {
          "x": 74.56692913385827,
          "y": 57.030010243708105
        },
        {
          "x": 75.32283464566929,
          "y": 57.045071818316195
        },
        {
          "x": 76.07874015748031,
          "y": 57.069732518190015
        },
        {
          "x": 76.83464566929133,
          "y": 57.100179395437586
        },
        {
          "x": 77.59055118110237,
          "y": 57.13170486442623
        },
        {
          "x": 78.34645669291339,
          "y": 57.159434571583716
        },
        {
          "x": 79.10236220472441,
          "y": 57.1790810502529
        },
        {
          "x": 79.85826771653544,
          "y": 57.18760663322199
        },
        {
          "x": 80.61417322834646,
          "y": 57.183693125801625
        },
        {
          "x": 81.37007874015748,
          "y": 57.167945620302454
        },
        {
          "x": 82.1259842519685,
          "y": 57.142798938858625
        },
        {
          "x": 82.88188976377953,
          "y": 57.112141170068284
        },
        {
          "x": 83.63779527559055,
          "y": 57.080712506848876
        },
        {
          "x": 84.39370078740157,
          "y": 57.053372335016014
        },
        {
          "x": 85.14960629921259,
          "y": 57.03434789268904
        },
        {
          "x": 85.90551181102362,
          "y": 57.02658067007859
        },
        {
          "x": 86.66141732283464,
          "y": 57.03127160694836
        },
        {
          "x": 87.41732283464566,
          "y": 57.04769540766844
        },
        {
          "x": 88.17322834645668,
          "y": 57.07331268379268
        },
        {
          "x": 88.9291338582677,
          "y": 57.104162585081795
        },
        {
          "x": 89.68503937007874,
          "y": 57.13547521178885
        },
        {
          "x": 90.44094488188976,
          "y": 57.16240911924254
        },
        {
          "x": 91.19685039370079,
          "y": 57.180799884447026
        },
        {
          "x": 91.95275590551181,
          "y": 57.18780399404799
        },
        {
          "x": 92.70866141732283,
          "y": 57.182338498045034
        },
        {
          "x": 93.46456692913385,
          "y": 57.16524845158946
        },
        {
          "x": 94.22047244094487,
          "y": 57.13917625562447
        },
        {
          "x": 94.9763779527559,
          "y": 57.10815309844366
        },
        {
          "x": 95.73228346456693,
          "y": 57.076975667991015
        },
        {
          "x": 96.48818897637796,
          "y": 57.05046450538376
        },
        {
          "x": 97.24409448818898,
          "y": 57.03271867034421
        },
        {
          "x": 98,
          "y": 57.02648195946579
        }
      ],
      [
        {
          "x": 2,
          "y": 65.60365653379337
        },
        {
          "x": 2.7559055118110236,
          "y": 65.51024348860417
        },
        {
          "x": 3.5118110236220472,
          "y": 65.23205837428351
        },
        {
          "x": 4.26771653543307,
          "y": 64.77521808953908
        },
        {
          "x": 5.0236220472440944,
          "y": 64.1497679085553
        },
        {
          "x": 5.7795275590551185,
          "y": 63.369460599567546
        },
        {
          "x": 6.535433070866142,
          "y": 62.451454020865974
        },
        {
          "x": 7.291338582677165,
          "y": 61.415933843666764
        },
        {
          "x": 8.047244094488189,
          "y": 60.285669697643165
        },
        {
          "x": 8.803149606299213,
          "y": 59.085514498850905
        },
        {
          "x": 9.559055118110237,
          "y": 57.84185796912122
        },
        {
          "x": 10.31496062992126,
          "y": 56.58204636326035
        },
        {
          "x": 11.070866141732283,
          "y": 55.333781163436534
        },
        {
          "x": 11.826771653543307,
          "y": 54.12450996261785
        },
        {
          "x": 12.58267716535433,
          "y": 52.98082293067589
        },
        {
          "x": 13.338582677165354,
          "y": 51.927868134015185
        },
        {
          "x": 14.094488188976378,
          "y": 50.98879856502599
        },
        {
          "x": 14.850393700787404,
          "y": 50.184263040403636
        },
        {
          "x": 15.606299212598426,
          "y": 49.53195216276312
        },
        {
          "x": 16.36220472440945,
          "y": 49.04620932921322
        },
        {
          "x": 17.118110236220474,
          "y": 48.73771534026357
        },
        {
          "x": 17.874015748031496,
          "y": 48.61325354407047
        },
        {
          "x": 18.62992125984252,
          "y": 48.67556068016848
        },
        {
          "x": 19.385826771653544,
          "y": 48.9232667024241
        },
        {
          "x": 20.141732283464567,
          "y": 49.35092490441981
        },
        {
          "x": 20.897637795275593,
          "y": 49.949131684854
        },
        {
          "x": 21.653543307086615,
          "y": 50.70473331948406
        },
        {
          "x": 22.409448818897637,
          "y": 51.601115192989255
        },
        {
          "x": 23.16535433070866,
          "y": 52.61856713095198
        },
        {
          "x": 23.921259842519685,
          "y": 53.73471679882206
        },
        {
          "x": 24.677165354330707,
          "y": 54.92502163803142
        },
        {
          "x": 25.433070866141733,
          "y": 56.163308522277106
        },
        {
          "x": 26.188976377952756,
          "y": 57.42234926769138
        },
        {
          "x": 26.944881889763778,
          "y": 58.67445934224111
        },
        {
          "x": 27.700787401574807,
          "y": 59.892106609580324
        },
        {
          "x": 28.45669291338583,
          "y": 61.04851672193631
        },
        {
          "x": 29.212598425196852,
          "y": 62.11826185029277
        },
        {
          "x": 29.968503937007874,
          "y": 63.07781980652263
        },
        {
          "x": 30.7244094488189,
          "y": 63.906091263162786
        },
        {
          "x": 31.480314960629922,
          "y": 64.58486369789654
        },
        {
          "x": 32.23622047244095,
          "y": 65.09921186125833
        },
        {
          "x": 32.99212598425197,
          "y": 65.43782596184019
        },
        {
          "x": 33.74803149606299,
          "y": 65.59326035266957
        },
        {
          "x": 34.503937007874015,
          "y": 65.56209725049548
        },
        {
          "x": 35.25984251968504,
          "y": 65.34502188802666
        },
        {
          "x": 36.01574803149606,
          "y": 64.94680744662978
        },
        {
          "x": 36.77165354330709,
          "y": 64.37621010079644
        },
        {
          "x": 37.52755905511811,
          "y": 63.64577648220342
        },
        {
          "x": 38.28346456692913,
          "y": 62.77156779695994
        },
        {
          "x": 39.039370078740156,
          "y": 61.77280666231523
        },
        {
          "x": 39.795275590551185,
          "y": 60.67145442838938
        },
        {
          "x": 40.55118110236221,
          "y": 59.49172827902728
        },
        {
          "x": 41.30708661417323,
          "y": 58.25956873004726
        },
        {
          "x": 42.06299212598425,
          "y": 57.00206923384785
        },
        {
          "x": 42.818897637795274,
          "y": 55.7468804325635
        },
        {
          "x": 43.574803149606296,
          "y": 54.52160215940325
        },
        {
          "x": 44.33070866141732,
          "y": 53.353176557205906
        },
        {
          "x": 45.08661417322834,
          "y": 52.267295658679835
        },
        {
          "x": 45.84251968503937,
          "y": 51.28783645480321
        },
        {
          "x": 46.59842519685039,
          "y": 50.43633587343454
        },
        {
          "x": 47.354330708661415,
          "y": 49.73151721261398
        },
        {
          "x": 48.11023622047244,
          "y": 49.18887844162024
        },
        {
          "x": 48.86614173228347,
          "y": 48.8203514224623
        },
        {
          "x": 49.62204724409449,
          "y": 48.634039545045646
        },
        {
          "x": 50.37795275590551,
          "y": 48.634039545045646
        },
        {
          "x": 51.13385826771653,
          "y": 48.8203514224623
        },
        {
          "x": 51.889763779527556,
          "y": 49.18887844162023
        },
        {
          "x": 52.64566929133858,
          "y": 49.73151721261398
        },
        {
          "x": 53.401574803149614,
          "y": 50.43633587343454
        },
        {
          "x": 54.15748031496064,
          "y": 51.28783645480322
        },
        {
          "x": 54.91338582677166,
          "y": 52.26729565867983
        },
        {
          "x": 55.66929133858268,
          "y": 53.3531765572059
        },
        {
          "x": 56.425196850393704,
          "y": 54.521602159403244
        },
        {
          "x": 57.181102362204726,
          "y": 55.74688043256349
        },
        {
          "x": 57.93700787401575,
          "y": 57.002069233847834
        },
        {
          "x": 58.69291338582677,
          "y": 58.25956873004725
        },
        {
          "x": 59.4488188976378,
          "y": 59.491728279027285
        },
        {
          "x": 60.20472440944882,
          "y": 60.671454428389374
        },
        {
          "x": 60.960629921259844,
          "y": 61.77280666231523
        },
        {
          "x": 61.71653543307087,
          "y": 62.77156779695994
        },
        {
          "x": 62.47244094488189,
          "y": 63.645776482203416
        },
        {
          "x": 63.22834645669291,
          "y": 64.37621010079644
        },
        {
          "x": 63.98425196850393,
          "y": 64.94680744662978
        },
        {
          "x": 64.74015748031496,
          "y": 65.34502188802666
        },
        {
          "x": 65.49606299212599,
          "y": 65.56209725049548
        },
        {
          "x": 66.25196850393701,
          "y": 65.59326035266957
        },
        {
          "x": 67.00787401574803,
          "y": 65.43782596184019
        },
        {
          "x": 67.76377952755905,
          "y": 65.09921186125833
        },
        {
          "x": 68.51968503937007,
          "y": 64.58486369789654
        },
        {
          "x": 69.2755905511811,
          "y": 63.90609126316279
        },
        {
          "x": 70.03149606299212,
          "y": 63.07781980652263
        },
        {
          "x": 70.78740157480314,
          "y": 62.118261850292775
        },
        {
          "x": 71.54330708661418,
          "y": 61.04851672193631
        },
        {
          "x": 72.2992125984252,
          "y": 59.892106609580324
        },
        {
          "x": 73.05511811023622,
          "y": 58.67445934224112
        },
        {
          "x": 73.81102362204724,
          "y": 57.422349267691395
        },
        {
          "x": 74.56692913385827,
          "y": 56.163308522277106
        },
        {
          "x": 75.32283464566929,
          "y": 54.925021638031424
        },
        {
          "x": 76.07874015748031,
          "y": 53.73471679882206
        },
        {
          "x": 76.83464566929133,
          "y": 52.61856713095199
        },
        {
          "x": 77.59055118110237,
          "y": 51.60111519298926
        },
        {
          "x": 78.34645669291339,
          "y": 50.70473331948406
        },
        {
          "x": 79.10236220472441,
          "y": 49.949131684854
        },
        {
          "x": 79.85826771653544,
          "y": 49.35092490441981
        },
        {
          "x": 80.61417322834646,
          "y": 48.9232667024241
        },
        {
          "x": 81.37007874015748,
          "y": 48.67556068016849
        },
        {
          "x": 82.1259842519685,
          "y": 48.61325354407047
        },
        {
          "x": 82.88188976377953,
          "y": 48.73771534026356
        },
        {
          "x": 83.63779527559055,
          "y": 49.04620932921321
        },
        {
          "x": 84.39370078740157,
          "y": 49.53195216276311
        },
        {
          "x": 85.14960629921259,
          "y": 50.184263040403636
        },
        {
          "x": 85.90551181102362,
          "y": 50.98879856502599
        },
        {
          "x": 86.66141732283464,
          "y": 51.927868134015185
        },
        {
          "x": 87.41732283464566,
          "y": 52.98082293067589
        },
        {
          "x": 88.17322834645668,
          "y": 54.12450996261784
        },
        {
          "x": 88.9291338582677,
          "y": 55.33378116343652
        },
        {
          "x": 89.68503937007874,
          "y": 56.58204636326037
        },
        {
          "x": 90.44094488188976,
          "y": 57.84185796912123
        },
        {
          "x": 91.19685039370079,
          "y": 59.085514498850905
        },
        {
          "x": 91.95275590551181,
          "y": 60.285669697643165
        },
        {
          "x": 92.70866141732283,
          "y": 61.41593384366676
        },
        {
          "x": 93.46456692913385,
          "y": 62.45145402086597
        },
        {
          "x": 94.22047244094487,
          "y": 63.36946059956754
        },
        {
          "x": 94.9763779527559,
          "y": 64.14976790855529
        },
        {
          "x": 95.73228346456693,
          "y": 64.7752180895391
        },
        {
          "x": 96.48818897637796,
          "y": 65.23205837428351
        },
        {
          "x": 97.24409448818898,
          "y": 65.51024348860417
        },
        {
          "x": 98,
          "y": 65.60365653379337
        }
      ],
      [
        {
          "x": 2,
          "y": 56.59223221134906
        },
        {
          "x": 2.7559055118110236,
          "y": 56.66662054059018
        },
        {
          "x": 3.5118110236220472,
          "y": 56.868292519118626
        },
        {
          "x": 4.26771653543307,
          "y": 57.13897909138369
        },
        {
          "x": 5.0236220472440944,
          "y": 57.40047082526087
        },
        {
          "x": 5.7795275590551185,
          "y": 57.57721495194948
        },
        {
          "x": 6.535433070866142,
          "y": 57.61814481652094
        },
        {
          "x": 7.291338582677165,
          "y": 57.511434559131956
        },
        {
          "x": 8.047244094488189,
          "y": 57.28791595899648
        },
        {
          "x": 8.803149606299213,
          "y": 57.01217021288234
        },
        {
          "x": 9.559055118110237,
          "y": 56.763868499281614
        },
        {
          "x": 10.31496062992126,
          "y": 56.614752596346655
        },
        {
          "x": 11.070866141732283,
          "y": 56.60790654031792
        },
        {
          "x": 11.826771653543307,
          "y": 56.745308361172384
        },
        {
          "x": 12.58267716535433,
          "y": 56.987258570708676
        },
        {
          "x": 13.338582677165354,
          "y": 57.263850529924
        },
        {
          "x": 14.094488188976378,
          "y": 57.49516856409748
        },
        {
          "x": 14.850393700787404,
          "y": 57.61437798711419
        },
        {
          "x": 15.606299212598426,
          "y": 57.58703563764544
        },
        {
          "x": 16.36220472440945,
          "y": 57.42104153676362
        },
        {
          "x": 17.118110236220474,
          "y": 57.164356335997724
        },
        {
          "x": 17.874015748031496,
          "y": 56.891144053232665
        },
        {
          "x": 18.62992125984252,
          "y": 56.680343873761956
        },
        {
          "x": 19.385826771653544,
          "y": 56.59286226291261
        },
        {
          "x": 20.141732283464567,
          "y": 56.653975269838504
        },
        {
          "x": 20.897637795275593,
          "y": 56.846025522298746
        },
        {
          "x": 21.653543307086615,
          "y": 57.11352396866214
        },
        {
          "x": 22.409448818897637,
          "y": 57.37918232155925
        },
        {
          "x": 23.16535433070866,
          "y": 57.56624395155936
        },
        {
          "x": 23.921259842519685,
          "y": 57.62066116899625
        },
        {
          "x": 24.677165354330707,
          "y": 57.52671121511642
        },
        {
          "x": 25.433070866141733,
          "y": 57.31153903648882
        },
        {
          "x": 26.188976377952756,
          "y": 57.03731429952372
        },
        {
          "x": 26.944881889763778,
          "y": 56.78326871776004
        },
        {
          "x": 27.700787401574807,
          "y": 56.622803644346625
        },
        {
          "x": 28.45669291338583,
          "y": 56.602282229706745
        },
        {
          "x": 29.212598425196852,
          "y": 56.72763372320044
        },
        {
          "x": 29.968503937007874,
          "y": 56.962640335965624
        },
        {
          "x": 30.7244094488189,
          "y": 57.239401641408996
        },
        {
          "x": 31.480314960629922,
          "y": 57.477953035628566
        },
        {
          "x": 32.23622047244095,
          "y": 57.609369898838764
        },
        {
          "x": 32.99212598425197,
          "y": 57.595681975783684
        },
        {
          "x": 33.74803149606299,
          "y": 57.44084411608937
        },
        {
          "x": 34.503937007874015,
          "y": 57.18959360013416
        },
        {
          "x": 35.25984251968504,
          "y": 56.91452420310762
        },
        {
          "x": 36.01574803149606,
          "y": 56.695111686057906
        },
        {
          "x": 36.77165354330709,
          "y": 56.59475087576151
        },
        {
          "x": 37.52755905511811,
          "y": 56.64243900660343
        },
        {
          "x": 38.28346456692913,
          "y": 56.82439755384556
        },
        {
          "x": 39.039370078740156,
          "y": 57.08805326078392
        },
        {
          "x": 39.795275590551185,
          "y": 57.357228122194655
        },
        {
          "x": 40.55118110236221,
          "y": 57.55414948435146
        },
        {
          "x": 41.30708661417323,
          "y": 57.62192088660394
        },
        {
          "x": 42.06299212598425,
          "y": 57.54096114751374
        },
        {
          "x": 42.818897637795274,
          "y": 57.33466195277184
        },
        {
          "x": 43.574803149606296,
          "y": 57.06262929883938
        },
        {
          "x": 44.33070866141732,
          "y": 56.80346154102211
        },
        {
          "x": 45.08661417322834,
          "y": 56.63203998205426
        },
        {
          "x": 45.84251968503937,
          "y": 56.59789342814366
        },
        {
          "x": 46.59842519685039,
          "y": 56.710887838166684
        },
        {
          "x": 47.354330708661415,
          "y": 56.9383757535989
        },
        {
          "x": 48.11023622047244,
          "y": 57.21462912397861
        },
        {
          "x": 48.86614173228347,
          "y": 57.45983010300819
        },
        {
          "x": 49.62204724409449,
          "y": 57.6031328073259
        },
        {
          "x": 50.37795275590551,
          "y": 57.603132807325906
        },
        {
          "x": 51.13385826771653,
          "y": 57.459830103008194
        },
        {
          "x": 51.889763779527556,
          "y": 57.21462912397862
        },
        {
          "x": 52.64566929133858,
          "y": 56.938375753598905
        },
        {
          "x": 53.401574803149614,
          "y": 56.710887838166684
        },
        {
          "x": 54.15748031496064,
          "y": 56.59789342814366
        },
        {
          "x": 54.91338582677166,
          "y": 56.63203998205426
        },
        {
          "x": 55.66929133858268,
          "y": 56.8034615410221
        },
        {
          "x": 56.425196850393704,
          "y": 57.062629298839376
        },
        {
          "x": 57.181102362204726,
          "y": 57.33466195277183
        },
        {
          "x": 57.93700787401575,
          "y": 57.540961147513734
        },
        {
          "x": 58.69291338582677,
          "y": 57.62192088660394
        },
        {
          "x": 59.4488188976378,
          "y": 57.55414948435146
        },
        {
          "x": 60.20472440944882,
          "y": 57.357228122194655
        },
        {
          "x": 60.960629921259844,
          "y": 57.08805326078392
        },
        {
          "x": 61.71653543307087,
          "y": 56.824397553845564
        },
        {
          "x": 62.47244094488189,
          "y": 56.64243900660344
        },
        {
          "x": 63.22834645669291,
          "y": 56.59475087576151
        },
        {
          "x": 63.98425196850393,
          "y": 56.6951116860579
        },
        {
          "x": 64.74015748031496,
          "y": 56.91452420310761
        },
        {
          "x": 65.49606299212599,
          "y": 57.18959360013415
        },
        {
          "x": 66.25196850393701,
          "y": 57.44084411608937
        },
        {
          "x": 67.00787401574803,
          "y": 57.595681975783684
        },
        {
          "x": 67.76377952755905,
          "y": 57.609369898838764
        },
        {
          "x": 68.51968503937007,
          "y": 57.477953035628566
        },
        {
          "x": 69.2755905511811,
          "y": 57.239401641409
        },
        {
          "x": 70.03149606299212,
          "y": 56.96264033596563
        },
        {
          "x": 70.78740157480314,
          "y": 56.72763372320045
        },
        {
          "x": 71.54330708661418,
          "y": 56.602282229706745
        },
        {
          "x": 72.2992125984252,
          "y": 56.622803644346625
        },
        {
          "x": 73.05511811023622,
          "y": 56.78326871776003
        },
        {
          "x": 73.81102362204724,
          "y": 57.037314299523715
        },
        {
          "x": 74.56692913385827,
          "y": 57.31153903648881
        },
        {
          "x": 75.32283464566929,
          "y": 57.526711215116414
        },
        {
          "x": 76.07874015748031,
          "y": 57.62066116899624
        },
        {
          "x": 76.83464566929133,
          "y": 57.56624395155936
        },
        {
          "x": 77.59055118110237,
          "y": 57.37918232155925
        },
        {
          "x": 78.34645669291339,
          "y": 57.11352396866214
        },
        {
          "x": 79.10236220472441,
          "y": 56.84602552229875
        },
        {
          "x": 79.85826771653544,
          "y": 56.653975269838504
        },
        {
          "x": 80.61417322834646,
          "y": 56.59286226291261
        },
        {
          "x": 81.37007874015748,
          "y": 56.68034387376195
        },
        {
          "x": 82.1259842519685,
          "y": 56.89114405323266
        },
        {
          "x": 82.88188976377953,
          "y": 57.16435633599772
        },
        {
          "x": 83.63779527559055,
          "y": 57.42104153676361
        },
        {
          "x": 84.39370078740157,
          "y": 57.587035637645435
        },
        {
          "x": 85.14960629921259,
          "y": 57.61437798711419
        },
        {
          "x": 85.90551181102362,
          "y": 57.49516856409749
        },
        {
          "x": 86.66141732283464,
          "y": 57.26385052992401
        },
        {
          "x": 87.41732283464566,
          "y": 56.98725857070868
        },
        {
          "x": 88.17322834645668,
          "y": 56.74530836117239
        },
        {
          "x": 88.9291338582677,
          "y": 56.60790654031793
        },
        {
          "x": 89.68503937007874,
          "y": 56.61475259634665
        },
        {
          "x": 90.44094488188976,
          "y": 56.763868499281614
        },
        {
          "x": 91.19685039370079,
          "y": 57.01217021288234
        },
        {
          "x": 91.95275590551181,
          "y": 57.28791595899647
        },
        {
          "x": 92.70866141732283,
          "y": 57.511434559131956
        },
        {
          "x": 93.46456692913385,
          "y": 57.61814481652094
        },
        {
          "x": 94.22047244094487,
          "y": 57.57721495194948
        },
        {
          "x": 94.9763779527559,
          "y": 57.400470825260875
        },
        {
          "x": 95.73228346456693,
          "y": 57.138979091383696
        },
        {
          "x": 96.48818897637796,
          "y": 56.868292519118626
        },
        {
          "x": 97.24409448818898,
          "y": 56.66662054059019
        },
        {
          "x": 98,
          "y": 56.59223221134906
        }
      ],
      [
        {
          "x": 2,
          "y": 57.484376508009824
        },
        {
          "x": 2.7559055118110236,
          "y": 57.46198055759567
        },
        {
          "x": 3.5118110236220472,
          "y": 57.397452040492105
        },
        {
          "x": 4.26771653543307,
          "y": 57.298453185150734
        },
        {
          "x": 5.0236220472440944,
          "y": 57.176739287991246
        },
        {
          "x": 5.7795275590551185,
          "y": 57.04676286904098
        },
        {
          "x": 6.535433070866142,
          "y": 56.92395755454803
        },
        {
          "x": 7.291338582677165,
          "y": 56.82290546133385
        },
        {
          "x": 8.047244094488189,
          "y": 56.75560569085739
        },
        {
          "x": 8.803149606299213,
          "y": 56.730049535019944
        },
        {
          "x": 9.559055118110237,
          "y": 56.74927157625362
        },
        {
          "x": 10.31496062992126,
          "y": 56.81098935592074
        },
        {
          "x": 11.070866141732283,
          "y": 56.9078743974258
        },
        {
          "x": 11.826771653543307,
          "y": 57.02842240228375
        },
        {
          "x": 12.58267716535433,
          "y": 57.158319290548725
        },
        {
          "x": 13.338582677165354,
          "y": 57.28214087958463
        },
        {
          "x": 14.094488188976378,
          "y": 57.38518437836167
        },
        {
          "x": 14.850393700787404,
          "y": 57.455214222457734
        },
        {
          "x": 15.606299212598426,
          "y": 57.48391494627744
        },
        {
          "x": 16.36220472440945,
          "y": 57.46787857591244
        },
        {
          "x": 17.118110236220474,
          "y": 57.40900929789585
        },
        {
          "x": 17.874015748031496,
          "y": 57.31429735277856
        },
        {
          "x": 18.62992125984252,
          "y": 57.19498900179762
        },
        {
          "x": 19.385826771653544,
          "y": 57.065251126239566
        },
        {
          "x": 20.141732283464567,
          "y": 56.94048902729486
        },
        {
          "x": 20.897637795275593,
          "y": 56.8355171737771
        },
        {
          "x": 21.653543307086615,
          "y": 56.76280010630717
        },
        {
          "x": 22.409448818897637,
          "y": 56.73097237606178
        },
        {
          "x": 23.16535433070866,
          "y": 56.74381326313571
        },
        {
          "x": 23.921259842519685,
          "y": 56.79979801824451
        },
        {
          "x": 24.677165354330707,
          "y": 56.892278914108715
        },
        {
          "x": 25.433070866141733,
          "y": 57.010274608163385
        },
        {
          "x": 26.188976377952756,
          "y": 57.139774086290466
        },
        {
          "x": 26.944881889763778,
          "y": 57.26540035502545
        },
        {
          "x": 27.700787401574807,
          "y": 57.3722363325295
        },
        {
          "x": 28.45669291338583,
          "y": 57.447596128854556
        },
        {
          "x": 29.212598425196852,
          "y": 57.482531390599206
        },
        {
          "x": 29.968503937007874,
          "y": 57.47289384396886
        },
        {
          "x": 30.7244094488189,
          "y": 57.419827868027376
        },
        {
          "x": 31.480314960629922,
          "y": 57.32963460913489
        },
        {
          "x": 32.23622047244095,
          "y": 57.21302377186002
        },
        {
          "x": 32.99212598425197,
          "y": 57.08384193001604
        },
        {
          "x": 33.74803149606299,
          "y": 56.957428360382266
        },
        {
          "x": 34.503937007874015,
          "y": 56.84879363027677
        },
        {
          "x": 35.25984251968504,
          "y": 56.770837216662784
        },
        {
          "x": 36.01574803149606,
          "y": 56.732815799798765
        },
        {
          "x": 36.77165354330709,
          "y": 56.73924410891053
        },
        {
          "x": 37.52755905511811,
          "y": 56.78935883538381
        },
        {
          "x": 38.28346456692913,
          "y": 56.87720926935782
        },
        {
          "x": 39.039370078740156,
          "y": 56.99236389737313
        },
        {
          "x": 39.795275590551185,
          "y": 57.121149058438924
        },
        {
          "x": 40.55118110236221,
          "y": 57.24827257834202
        },
        {
          "x": 41.30708661417323,
          "y": 57.35863958903347
        },
        {
          "x": 42.06299212598425,
          "y": 57.439144919537746
        },
        {
          "x": 42.818897637795274,
          "y": 57.4802292267677
        },
        {
          "x": 43.574803149606296,
          "y": 57.4770140885636
        },
        {
          "x": 44.33070866141732,
          "y": 57.429881276032695
        },
        {
          "x": 45.08661417322834,
          "y": 57.34442742138334
        },
        {
          "x": 45.84251968503937,
          "y": 57.230799464074
        },
        {
          "x": 46.59842519685039,
          "y": 57.102489785558284
        },
        {
          "x": 47.354330708661415,
          "y": 56.97473410042363
        },
        {
          "x": 48.11023622047244,
          "y": 56.86270234111905
        },
        {
          "x": 48.86614173228347,
          "y": 56.7796973537684
        },
        {
          "x": 49.62204724409449,
          "y": 56.73557529506413
        },
        {
          "x": 50.37795275590551,
          "y": 56.73557529506413
        },
        {
          "x": 51.13385826771653,
          "y": 56.7796973537684
        },
        {
          "x": 51.889763779527556,
          "y": 56.86270234111905
        },
        {
          "x": 52.64566929133858,
          "y": 56.97473410042363
        },
        {
          "x": 53.401574803149614,
          "y": 57.102489785558284
        },
        {
          "x": 54.15748031496064,
          "y": 57.230799464074
        },
        {
          "x": 54.91338582677166,
          "y": 57.34442742138334
        },
        {
          "x": 55.66929133858268,
          "y": 57.429881276032695
        },
        {
          "x": 56.425196850393704,
          "y": 57.4770140885636
        },
        {
          "x": 57.181102362204726,
          "y": 57.4802292267677
        },
        {
          "x": 57.93700787401575,
          "y": 57.439144919537746
        },
        {
          "x": 58.69291338582677,
          "y": 57.35863958903347
        },
        {
          "x": 59.4488188976378,
          "y": 57.24827257834202
        },
        {
          "x": 60.20472440944882,
          "y": 57.121149058438924
        },
        {
          "x": 60.960629921259844,
          "y": 56.99236389737314
        },
        {
          "x": 61.71653543307087,
          "y": 56.87720926935782
        },
        {
          "x": 62.47244094488189,
          "y": 56.78935883538381
        },
        {
          "x": 63.22834645669291,
          "y": 56.73924410891053
        },
        {
          "x": 63.98425196850393,
          "y": 56.732815799798765
        },
        {
          "x": 64.74015748031496,
          "y": 56.770837216662784
        },
        {
          "x": 65.49606299212599,
          "y": 56.84879363027677
        },
        {
          "x": 66.25196850393701,
          "y": 56.957428360382266
        },
        {
          "x": 67.00787401574803,
          "y": 57.08384193001604
        },
        {
          "x": 67.76377952755905,
          "y": 57.21302377186002
        },
        {
          "x": 68.51968503937007,
          "y": 57.32963460913489
        },
        {
          "x": 69.2755905511811,
          "y": 57.419827868027376
        },
        {
          "x": 70.03149606299212,
          "y": 57.47289384396886
        },
        {
          "x": 70.78740157480314,
          "y": 57.482531390599206
        },
        {
          "x": 71.54330708661418,
          "y": 57.447596128854556
        },
        {
          "x": 72.2992125984252,
          "y": 57.3722363325295
        },
        {
          "x": 73.05511811023622,
          "y": 57.26540035502545
        },
        {
          "x": 73.81102362204724,
          "y": 57.139774086290466
        },
        {
          "x": 74.56692913385827,
          "y": 57.010274608163385
        },
        {
          "x": 75.32283464566929,
          "y": 56.892278914108715
        },
        {
          "x": 76.07874015748031,
          "y": 56.79979801824451
        },
        {
          "x": 76.83464566929133,
          "y": 56.74381326313571
        },
        {
          "x": 77.59055118110237,
          "y": 56.73097237606178
        },
        {
          "x": 78.34645669291339,
          "y": 56.76280010630717
        },
        {
          "x": 79.10236220472441,
          "y": 56.8355171737771
        },
        {
          "x": 79.85826771653544,
          "y": 56.94048902729486
        },
        {
          "x": 80.61417322834646,
          "y": 57.065251126239566
        },
        {
          "x": 81.37007874015748,
          "y": 57.19498900179762
        },
        {
          "x": 82.1259842519685,
          "y": 57.31429735277856
        },
        {
          "x": 82.88188976377953,
          "y": 57.40900929789585
        },
        {
          "x": 83.63779527559055,
          "y": 57.46787857591244
        },
        {
          "x": 84.39370078740157,
          "y": 57.48391494627744
        },
        {
          "x": 85.14960629921259,
          "y": 57.455214222457734
        },
        {
          "x": 85.90551181102362,
          "y": 57.38518437836167
        },
        {
          "x": 86.66141732283464,
          "y": 57.28214087958463
        },
        {
          "x": 87.41732283464566,
          "y": 57.158319290548725
        },
        {
          "x": 88.17322834645668,
          "y": 57.02842240228376
        },
        {
          "x": 88.9291338582677,
          "y": 56.9078743974258
        },
        {
          "x": 89.68503937007874,
          "y": 56.81098935592074
        },
        {
          "x": 90.44094488188976,
          "y": 56.74927157625362
        },
        {
          "x": 91.19685039370079,
          "y": 56.730049535019944
        },
        {
          "x": 91.95275590551181,
          "y": 56.75560569085739
        },
        {
          "x": 92.70866141732283,
          "y": 56.822905461333846
        },
        {
          "x": 93.46456692913385,
          "y": 56.92395755454803
        },
        {
          "x": 94.22047244094487,
          "y": 57.04676286904098
        },
        {
          "x": 94.9763779527559,
          "y": 57.176739287991246
        },
        {
          "x": 95.73228346456693,
          "y": 57.298453185150734
        },
        {
          "x": 96.48818897637796,
          "y": 57.397452040492105
        },
        {
          "x": 97.24409448818898,
          "y": 57.46198055759567
        },
        {
          "x": 98,
          "y": 57.484376508009824
        }
      ],
      [
        {
          "x": 2,
          "y": 56.46653677916718
        },
        {
          "x": 2.7559055118110236,
          "y": 56.46732062962349
        },
        {
          "x": 3.5118110236220472,
          "y": 56.469670262779005
        },
        {
          "x": 4.26771653543307,
          "y": 56.47357992868767
        },
        {
          "x": 5.0236220472440944,
          "y": 56.479040059741855
        },
        {
          "x": 5.7795275590551185,
          "y": 56.486037294085904
        },
        {
          "x": 6.535433070866142,
          "y": 56.494554508314835
        },
        {
          "x": 7.291338582677165,
          "y": 56.504570859378205
        },
        {
          "x": 8.047244094488189,
          "y": 56.51606183558649
        },
        {
          "x": 8.803149606299213,
          "y": 56.52899931659535
        },
        {
          "x": 9.559055118110237,
          "y": 56.54335164222082
        },
        {
          "x": 10.31496062992126,
          "y": 56.55908368991704
        },
        {
          "x": 11.070866141732283,
          "y": 56.576156960727054
        },
        {
          "x": 11.826771653543307,
          "y": 56.594529673496204
        },
        {
          "x": 12.58267716535433,
          "y": 56.61415686711759
        },
        {
          "x": 13.338582677165354,
          "y": 56.634990510559476
        },
        {
          "x": 14.094488188976378,
          "y": 56.65697962040523
        },
        {
          "x": 14.850393700787404,
          "y": 56.68007038561831
        },
        {
          "x": 15.606299212598426,
          "y": 56.70420629922689
        },
        {
          "x": 16.36220472440945,
          "y": 56.72932829660587
        },
        {
          "x": 17.118110236220474,
          "y": 56.75537490001794
        },
        {
          "x": 17.874015748031496,
          "y": 56.78228236905989
        },
        {
          "x": 18.62992125984252,
          "y": 56.80998485664604
        },
        {
          "x": 19.385826771653544,
          "y": 56.83841457014712
        },
        {
          "x": 20.141732283464567,
          "y": 56.867501937290186
        },
        {
          "x": 20.897637795275593,
          "y": 56.897175776413626
        },
        {
          "x": 21.653543307086615,
          "y": 56.927363470660616
        },
        {
          "x": 22.409448818897637,
          "y": 56.957991145684744
        },
        {
          "x": 23.16535433070866,
          "y": 56.98898385043289
        },
        {
          "x": 23.921259842519685,
          "y": 57.02026574056304
        },
        {
          "x": 24.677165354330707,
          "y": 57.051760264048106
        },
        {
          "x": 25.433070866141733,
          "y": 57.08339034851153
        },
        {
          "x": 26.188976377952756,
          "y": 57.11507858983632
        },
        {
          "x": 26.944881889763778,
          "y": 57.14674744158593
        },
        {
          "x": 27.700787401574807,
          "y": 57.17831940477331
        },
        {
          "x": 28.45669291338583,
          "y": 57.209717217514
        },
        {
          "x": 29.212598425196852,
          "y": 57.240864044098835
        },
        {
          "x": 29.968503937007874,
          "y": 57.271683663023836
        },
        {
          "x": 30.7244094488189,
          "y": 57.30210065351702
        },
        {
          "x": 31.480314960629922,
          "y": 57.33204058010562
        },
        {
          "x": 32.23622047244095,
          "y": 57.361430174772195
        },
        {
          "x": 32.99212598425197,
          "y": 57.39019751625374
        },
        {
          "x": 33.74803149606299,
          "y": 57.418272206045074
        },
        {
          "x": 34.503937007874015,
          "y": 57.445585540675744
        },
        {
          "x": 35.25984251968504,
          "y": 57.472070679838986
        },
        {
          "x": 36.01574803149606,
          "y": 57.4976628099611
        },
        {
          "x": 36.77165354330709,
          "y": 57.52229930281118
        },
        {
          "x": 37.52755905511811,
          "y": 57.54591986876284
        },
        {
          "x": 38.28346456692913,
          "y": 57.56846670433306
        },
        {
          "x": 39.039370078740156,
          "y": 57.589884633637006
        },
        {
          "x": 39.795275590551185,
          "y": 57.61012124341263
        },
        {
          "x": 40.55118110236221,
          "y": 57.62912701128472
        },
        {
          "x": 41.30708661417323,
          "y": 57.646855426954495
        },
        {
          "x": 42.06299212598425,
          "y": 57.663263106018015
        },
        {
          "x": 42.818897637795274,
          "y": 57.67830989613516
        },
        {
          "x": 43.574803149606296,
          "y": 57.69195897528909
        },
        {
          "x": 44.33070866141732,
          "y": 57.70417694189594
        },
        {
          "x": 45.08661417322834,
          "y": 57.71493389654401
        },
        {
          "x": 45.84251968503937,
          "y": 57.72420351516275
        },
        {
          "x": 46.59842519685039,
          "y": 57.73196311344205
        },
        {
          "x": 47.354330708661415,
          "y": 57.73819370234465
        },
        {
          "x": 48.11023622047244,
          "y": 57.74288003457543
        },
        {
          "x": 48.86614173228347,
          "y": 57.746010641894124
        },
        {
          "x": 49.62204724409449,
          "y": 57.74757786318003
        },
        {
          "x": 50.37795275590551,
          "y": 57.74757786318003
        },
        {
          "x": 51.13385826771653,
          "y": 57.746010641894124
        },
        {
          "x": 51.889763779527556,
          "y": 57.74288003457543
        },
        {
          "x": 52.64566929133858,
          "y": 57.73819370234465
        },
        {
          "x": 53.401574803149614,
          "y": 57.73196311344205
        },
        {
          "x": 54.15748031496064,
          "y": 57.72420351516275
        },
        {
          "x": 54.91338582677166,
          "y": 57.71493389654401
        },
        {
          "x": 55.66929133858268,
          "y": 57.70417694189594
        },
        {
          "x": 56.425196850393704,
          "y": 57.69195897528909
        },
        {
          "x": 57.181102362204726,
          "y": 57.67830989613516
        },
        {
          "x": 57.93700787401575,
          "y": 57.663263106018015
        },
        {
          "x": 58.69291338582677,
          "y": 57.646855426954495
        },
        {
          "x": 59.4488188976378,
          "y": 57.62912701128472
        },
        {
          "x": 60.20472440944882,
          "y": 57.61012124341263
        },
        {
          "x": 60.960629921259844,
          "y": 57.589884633637006
        },
        {
          "x": 61.71653543307087,
          "y": 57.56846670433306
        },
        {
          "x": 62.47244094488189,
          "y": 57.54591986876284
        },
        {
          "x": 63.22834645669291,
          "y": 57.52229930281118
        },
        {
          "x": 63.98425196850393,
          "y": 57.4976628099611
        },
        {
          "x": 64.74015748031496,
          "y": 57.472070679838986
        },
        {
          "x": 65.49606299212599,
          "y": 57.445585540675744
        },
        {
          "x": 66.25196850393701,
          "y": 57.418272206045074
        },
        {
          "x": 67.00787401574803,
          "y": 57.39019751625374
        },
        {
          "x": 67.76377952755905,
          "y": 57.361430174772195
        },
        {
          "x": 68.51968503937007,
          "y": 57.33204058010562
        },
        {
          "x": 69.2755905511811,
          "y": 57.30210065351702
        },
        {
          "x": 70.03149606299212,
          "y": 57.271683663023836
        },
        {
          "x": 70.78740157480314,
          "y": 57.240864044098835
        },
        {
          "x": 71.54330708661418,
          "y": 57.209717217514
        },
        {
          "x": 72.2992125984252,
          "y": 57.17831940477331
        },
        {
          "x": 73.05511811023622,
          "y": 57.14674744158593
        },
        {
          "x": 73.81102362204724,
          "y": 57.11507858983632
        },
        {
          "x": 74.56692913385827,
          "y": 57.08339034851153
        },
        {
          "x": 75.32283464566929,
          "y": 57.051760264048106
        },
        {
          "x": 76.07874015748031,
          "y": 57.02026574056304
        },
        {
          "x": 76.83464566929133,
          "y": 56.98898385043289
        },
        {
          "x": 77.59055118110237,
          "y": 56.957991145684744
        },
        {
          "x": 78.34645669291339,
          "y": 56.927363470660616
        },
        {
          "x": 79.10236220472441,
          "y": 56.897175776413626
        },
        {
          "x": 79.85826771653544,
          "y": 56.867501937290186
        },
        {
          "x": 80.61417322834646,
          "y": 56.83841457014712
        },
        {
          "x": 81.37007874015748,
          "y": 56.80998485664604
        },
        {
          "x": 82.1259842519685,
          "y": 56.78228236905989
        },
        {
          "x": 82.88188976377953,
          "y": 56.75537490001795
        },
        {
          "x": 83.63779527559055,
          "y": 56.72932829660587
        },
        {
          "x": 84.39370078740157,
          "y": 56.70420629922689
        },
        {
          "x": 85.14960629921259,
          "y": 56.68007038561831
        },
        {
          "x": 85.90551181102362,
          "y": 56.65697962040523
        },
        {
          "x": 86.66141732283464,
          "y": 56.634990510559476
        },
        {
          "x": 87.41732283464566,
          "y": 56.61415686711759
        },
        {
          "x": 88.17322834645668,
          "y": 56.594529673496204
        },
        {
          "x": 88.9291338582677,
          "y": 56.576156960727054
        },
        {
          "x": 89.68503937007874,
          "y": 56.55908368991704
        },
        {
          "x": 90.44094488188976,
          "y": 56.54335164222082
        },
        {
          "x": 91.19685039370079,
          "y": 56.52899931659535
        },
        {
          "x": 91.95275590551181,
          "y": 56.51606183558649
        },
        {
          "x": 92.70866141732283,
          "y": 56.504570859378205
        },
        {
          "x": 93.46456692913385,
          "y": 56.494554508314835
        },
        {
          "x": 94.22047244094487,
          "y": 56.486037294085904
        },
        {
          "x": 94.9763779527559,
          "y": 56.479040059741855
        },
        {
          "x": 95.73228346456693,
          "y": 56.47357992868767
        },
        {
          "x": 96.48818897637796,
          "y": 56.469670262779005
        },
        {
          "x": 97.24409448818898,
          "y": 56.46732062962349
        },
        {
          "x": 98,
          "y": 56.46653677916718
        }
      ]
    ],
    "componentWidths": [
      1.2,
      0.633,
      0.617,
      0.459,
      0.481,
      0.464,
      0.494,
      0.421,
      0.973,
      0.512,
      0.491,
      0.538
    ],
    "partialSums": [
      [
        {
          "x": 2,
          "y": 81.71710495771373
        },
        {
          "x": 2.7559055118110236,
          "y": 81.5967293062537
        },
        {
          "x": 3.5118110236220472,
          "y": 81.23677994855109
        },
        {
          "x": 4.26771653543307,
          "y": 80.64077815458486
        },
        {
          "x": 5.0236220472440944,
          "y": 79.81455442017227
        },
        {
          "x": 5.7795275590551185,
          "y": 78.76619142908433
        },
        {
          "x": 6.535433070866142,
          "y": 77.50594498272365
        },
        {
          "x": 7.291338582677165,
          "y": 76.04614367088404
        },
        {
          "x": 8.047244094488189,
          "y": 74.40106826508139
        },
        {
          "x": 8.803149606299213,
          "y": 72.5868120143121
        },
        {
          "x": 9.559055118110237,
          "y": 70.62112320992127
        },
        {
          "x": 10.31496062992126,
          "y": 68.52323155971855
        },
        {
          "x": 11.070866141732283,
          "y": 66.31366006986833
        },
        {
          "x": 11.826771653543307,
          "y": 64.01402427485371
        },
        {
          "x": 12.58267716535433,
          "y": 61.64682077958388
        },
        {
          "x": 13.338582677165354,
          "y": 59.23520718226988
        },
        {
          "x": 14.094488188976378,
          "y": 56.80277553101343
        },
        {
          "x": 14.850393700787404,
          "y": 54.373321530310655
        },
        {
          "x": 15.606299212598426,
          "y": 51.970611755250246
        },
        {
          "x": 16.36220472440945,
          "y": 49.61815115067525
        },
        {
          "x": 17.118110236220474,
          "y": 47.338953089790394
        },
        {
          "x": 17.874015748031496,
          "y": 45.15531424165803
        },
        {
          "x": 18.62992125984252,
          "y": 43.08859644998287
        },
        {
          "x": 19.385826771653544,
          "y": 41.15901775699527
        },
        {
          "x": 20.141732283464567,
          "y": 39.385454616780464
        },
        {
          "x": 20.897637795275593,
          "y": 37.785257232937354
        },
        {
          "x": 21.653543307086615,
          "y": 36.37407982706013
        },
        {
          "x": 22.409448818897637,
          "y": 35.165727498471725
        },
        {
          "x": 23.16535433070866,
          "y": 34.17202117333196
        },
        {
          "x": 23.921259842519685,
          "y": 33.402681964280006
        },
        {
          "x": 24.677165354330707,
          "y": 32.86523607188413
        },
        {
          "x": 25.433070866141733,
          "y": 32.564941158217344
        },
        {
          "x": 26.188976377952756,
          "y": 32.50473491282324
        },
        {
          "x": 26.944881889763778,
          "y": 32.685206314234236
        },
        {
          "x": 27.700787401574807,
          "y": 33.10458986818219
        },
        {
          "x": 28.45669291338583,
          "y": 33.758782878866725
        },
        {
          "x": 29.212598425196852,
          "y": 34.64138558432222
        },
        {
          "x": 29.968503937007874,
          "y": 35.74376376325179
        },
        {
          "x": 30.7244094488189,
          "y": 37.05513320086559
        },
        {
          "x": 31.480314960629922,
          "y": 38.562665187420976
        },
        {
          "x": 32.23622047244095,
          "y": 40.251612017406075
        },
        {
          "x": 32.99212598425197,
          "y": 42.10545126164791
        },
        {
          "x": 33.74803149606299,
          "y": 44.10604740097719
        },
        {
          "x": 34.503937007874015,
          "y": 46.23382924023906
        },
        {
          "x": 35.25984251968504,
          "y": 48.467981367064915
        },
        {
          "x": 36.01574803149606,
          "y": 50.78664778242522
        },
        {
          "x": 36.77165354330709,
          "y": 53.167145710910205
        },
        {
          "x": 37.52755905511811,
          "y": 55.58618749910086
        },
        {
          "x": 38.28346456692913,
          "y": 58.02010843126883
        },
        {
          "x": 39.039370078740156,
          "y": 60.445098233756966
        },
        {
          "x": 39.795275590551185,
          "y": 62.83743400330655
        },
        {
          "x": 40.55118110236221,
          "y": 65.17371228066791
        },
        {
          "x": 41.30708661417323,
          "y": 67.43107799919201
        },
        {
          "x": 42.06299212598425,
          "y": 69.58744806867155
        },
        {
          "x": 42.818897637795274,
          "y": 71.62172740718259
        },
        {
          "x": 43.574803149606296,
          "y": 73.5140153075555
        },
        {
          "x": 44.33070866141732,
          "y": 75.24580011965794
        },
        {
          "x": 45.08661417322834,
          "y": 76.80014034397504
        },
        {
          "x": 45.84251968503937,
          "y": 78.16183036490602
        },
        {
          "x": 46.59842519685039,
          "y": 79.31754920246084
        },
        {
          "x": 47.354330708661415,
          "y": 80.25599082716695
        },
        {
          "x": 48.11023622047244,
          "y": 80.9679747633564
        },
        {
          "x": 48.86614173228347,
          "y": 81.44653589883667
        },
        {
          "x": 49.62204724409449,
          "y": 81.68699262236608
        },
        {
          "x": 50.37795275590551,
          "y": 81.68699262236608
        },
        {
          "x": 51.13385826771653,
          "y": 81.44653589883669
        },
        {
          "x": 51.889763779527556,
          "y": 80.96797476335641
        },
        {
          "x": 52.64566929133858,
          "y": 80.25599082716697
        },
        {
          "x": 53.401574803149614,
          "y": 79.31754920246084
        },
        {
          "x": 54.15748031496064,
          "y": 78.16183036490602
        },
        {
          "x": 54.91338582677166,
          "y": 76.80014034397506
        },
        {
          "x": 55.66929133858268,
          "y": 75.24580011965796
        },
        {
          "x": 56.425196850393704,
          "y": 73.5140153075555
        },
        {
          "x": 57.181102362204726,
          "y": 71.6217274071826
        },
        {
          "x": 57.93700787401575,
          "y": 69.58744806867156
        },
        {
          "x": 58.69291338582677,
          "y": 67.43107799919204
        },
        {
          "x": 59.4488188976378,
          "y": 65.17371228066793
        },
        {
          "x": 60.20472440944882,
          "y": 62.83743400330654
        },
        {
          "x": 60.960629921259844,
          "y": 60.44509823375697
        },
        {
          "x": 61.71653543307087,
          "y": 58.02010843126884
        },
        {
          "x": 62.47244094488189,
          "y": 55.58618749910087
        },
        {
          "x": 63.22834645669291,
          "y": 53.16714571091022
        },
        {
          "x": 63.98425196850393,
          "y": 50.786647782425234
        },
        {
          "x": 64.74015748031496,
          "y": 48.46798136706493
        },
        {
          "x": 65.49606299212599,
          "y": 46.233829240239054
        },
        {
          "x": 66.25196850393701,
          "y": 44.10604740097718
        },
        {
          "x": 67.00787401574803,
          "y": 42.1054512616479
        },
        {
          "x": 67.76377952755905,
          "y": 40.2516120174061
        },
        {
          "x": 68.51968503937007,
          "y": 38.562665187421
        },
        {
          "x": 69.2755905511811,
          "y": 37.0551332008656
        },
        {
          "x": 70.03149606299212,
          "y": 35.7437637632518
        },
        {
          "x": 70.78740157480314,
          "y": 34.64138558432224
        },
        {
          "x": 71.54330708661418,
          "y": 33.75878287886672
        },
        {
          "x": 72.2992125984252,
          "y": 33.10458986818218
        },
        {
          "x": 73.05511811023622,
          "y": 32.685206314234236
        },
        {
          "x": 73.81102362204724,
          "y": 32.50473491282324
        },
        {
          "x": 74.56692913385827,
          "y": 32.564941158217344
        },
        {
          "x": 75.32283464566929,
          "y": 32.86523607188412
        },
        {
          "x": 76.07874015748031,
          "y": 33.402681964280006
        },
        {
          "x": 76.83464566929133,
          "y": 34.17202117333194
        },
        {
          "x": 77.59055118110237,
          "y": 35.165727498471725
        },
        {
          "x": 78.34645669291339,
          "y": 36.374079827060136
        },
        {
          "x": 79.10236220472441,
          "y": 37.78525723293734
        },
        {
          "x": 79.85826771653544,
          "y": 39.38545461678044
        },
        {
          "x": 80.61417322834646,
          "y": 41.15901775699526
        },
        {
          "x": 81.37007874015748,
          "y": 43.08859644998286
        },
        {
          "x": 82.1259842519685,
          "y": 45.15531424165803
        },
        {
          "x": 82.88188976377953,
          "y": 47.33895308979035
        },
        {
          "x": 83.63779527559055,
          "y": 49.61815115067527
        },
        {
          "x": 84.39370078740157,
          "y": 51.97061175525026
        },
        {
          "x": 85.14960629921259,
          "y": 54.37332153031063
        },
        {
          "x": 85.90551181102362,
          "y": 56.80277553101341
        },
        {
          "x": 86.66141732283464,
          "y": 59.23520718226987
        },
        {
          "x": 87.41732283464566,
          "y": 61.64682077958387
        },
        {
          "x": 88.17322834645668,
          "y": 64.01402427485367
        },
        {
          "x": 88.9291338582677,
          "y": 66.31366006986829
        },
        {
          "x": 89.68503937007874,
          "y": 68.52323155971857
        },
        {
          "x": 90.44094488188976,
          "y": 70.62112320992128
        },
        {
          "x": 91.19685039370079,
          "y": 72.58681201431209
        },
        {
          "x": 91.95275590551181,
          "y": 74.40106826508139
        },
        {
          "x": 92.70866141732283,
          "y": 76.04614367088404
        },
        {
          "x": 93.46456692913385,
          "y": 77.50594498272365
        },
        {
          "x": 94.22047244094487,
          "y": 78.76619142908432
        },
        {
          "x": 94.9763779527559,
          "y": 79.81455442017224
        },
        {
          "x": 95.73228346456693,
          "y": 80.64077815458486
        },
        {
          "x": 96.48818897637796,
          "y": 81.23677994855109
        },
        {
          "x": 97.24409448818898,
          "y": 81.59672930625369
        },
        {
          "x": 98,
          "y": 81.71710495771373
        }
      ],
      [
        {
          "x": 2,
          "y": 80.02575992123901
        },
        {
          "x": 2.7559055118110236,
          "y": 79.9568690413621
        },
        {
          "x": 3.5118110236220472,
          "y": 79.74823959159315
        },
        {
          "x": 4.26771653543307,
          "y": 79.39418044499872
        },
        {
          "x": 5.0236220472440944,
          "y": 78.88579256360194
        },
        {
          "x": 5.7795275590551185,
          "y": 78.21180869849826
        },
        {
          "x": 6.535433070866142,
          "y": 77.35969234866695
        },
        {
          "x": 7.291338582677165,
          "y": 76.31692503326532
        },
        {
          "x": 8.047244094488189,
          "y": 75.07239838133864
        },
        {
          "x": 8.803149606299213,
          "y": 73.61782012543758
        },
        {
          "x": 9.559055118110237,
          "y": 71.94904126332142
        },
        {
          "x": 10.31496062992126,
          "y": 70.06721554522869
        },
        {
          "x": 11.070866141732283,
          "y": 67.97971182495192
        },
        {
          "x": 11.826771653543307,
          "y": 65.70071411815502
        },
        {
          "x": 12.58267716535433,
          "y": 63.251462577355866
        },
        {
          "x": 13.338582677165354,
          "y": 60.66010990796343
        },
        {
          "x": 14.094488188976378,
          "y": 57.96119072138962
        },
        {
          "x": 14.850393700787404,
          "y": 55.19472455533985
        },
        {
          "x": 15.606299212598426,
          "y": 52.40499537665842
        },
        {
          "x": 16.36220472440945,
          "y": 49.63906997613221
        },
        {
          "x": 17.118110236220474,
          "y": 46.945133575545796
        },
        {
          "x": 17.874015748031496,
          "y": 44.37073222622927
        },
        {
          "x": 18.62992125984252,
          "y": 41.96101749862297
        },
        {
          "x": 19.385826771653544,
          "y": 39.757089181164325
        },
        {
          "x": 20.141732283464567,
          "y": 37.79452620726147
        },
        {
          "x": 20.897637795275593,
          "y": 36.10218514149445
        },
        {
          "x": 21.653543307086615,
          "y": 34.70132993772895
        },
        {
          "x": 22.409448818897637,
          "y": 33.60513727683219
        },
        {
          "x": 23.16535433070866,
          "y": 32.818599774066556
        },
        {
          "x": 23.921259842519685,
          "y": 32.3388260481459
        },
        {
          "x": 24.677165354330707,
          "y": 32.155713474725935
        },
        {
          "x": 25.433070866141733,
          "y": 32.252947807607455
        },
        {
          "x": 26.188976377952756,
          "y": 32.609265048310874
        },
        {
          "x": 26.944881889763778,
          "y": 33.1998961129056
        },
        {
          "x": 27.700787401574807,
          "y": 33.99810487592024
        },
        {
          "x": 28.45669291338583,
          "y": 34.976725660390784
        },
        {
          "x": 29.212598425196852,
          "y": 36.1096074537571
        },
        {
          "x": 29.968503937007874,
          "y": 37.37287897617395
        },
        {
          "x": 30.7244094488189,
          "y": 38.74596078259386
        },
        {
          "x": 31.480314960629922,
          "y": 40.212267097574035
        },
        {
          "x": 32.23622047244095,
          "y": 41.759560045635666
        },
        {
          "x": 32.99212598425197,
          "y": 43.37994112424098
        },
        {
          "x": 33.74803149606299,
          "y": 45.069487810472545
        },
        {
          "x": 34.503937007874015,
          "y": 46.82756568398895
        },
        {
          "x": 35.25984251968504,
          "y": 48.65586700982544
        },
        {
          "x": 36.01574803149606,
          "y": 50.55724409546018
        },
        {
          "x": 36.77165354330709,
          "y": 52.534418852713586
        },
        {
          "x": 37.52755905511811,
          "y": 54.588658051891244
        },
        {
          "x": 38.28346456692913,
          "y": 56.71850625752779
        },
        {
          "x": 39.039370078740156,
          "y": 58.918665225779655
        },
        {
          "x": 39.795275590551185,
          "y": 61.17909981537146
        },
        {
          "x": 40.55118110236221,
          "y": 63.48443674655592
        },
        {
          "x": 41.30708661417323,
          "y": 65.81370467020588
        },
        {
          "x": 42.06299212598425,
          "y": 68.14044307042337
        },
        {
          "x": 42.818897637795274,
          "y": 70.43318479524093
        },
        {
          "x": 43.574803149606296,
          "y": 72.65629387752148
        },
        {
          "x": 44.33070866141732,
          "y": 74.7711181841229
        },
        {
          "x": 45.08661417322834,
          "y": 76.73739666753002
        },
        {
          "x": 45.84251968503937,
          "y": 78.51484479953909
        },
        {
          "x": 46.59842519685039,
          "y": 80.0648301339352
        },
        {
          "x": 47.354330708661415,
          "y": 81.35204359030708
        },
        {
          "x": 48.11023622047244,
          "y": 82.34607136956579
        },
        {
          "x": 48.86614173228347,
          "y": 83.02277745408715
        },
        {
          "x": 49.62204724409449,
          "y": 83.36541711455276
        },
        {
          "x": 50.37795275590551,
          "y": 83.36541711455276
        },
        {
          "x": 51.13385826771653,
          "y": 83.02277745408716
        },
        {
          "x": 51.889763779527556,
          "y": 82.3460713695658
        },
        {
          "x": 52.64566929133858,
          "y": 81.35204359030709
        },
        {
          "x": 53.401574803149614,
          "y": 80.06483013393522
        },
        {
          "x": 54.15748031496064,
          "y": 78.5148447995391
        },
        {
          "x": 54.91338582677166,
          "y": 76.73739666753004
        },
        {
          "x": 55.66929133858268,
          "y": 74.77111818412293
        },
        {
          "x": 56.425196850393704,
          "y": 72.65629387752148
        },
        {
          "x": 57.181102362204726,
          "y": 70.43318479524096
        },
        {
          "x": 57.93700787401575,
          "y": 68.14044307042339
        },
        {
          "x": 58.69291338582677,
          "y": 65.81370467020591
        },
        {
          "x": 59.4488188976378,
          "y": 63.484436746555936
        },
        {
          "x": 60.20472440944882,
          "y": 61.17909981537145
        },
        {
          "x": 60.960629921259844,
          "y": 58.91866522577966
        },
        {
          "x": 61.71653543307087,
          "y": 56.71850625752779
        },
        {
          "x": 62.47244094488189,
          "y": 54.58865805189125
        },
        {
          "x": 63.22834645669291,
          "y": 52.53441885271359
        },
        {
          "x": 63.98425196850393,
          "y": 50.55724409546018
        },
        {
          "x": 64.74015748031496,
          "y": 48.65586700982544
        },
        {
          "x": 65.49606299212599,
          "y": 46.82756568398894
        },
        {
          "x": 66.25196850393701,
          "y": 45.06948781047253
        },
        {
          "x": 67.00787401574803,
          "y": 43.379941124240965
        },
        {
          "x": 67.76377952755905,
          "y": 41.75956004563569
        },
        {
          "x": 68.51968503937007,
          "y": 40.212267097574056
        },
        {
          "x": 69.2755905511811,
          "y": 38.74596078259387
        },
        {
          "x": 70.03149606299212,
          "y": 37.37287897617396
        },
        {
          "x": 70.78740157480314,
          "y": 36.109607453757114
        },
        {
          "x": 71.54330708661418,
          "y": 34.97672566039078
        },
        {
          "x": 72.2992125984252,
          "y": 33.99810487592024
        },
        {
          "x": 73.05511811023622,
          "y": 33.199896112905606
        },
        {
          "x": 73.81102362204724,
          "y": 32.60926504831089
        },
        {
          "x": 74.56692913385827,
          "y": 32.25294780760746
        },
        {
          "x": 75.32283464566929,
          "y": 32.155713474725935
        },
        {
          "x": 76.07874015748031,
          "y": 32.338826048145904
        },
        {
          "x": 76.83464566929133,
          "y": 32.81859977406654
        },
        {
          "x": 77.59055118110237,
          "y": 33.605137276832195
        },
        {
          "x": 78.34645669291339,
          "y": 34.70132993772896
        },
        {
          "x": 79.10236220472441,
          "y": 36.10218514149444
        },
        {
          "x": 79.85826771653544,
          "y": 37.79452620726145
        },
        {
          "x": 80.61417322834646,
          "y": 39.75708918116432
        },
        {
          "x": 81.37007874015748,
          "y": 41.96101749862295
        },
        {
          "x": 82.1259842519685,
          "y": 44.37073222622926
        },
        {
          "x": 82.88188976377953,
          "y": 46.945133575545746
        },
        {
          "x": 83.63779527559055,
          "y": 49.63906997613222
        },
        {
          "x": 84.39370078740157,
          "y": 52.40499537665843
        },
        {
          "x": 85.14960629921259,
          "y": 55.194724555339825
        },
        {
          "x": 85.90551181102362,
          "y": 57.9611907213896
        },
        {
          "x": 86.66141732283464,
          "y": 60.66010990796341
        },
        {
          "x": 87.41732283464566,
          "y": 63.25146257735586
        },
        {
          "x": 88.17322834645668,
          "y": 65.70071411815498
        },
        {
          "x": 88.9291338582677,
          "y": 67.97971182495188
        },
        {
          "x": 89.68503937007874,
          "y": 70.06721554522872
        },
        {
          "x": 90.44094488188976,
          "y": 71.94904126332145
        },
        {
          "x": 91.19685039370079,
          "y": 73.61782012543756
        },
        {
          "x": 91.95275590551181,
          "y": 75.07239838133866
        },
        {
          "x": 92.70866141732283,
          "y": 76.31692503326533
        },
        {
          "x": 93.46456692913385,
          "y": 77.35969234866697
        },
        {
          "x": 94.22047244094487,
          "y": 78.21180869849826
        },
        {
          "x": 94.9763779527559,
          "y": 78.88579256360192
        },
        {
          "x": 95.73228346456693,
          "y": 79.39418044499874
        },
        {
          "x": 96.48818897637796,
          "y": 79.74823959159315
        },
        {
          "x": 97.24409448818898,
          "y": 79.95686904136208
        },
        {
          "x": 98,
          "y": 80.02575992123901
        }
      ],
      [
        {
          "x": 2,
          "y": 81.519036384471
        },
        {
          "x": 2.7559055118110236,
          "y": 81.4210004619845
        },
        {
          "x": 3.5118110236220472,
          "y": 81.12607356187608
        },
        {
          "x": 4.26771653543307,
          "y": 80.63193318040989
        },
        {
          "x": 5.0236220472440944,
          "y": 79.9351483542217
        },
        {
          "x": 5.7795275590551185,
          "y": 79.03180591400128
        },
        {
          "x": 6.535433070866142,
          "y": 77.91832237661741
        },
        {
          "x": 7.291338582677165,
          "y": 76.59238173612809
        },
        {
          "x": 8.047244094488189,
          "y": 75.05392929961985
        },
        {
          "x": 8.803149606299213,
          "y": 73.306146200218
        },
        {
          "x": 9.559055118110237,
          "y": 71.35632869430283
        },
        {
          "x": 10.31496062992126,
          "y": 69.21660088281502
        },
        {
          "x": 11.070866141732283,
          "y": 66.90439883440804
        },
        {
          "x": 11.826771653543307,
          "y": 64.44267766977414
        },
        {
          "x": 12.58267716535433,
          "y": 61.859810156316044
        },
        {
          "x": 13.338582677165354,
          "y": 59.189164702378314
        },
        {
          "x": 14.094488188976378,
          "y": 56.4683711152607
        },
        {
          "x": 14.850393700787404,
          "y": 53.73830280045748
        },
        {
          "x": 15.606299212598426,
          "y": 51.04182293375169
        },
        {
          "x": 16.36220472440945,
          "y": 48.42235831663451
        },
        {
          "x": 17.118110236220474,
          "y": 45.92237707043631
        },
        {
          "x": 17.874015748031496,
          "y": 43.581854202038066
        },
        {
          "x": 18.62992125984252,
          "y": 41.43681182935117
        },
        {
          "x": 19.385826771653544,
          "y": 39.51801824861903
        },
        {
          "x": 20.141732283464567,
          "y": 37.84992215145467
        },
        {
          "x": 20.897637795275593,
          "y": 36.44988558031719
        },
        {
          "x": 21.653543307086615,
          "y": 35.32776237559267
        },
        {
          "x": 22.409448818897637,
          "y": 34.485848907383755
        },
        {
          "x": 23.16535433070866,
          "y": 33.919211996114306
        },
        {
          "x": 23.921259842519685,
          "y": 33.616376435243005
        },
        {
          "x": 24.677165354330707,
          "y": 33.56033281459374
        },
        {
          "x": 25.433070866141733,
          "y": 33.729806748121746
        },
        {
          "x": 26.188976377952756,
          "y": 34.10071436267482
        },
        {
          "x": 26.944881889763778,
          "y": 34.647717038703206
        },
        {
          "x": 27.700787401574807,
          "y": 35.345781686007356
        },
        {
          "x": 28.45669291338583,
          "y": 36.17165175576041
        },
        {
          "x": 29.212598425196852,
          "y": 37.10513886348711
        },
        {
          "x": 29.968503937007874,
          "y": 38.13015510603394
        },
        {
          "x": 30.7244094488189,
          "y": 39.235421339342196
        },
        {
          "x": 31.480314960629922,
          "y": 40.414805975766235
        },
        {
          "x": 32.23622047244095,
          "y": 41.66727113494274
        },
        {
          "x": 32.99212598425197,
          "y": 42.9964269246698
        },
        {
          "x": 33.74803149606299,
          "y": 44.409718808685284
        },
        {
          "x": 34.503937007874015,
          "y": 45.91729597997048
        },
        {
          "x": 35.25984251968504,
          "y": 47.53062900492682
        },
        {
          "x": 36.01574803149606,
          "y": 49.26096148419634
        },
        {
          "x": 36.77165354330709,
          "y": 51.117692060216214
        },
        {
          "x": 37.52755905511811,
          "y": 53.10678904500991
        },
        {
          "x": 38.28346456692913,
          "y": 55.22933983112906
        },
        {
          "x": 39.039370078740156,
          "y": 57.480331029688976
        },
        {
          "x": 39.795275590551185,
          "y": 59.84774326199443
        },
        {
          "x": 40.55118110236221,
          "y": 62.312027373258346
        },
        {
          "x": 41.30708661417323,
          "y": 64.8460075070836
        },
        {
          "x": 42.06299212598425,
          "y": 67.41523220117328
        },
        {
          "x": 42.818897637795274,
          "y": 69.97876884483054
        },
        {
          "x": 43.574803149606296,
          "y": 72.49041098428387
        },
        {
          "x": 44.33070866141732,
          "y": 74.90024359106987
        },
        {
          "x": 45.08661417322834,
          "y": 77.15648996107426
        },
        {
          "x": 45.84251968503937,
          "y": 79.20754666216841
        },
        {
          "x": 46.59842519685039,
          "y": 81.00410093059321
        },
        {
          "x": 47.354330708661415,
          "y": 82.50121886124425
        },
        {
          "x": 48.11023622047244,
          "y": 83.6602930284706
        },
        {
          "x": 48.86614173228347,
          "y": 84.45074482464103
        },
        {
          "x": 49.62204724409449,
          "y": 84.85138945365206
        },
        {
          "x": 50.37795275590551,
          "y": 84.85138945365206
        },
        {
          "x": 51.13385826771653,
          "y": 84.45074482464105
        },
        {
          "x": 51.889763779527556,
          "y": 83.66029302847062
        },
        {
          "x": 52.64566929133858,
          "y": 82.50121886124427
        },
        {
          "x": 53.401574803149614,
          "y": 81.00410093059321
        },
        {
          "x": 54.15748031496064,
          "y": 79.20754666216843
        },
        {
          "x": 54.91338582677166,
          "y": 77.15648996107426
        },
        {
          "x": 55.66929133858268,
          "y": 74.9002435910699
        },
        {
          "x": 56.425196850393704,
          "y": 72.49041098428387
        },
        {
          "x": 57.181102362204726,
          "y": 69.97876884483057
        },
        {
          "x": 57.93700787401575,
          "y": 67.4152322011733
        },
        {
          "x": 58.69291338582677,
          "y": 64.84600750708363
        },
        {
          "x": 59.4488188976378,
          "y": 62.31202737325835
        },
        {
          "x": 60.20472440944882,
          "y": 59.84774326199442
        },
        {
          "x": 60.960629921259844,
          "y": 57.48033102968898
        },
        {
          "x": 61.71653543307087,
          "y": 55.22933983112906
        },
        {
          "x": 62.47244094488189,
          "y": 53.10678904500992
        },
        {
          "x": 63.22834645669291,
          "y": 51.11769206021622
        },
        {
          "x": 63.98425196850393,
          "y": 49.26096148419634
        },
        {
          "x": 64.74015748031496,
          "y": 47.53062900492682
        },
        {
          "x": 65.49606299212599,
          "y": 45.917295979970476
        },
        {
          "x": 66.25196850393701,
          "y": 44.40971880868528
        },
        {
          "x": 67.00787401574803,
          "y": 42.99642692466979
        },
        {
          "x": 67.76377952755905,
          "y": 41.66727113494276
        },
        {
          "x": 68.51968503937007,
          "y": 40.414805975766264
        },
        {
          "x": 69.2755905511811,
          "y": 39.23542133934221
        },
        {
          "x": 70.03149606299212,
          "y": 38.13015510603395
        },
        {
          "x": 70.78740157480314,
          "y": 37.10513886348713
        },
        {
          "x": 71.54330708661418,
          "y": 36.1716517557604
        },
        {
          "x": 72.2992125984252,
          "y": 35.345781686007356
        },
        {
          "x": 73.05511811023622,
          "y": 34.64771703870321
        },
        {
          "x": 73.81102362204724,
          "y": 34.100714362674836
        },
        {
          "x": 74.56692913385827,
          "y": 33.72980674812175
        },
        {
          "x": 75.32283464566929,
          "y": 33.56033281459374
        },
        {
          "x": 76.07874015748031,
          "y": 33.61637643524301
        },
        {
          "x": 76.83464566929133,
          "y": 33.91921199611429
        },
        {
          "x": 77.59055118110237,
          "y": 34.485848907383755
        },
        {
          "x": 78.34645669291339,
          "y": 35.32776237559267
        },
        {
          "x": 79.10236220472441,
          "y": 36.44988558031717
        },
        {
          "x": 79.85826771653544,
          "y": 37.84992215145464
        },
        {
          "x": 80.61417322834646,
          "y": 39.51801824861902
        },
        {
          "x": 81.37007874015748,
          "y": 41.43681182935114
        },
        {
          "x": 82.1259842519685,
          "y": 43.581854202038045
        },
        {
          "x": 82.88188976377953,
          "y": 45.922377070436255
        },
        {
          "x": 83.63779527559055,
          "y": 48.42235831663451
        },
        {
          "x": 84.39370078740157,
          "y": 51.04182293375169
        },
        {
          "x": 85.14960629921259,
          "y": 53.738302800457454
        },
        {
          "x": 85.90551181102362,
          "y": 56.46837111526068
        },
        {
          "x": 86.66141732283464,
          "y": 59.18916470237829
        },
        {
          "x": 87.41732283464566,
          "y": 61.85981015631604
        },
        {
          "x": 88.17322834645668,
          "y": 64.4426776697741
        },
        {
          "x": 88.9291338582677,
          "y": 66.904398834408
        },
        {
          "x": 89.68503937007874,
          "y": 69.21660088281504
        },
        {
          "x": 90.44094488188976,
          "y": 71.35632869430287
        },
        {
          "x": 91.19685039370079,
          "y": 73.30614620021798
        },
        {
          "x": 91.95275590551181,
          "y": 75.05392929961987
        },
        {
          "x": 92.70866141732283,
          "y": 76.5923817361281
        },
        {
          "x": 93.46456692913385,
          "y": 77.91832237661743
        },
        {
          "x": 94.22047244094487,
          "y": 79.03180591400128
        },
        {
          "x": 94.9763779527559,
          "y": 79.93514835422168
        },
        {
          "x": 95.73228346456693,
          "y": 80.63193318040992
        },
        {
          "x": 96.48818897637796,
          "y": 81.12607356187608
        },
        {
          "x": 97.24409448818898,
          "y": 81.42100046198449
        },
        {
          "x": 98,
          "y": 81.519036384471
        }
      ],
      [
        {
          "x": 2,
          "y": 81.1982110159521
        },
        {
          "x": 2.7559055118110236,
          "y": 81.15507349718517
        },
        {
          "x": 3.5118110236220472,
          "y": 81.00605380063574
        },
        {
          "x": 4.26771653543307,
          "y": 80.69889526303716
        },
        {
          "x": 5.0236220472440944,
          "y": 80.16617569239973
        },
        {
          "x": 5.7795275590551185,
          "y": 79.34783348777792
        },
        {
          "x": 6.535433070866142,
          "y": 78.211195338938
        },
        {
          "x": 7.291338582677165,
          "y": 76.76186949613727
        },
        {
          "x": 8.047244094488189,
          "y": 75.04202766944765
        },
        {
          "x": 8.803149606299213,
          "y": 73.11692830226825
        },
        {
          "x": 9.559055118110237,
          "y": 71.05455100715807
        },
        {
          "x": 10.31496062992126,
          "y": 68.90554148188998
        },
        {
          "x": 11.070866141732283,
          "y": 66.6905122974787
        },
        {
          "x": 11.826771653543307,
          "y": 64.39916288076128
        },
        {
          "x": 12.58267716535433,
          "y": 62.001559282045655
        },
        {
          "x": 13.338582677165354,
          "y": 59.46766661190634
        },
        {
          "x": 14.094488188976378,
          "y": 56.78831345634689
        },
        {
          "x": 14.850393700787404,
          "y": 53.99019096618207
        },
        {
          "x": 15.606299212598426,
          "y": 51.13945265493255
        },
        {
          "x": 16.36220472440945,
          "y": 48.332317548125964
        },
        {
          "x": 17.118110236220474,
          "y": 45.67548067256953
        },
        {
          "x": 17.874015748031496,
          "y": 43.26259809974299
        },
        {
          "x": 18.62992125984252,
          "y": 41.154455776459876
        },
        {
          "x": 19.385826771653544,
          "y": 39.36919360976362
        },
        {
          "x": 20.141732283464567,
          "y": 37.88556152679094
        },
        {
          "x": 20.897637795275593,
          "y": 36.65779202404527
        },
        {
          "x": 21.653543307086615,
          "y": 35.63678358491072
        },
        {
          "x": 22.409448818897637,
          "y": 34.79022783954064
        },
        {
          "x": 23.16535433070866,
          "y": 34.11478034560214
        },
        {
          "x": 23.921259842519685,
          "y": 33.63620439377065
        },
        {
          "x": 24.677165354330707,
          "y": 33.397634614082996
        },
        {
          "x": 25.433070866141733,
          "y": 33.44026296980171
        },
        {
          "x": 26.188976377952756,
          "y": 33.783416243065126
        },
        {
          "x": 26.944881889763778,
          "y": 34.411254246695734
        },
        {
          "x": 27.700787401574807,
          "y": 35.2710794294821
        },
        {
          "x": 28.45669291338583,
          "y": 36.28427556063832
        },
        {
          "x": 29.212598425196852,
          "y": 37.36654522470085
        },
        {
          "x": 29.968503937007874,
          "y": 38.45088232035831
        },
        {
          "x": 30.7244094488189,
          "y": 39.505706190874946
        },
        {
          "x": 31.480314960629922,
          "y": 40.542148255018134
        },
        {
          "x": 32.23622047244095,
          "y": 41.608090199340445
        },
        {
          "x": 32.99212598425197,
          "y": 42.7709764025981
        },
        {
          "x": 33.74803149606299,
          "y": 44.095155153429765
        },
        {
          "x": 34.503937007874015,
          "y": 45.621273038366525
        },
        {
          "x": 35.25984251968504,
          "y": 47.35445539252096
        },
        {
          "x": 36.01574803149606,
          "y": 49.264929503578244
        },
        {
          "x": 36.77165354330709,
          "y": 51.30044372694094
        },
        {
          "x": 37.52755905511811,
          "y": 53.405780833753425
        },
        {
          "x": 38.28346456692913,
          "y": 55.542247090925926
        },
        {
          "x": 39.039370078740156,
          "y": 57.700066785750295
        },
        {
          "x": 39.795275590551185,
          "y": 59.89910683861573
        },
        {
          "x": 40.55118110236221,
          "y": 62.17744049488832
        },
        {
          "x": 41.30708661417323,
          "y": 64.5715301521973
        },
        {
          "x": 42.06299212598425,
          "y": 67.09479938937335
        },
        {
          "x": 42.818897637795274,
          "y": 69.72204303796282
        },
        {
          "x": 43.574803149606296,
          "y": 72.38525204864085
        },
        {
          "x": 44.33070866141732,
          "y": 74.98264031226599
        },
        {
          "x": 45.08661417322834,
          "y": 77.3982435187589
        },
        {
          "x": 45.84251968503937,
          "y": 79.52592117749457
        },
        {
          "x": 46.59842519685039,
          "y": 81.29013835727491
        },
        {
          "x": 47.354330708661415,
          "y": 82.65702794958781
        },
        {
          "x": 48.11023622047244,
          "y": 83.63255087402771
        },
        {
          "x": 48.86614173228347,
          "y": 84.24894568905121
        },
        {
          "x": 49.62204724409449,
          "y": 84.54459552153627
        },
        {
          "x": 50.37795275590551,
          "y": 84.54459552153627
        },
        {
          "x": 51.13385826771653,
          "y": 84.24894568905123
        },
        {
          "x": 51.889763779527556,
          "y": 83.63255087402773
        },
        {
          "x": 52.64566929133858,
          "y": 82.65702794958783
        },
        {
          "x": 53.401574803149614,
          "y": 81.29013835727491
        },
        {
          "x": 54.15748031496064,
          "y": 79.52592117749458
        },
        {
          "x": 54.91338582677166,
          "y": 77.3982435187589
        },
        {
          "x": 55.66929133858268,
          "y": 74.98264031226601
        },
        {
          "x": 56.425196850393704,
          "y": 72.38525204864085
        },
        {
          "x": 57.181102362204726,
          "y": 69.72204303796285
        },
        {
          "x": 57.93700787401575,
          "y": 67.09479938937336
        },
        {
          "x": 58.69291338582677,
          "y": 64.57153015219733
        },
        {
          "x": 59.4488188976378,
          "y": 62.17744049488833
        },
        {
          "x": 60.20472440944882,
          "y": 59.899106838615715
        },
        {
          "x": 60.960629921259844,
          "y": 57.7000667857503
        },
        {
          "x": 61.71653543307087,
          "y": 55.542247090925926
        },
        {
          "x": 62.47244094488189,
          "y": 53.40578083375343
        },
        {
          "x": 63.22834645669291,
          "y": 51.30044372694095
        },
        {
          "x": 63.98425196850393,
          "y": 49.264929503578244
        },
        {
          "x": 64.74015748031496,
          "y": 47.35445539252096
        },
        {
          "x": 65.49606299212599,
          "y": 45.62127303836652
        },
        {
          "x": 66.25196850393701,
          "y": 44.09515515342976
        },
        {
          "x": 67.00787401574803,
          "y": 42.770976402598095
        },
        {
          "x": 67.76377952755905,
          "y": 41.60809019934047
        },
        {
          "x": 68.51968503937007,
          "y": 40.54214825501816
        },
        {
          "x": 69.2755905511811,
          "y": 39.50570619087495
        },
        {
          "x": 70.03149606299212,
          "y": 38.450882320358325
        },
        {
          "x": 70.78740157480314,
          "y": 37.366545224700864
        },
        {
          "x": 71.54330708661418,
          "y": 36.284275560638314
        },
        {
          "x": 72.2992125984252,
          "y": 35.2710794294821
        },
        {
          "x": 73.05511811023622,
          "y": 34.41125424669574
        },
        {
          "x": 73.81102362204724,
          "y": 33.78341624306514
        },
        {
          "x": 74.56692913385827,
          "y": 33.440262969801715
        },
        {
          "x": 75.32283464566929,
          "y": 33.397634614082996
        },
        {
          "x": 76.07874015748031,
          "y": 33.636204393770655
        },
        {
          "x": 76.83464566929133,
          "y": 34.11478034560213
        },
        {
          "x": 77.59055118110237,
          "y": 34.79022783954064
        },
        {
          "x": 78.34645669291339,
          "y": 35.63678358491072
        },
        {
          "x": 79.10236220472441,
          "y": 36.65779202404525
        },
        {
          "x": 79.85826771653544,
          "y": 37.88556152679091
        },
        {
          "x": 80.61417322834646,
          "y": 39.36919360976361
        },
        {
          "x": 81.37007874015748,
          "y": 41.15445577645985
        },
        {
          "x": 82.1259842519685,
          "y": 43.262598099742966
        },
        {
          "x": 82.88188976377953,
          "y": 45.67548067256947
        },
        {
          "x": 83.63779527559055,
          "y": 48.332317548125964
        },
        {
          "x": 84.39370078740157,
          "y": 51.13945265493255
        },
        {
          "x": 85.14960629921259,
          "y": 53.99019096618205
        },
        {
          "x": 85.90551181102362,
          "y": 56.78831345634687
        },
        {
          "x": 86.66141732283464,
          "y": 59.46766661190632
        },
        {
          "x": 87.41732283464566,
          "y": 62.00155928204565
        },
        {
          "x": 88.17322834645668,
          "y": 64.39916288076124
        },
        {
          "x": 88.9291338582677,
          "y": 66.69051229747866
        },
        {
          "x": 89.68503937007874,
          "y": 68.90554148189001
        },
        {
          "x": 90.44094488188976,
          "y": 71.05455100715811
        },
        {
          "x": 91.19685039370079,
          "y": 73.11692830226824
        },
        {
          "x": 91.95275590551181,
          "y": 75.04202766944766
        },
        {
          "x": 92.70866141732283,
          "y": 76.76186949613728
        },
        {
          "x": 93.46456692913385,
          "y": 78.21119533893801
        },
        {
          "x": 94.22047244094487,
          "y": 79.34783348777792
        },
        {
          "x": 94.9763779527559,
          "y": 80.16617569239972
        },
        {
          "x": 95.73228346456693,
          "y": 80.69889526303719
        },
        {
          "x": 96.48818897637796,
          "y": 81.00605380063574
        },
        {
          "x": 97.24409448818898,
          "y": 81.15507349718516
        },
        {
          "x": 98,
          "y": 81.1982110159521
        }
      ],
      [
        {
          "x": 2,
          "y": 80.77357441624095
        },
        {
          "x": 2.7559055118110236,
          "y": 80.77184044407298
        },
        {
          "x": 3.5118110236220472,
          "y": 80.73895740748856
        },
        {
          "x": 4.26771653543307,
          "y": 80.60002118600242
        },
        {
          "x": 5.0236220472440944,
          "y": 80.25480506484521
        },
        {
          "x": 5.7795275590551185,
          "y": 79.6066829650528
        },
        {
          "x": 6.535433070866142,
          "y": 78.58978747090369
        },
        {
          "x": 7.291338582677165,
          "y": 77.18637618136066
        },
        {
          "x": 8.047244094488189,
          "y": 75.42966714896038
        },
        {
          "x": 8.803149606299213,
          "y": 73.39210817887931
        },
        {
          "x": 9.559055118110237,
          "y": 71.1636092891686
        },
        {
          "x": 10.31496062992126,
          "y": 68.82721104506108
        },
        {
          "x": 11.070866141732283,
          "y": 66.44006812231636
        },
        {
          "x": 11.826771653543307,
          "y": 64.02544332497571
        },
        {
          "x": 12.58267716535433,
          "y": 61.577442260792736
        },
        {
          "x": 13.338582677165354,
          "y": 59.07585789696741
        },
        {
          "x": 14.094488188976378,
          "y": 56.50521847484665
        },
        {
          "x": 14.850393700787404,
          "y": 53.87101521037648
        },
        {
          "x": 15.606299212598426,
          "y": 51.207436226886855
        },
        {
          "x": 16.36220472440945,
          "y": 48.57420317801798
        },
        {
          "x": 17.118110236220474,
          "y": 46.04409897860001
        },
        {
          "x": 17.874015748031496,
          "y": 43.68606594597243
        },
        {
          "x": 18.62992125984252,
          "y": 41.550193984755964
        },
        {
          "x": 19.385826771653544,
          "y": 39.66003047444049
        },
        {
          "x": 20.141732283464567,
          "y": 38.014781834475386
        },
        {
          "x": 20.897637795275593,
          "y": 36.60019691512706
        },
        {
          "x": 21.653543307086615,
          "y": 35.40360450659713
        },
        {
          "x": 22.409448818897637,
          "y": 34.42693633545945
        },
        {
          "x": 23.16535433070866,
          "y": 33.69222078822838
        },
        {
          "x": 23.921259842519685,
          "y": 33.23677883858641
        },
        {
          "x": 24.677165354330707,
          "y": 33.099233825088064
        },
        {
          "x": 25.433070866141733,
          "y": 33.30107717827018
        },
        {
          "x": 26.188976377952756,
          "y": 33.83058764733558
        },
        {
          "x": 26.944881889763778,
          "y": 34.63558409453542
        },
        {
          "x": 27.700787401574807,
          "y": 35.62882183881261
        },
        {
          "x": 28.45669291338583,
          "y": 36.705668271092954
        },
        {
          "x": 29.212598425196852,
          "y": 37.769413724070155
        },
        {
          "x": 29.968503937007874,
          "y": 38.75666444655717
        },
        {
          "x": 30.7244094488189,
          "y": 39.65477230048677
        },
        {
          "x": 31.480314960629922,
          "y": 40.505429418893435
        },
        {
          "x": 32.23622047244095,
          "y": 41.3927468461544
        },
        {
          "x": 32.99212598425197,
          "y": 42.41900198540907
        },
        {
          "x": 33.74803149606299,
          "y": 43.67518713398099
        },
        {
          "x": 34.503937007874015,
          "y": 45.21520810420284
        },
        {
          "x": 35.25984251968504,
          "y": 47.04147903276547
        },
        {
          "x": 36.01574803149606,
          "y": 49.10607428727623
        },
        {
          "x": 36.77165354330709,
          "y": 51.326687527196704
        },
        {
          "x": 37.52755905511811,
          "y": 53.61200592681182
        },
        {
          "x": 38.28346456692913,
          "y": 55.88823814793341
        },
        {
          "x": 39.039370078740156,
          "y": 58.118353141854236
        },
        {
          "x": 39.795275590551185,
          "y": 60.30811974233103
        },
        {
          "x": 40.55118110236221,
          "y": 62.497419582506
        },
        {
          "x": 41.30708661417323,
          "y": 64.74007727398704
        },
        {
          "x": 42.06299212598425,
          "y": 67.0790466831872
        },
        {
          "x": 42.818897637795274,
          "y": 69.52506239117497
        },
        {
          "x": 43.574803149606296,
          "y": 72.0454560587237
        },
        {
          "x": 44.33070866141732,
          "y": 74.56629156286044
        },
        {
          "x": 45.08661417322834,
          "y": 76.98653291455457
        },
        {
          "x": 45.84251968503937,
          "y": 79.19913515257676
        },
        {
          "x": 46.59842519685039,
          "y": 81.11200246153629
        },
        {
          "x": 47.354330708661415,
          "y": 82.66227992285195
        },
        {
          "x": 48.11023622047244,
          "y": 83.82016654494467
        },
        {
          "x": 48.86614173228347,
          "y": 84.58233869564093
        },
        {
          "x": 49.62204724409449,
          "y": 84.95875190648327
        },
        {
          "x": 50.37795275590551,
          "y": 84.95875190648327
        },
        {
          "x": 51.13385826771653,
          "y": 84.58233869564094
        },
        {
          "x": 51.889763779527556,
          "y": 83.82016654494468
        },
        {
          "x": 52.64566929133858,
          "y": 82.66227992285197
        },
        {
          "x": 53.401574803149614,
          "y": 81.11200246153629
        },
        {
          "x": 54.15748031496064,
          "y": 79.19913515257677
        },
        {
          "x": 54.91338582677166,
          "y": 76.98653291455457
        },
        {
          "x": 55.66929133858268,
          "y": 74.56629156286047
        },
        {
          "x": 56.425196850393704,
          "y": 72.0454560587237
        },
        {
          "x": 57.181102362204726,
          "y": 69.525062391175
        },
        {
          "x": 57.93700787401575,
          "y": 67.07904668318722
        },
        {
          "x": 58.69291338582677,
          "y": 64.74007727398707
        },
        {
          "x": 59.4488188976378,
          "y": 62.497419582506005
        },
        {
          "x": 60.20472440944882,
          "y": 60.308119742331016
        },
        {
          "x": 60.960629921259844,
          "y": 58.11835314185424
        },
        {
          "x": 61.71653543307087,
          "y": 55.88823814793341
        },
        {
          "x": 62.47244094488189,
          "y": 53.61200592681183
        },
        {
          "x": 63.22834645669291,
          "y": 51.32668752719671
        },
        {
          "x": 63.98425196850393,
          "y": 49.10607428727623
        },
        {
          "x": 64.74015748031496,
          "y": 47.04147903276547
        },
        {
          "x": 65.49606299212599,
          "y": 45.21520810420283
        },
        {
          "x": 66.25196850393701,
          "y": 43.675187133980984
        },
        {
          "x": 67.00787401574803,
          "y": 42.41900198540906
        },
        {
          "x": 67.76377952755905,
          "y": 41.392746846154424
        },
        {
          "x": 68.51968503937007,
          "y": 40.50542941889346
        },
        {
          "x": 69.2755905511811,
          "y": 39.65477230048677
        },
        {
          "x": 70.03149606299212,
          "y": 38.75666444655718
        },
        {
          "x": 70.78740157480314,
          "y": 37.76941372407017
        },
        {
          "x": 71.54330708661418,
          "y": 36.70566827109295
        },
        {
          "x": 72.2992125984252,
          "y": 35.62882183881261
        },
        {
          "x": 73.05511811023622,
          "y": 34.635584094535425
        },
        {
          "x": 73.81102362204724,
          "y": 33.83058764733559
        },
        {
          "x": 74.56692913385827,
          "y": 33.30107717827019
        },
        {
          "x": 75.32283464566929,
          "y": 33.099233825088064
        },
        {
          "x": 76.07874015748031,
          "y": 33.23677883858642
        },
        {
          "x": 76.83464566929133,
          "y": 33.69222078822837
        },
        {
          "x": 77.59055118110237,
          "y": 34.42693633545945
        },
        {
          "x": 78.34645669291339,
          "y": 35.40360450659712
        },
        {
          "x": 79.10236220472441,
          "y": 36.600196915127036
        },
        {
          "x": 79.85826771653544,
          "y": 38.01478183447536
        },
        {
          "x": 80.61417322834646,
          "y": 39.66003047444048
        },
        {
          "x": 81.37007874015748,
          "y": 41.550193984755936
        },
        {
          "x": 82.1259842519685,
          "y": 43.68606594597241
        },
        {
          "x": 82.88188976377953,
          "y": 46.04409897859996
        },
        {
          "x": 83.63779527559055,
          "y": 48.57420317801798
        },
        {
          "x": 84.39370078740157,
          "y": 51.207436226886855
        },
        {
          "x": 85.14960629921259,
          "y": 53.871015210376456
        },
        {
          "x": 85.90551181102362,
          "y": 56.50521847484663
        },
        {
          "x": 86.66141732283464,
          "y": 59.07585789696739
        },
        {
          "x": 87.41732283464566,
          "y": 61.57744226079273
        },
        {
          "x": 88.17322834645668,
          "y": 64.02544332497567
        },
        {
          "x": 88.9291338582677,
          "y": 66.44006812231632
        },
        {
          "x": 89.68503937007874,
          "y": 68.8272110450611
        },
        {
          "x": 90.44094488188976,
          "y": 71.16360928916865
        },
        {
          "x": 91.19685039370079,
          "y": 73.3921081788793
        },
        {
          "x": 91.95275590551181,
          "y": 75.42966714896039
        },
        {
          "x": 92.70866141732283,
          "y": 77.18637618136067
        },
        {
          "x": 93.46456692913385,
          "y": 78.5897874709037
        },
        {
          "x": 94.22047244094487,
          "y": 79.6066829650528
        },
        {
          "x": 94.9763779527559,
          "y": 80.25480506484521
        },
        {
          "x": 95.73228346456693,
          "y": 80.60002118600245
        },
        {
          "x": 96.48818897637796,
          "y": 80.73895740748856
        },
        {
          "x": 97.24409448818898,
          "y": 80.77184044407296
        },
        {
          "x": 98,
          "y": 80.77357441624095
        }
      ],
      [
        {
          "x": 2,
          "y": 80.45794011491631
        },
        {
          "x": 2.7559055118110236,
          "y": 80.47001054558008
        },
        {
          "x": 3.5118110236220472,
          "y": 80.4773332344211
        },
        {
          "x": 4.26771653543307,
          "y": 80.40148723133463
        },
        {
          "x": 5.0236220472440944,
          "y": 80.13672726551428
        },
        {
          "x": 5.7795275590551185,
          "y": 79.57938968841684
        },
        {
          "x": 6.535433070866142,
          "y": 78.65566608350491
        },
        {
          "x": 7.291338582677165,
          "y": 77.33966422390661
        },
        {
          "x": 8.047244094488189,
          "y": 75.6569563836283
        },
        {
          "x": 8.803149606299213,
          "y": 73.67351741948947
        },
        {
          "x": 9.559055118110237,
          "y": 71.47452342575575
        },
        {
          "x": 10.31496062992126,
          "y": 69.14043414885882
        },
        {
          "x": 11.070866141732283,
          "y": 66.72820229719689
        },
        {
          "x": 11.826771653543307,
          "y": 64.26328522514964
        },
        {
          "x": 12.58267716535433,
          "y": 61.744187649290346
        },
        {
          "x": 13.338582677165354,
          "y": 59.156921410262015
        },
        {
          "x": 14.094488188976378,
          "y": 56.49350941723263
        },
        {
          "x": 14.850393700787404,
          "y": 53.76755778326291
        },
        {
          "x": 15.606299212598426,
          "y": 51.021279941013326
        },
        {
          "x": 16.36220472440945,
          "y": 48.3216312849137
        },
        {
          "x": 17.118110236220474,
          "y": 45.7472041604719
        },
        {
          "x": 17.874015748031496,
          "y": 43.370817849661115
        },
        {
          "x": 18.62992125984252,
          "y": 41.24416763423796
        },
        {
          "x": 19.385826771653544,
          "y": 39.389994259602105
        },
        {
          "x": 20.141732283464567,
          "y": 37.804356056869025
        },
        {
          "x": 20.897637795275593,
          "y": 36.4677876997402
        },
        {
          "x": 21.653543307086615,
          "y": 35.360793802160714
        },
        {
          "x": 22.409448818897637,
          "y": 34.477468831362884
        },
        {
          "x": 23.16535433070866,
          "y": 33.83167636329588
        },
        {
          "x": 23.921259842519685,
          "y": 33.452959192903904
        },
        {
          "x": 24.677165354330707,
          "y": 33.373229475859915
        },
        {
          "x": 25.433070866141733,
          "y": 33.60892148865417
        },
        {
          "x": 26.188976377952756,
          "y": 34.14535320892164
        },
        {
          "x": 26.944881889763778,
          "y": 34.92973809107732
        },
        {
          "x": 27.700787401574807,
          "y": 35.87663436550731
        },
        {
          "x": 28.45669291338583,
          "y": 36.885462951634786
        },
        {
          "x": 29.212598425196852,
          "y": 37.865463762057175
        },
        {
          "x": 29.968503937007874,
          "y": 38.76056826199118
        },
        {
          "x": 30.7244094488189,
          "y": 39.56618842325122
        },
        {
          "x": 31.480314960629922,
          "y": 40.33210635744019
        },
        {
          "x": 32.23622047244095,
          "y": 41.14984531875957
        },
        {
          "x": 32.99212598425197,
          "y": 42.12776879901681
        },
        {
          "x": 33.74803149606299,
          "y": 43.36109670760126
        },
        {
          "x": 34.503937007874015,
          "y": 44.90573419942074
        },
        {
          "x": 35.25984251968504,
          "y": 46.76369160002424
        },
        {
          "x": 36.01574803149606,
          "y": 48.88427163387046
        },
        {
          "x": 36.77165354330709,
          "y": 51.180270923291985
        },
        {
          "x": 37.52755905511811,
          "y": 53.55378255954257
        },
        {
          "x": 38.28346456692913,
          "y": 55.923300865653765
        },
        {
          "x": 39.039370078740156,
          "y": 58.2436349782823
        },
        {
          "x": 39.795275590551185,
          "y": 60.51266218674541
        },
        {
          "x": 40.55118110236221,
          "y": 62.76333113016825
        },
        {
          "x": 41.30708661417323,
          "y": 65.04409841155444
        },
        {
          "x": 42.06299212598425,
          "y": 67.39458441848667
        },
        {
          "x": 42.818897637795274,
          "y": 69.82451636525688
        },
        {
          "x": 43.574803149606296,
          "y": 72.30263277316003
        },
        {
          "x": 44.33070866141732,
          "y": 74.75869554773476
        },
        {
          "x": 45.08661417322834,
          "y": 77.09733442669581
        },
        {
          "x": 45.84251968503937,
          "y": 79.21864228776828
        },
        {
          "x": 46.59842519685039,
          "y": 81.0385089137705
        },
        {
          "x": 47.354330708661415,
          "y": 82.50221423639437
        },
        {
          "x": 48.11023622047244,
          "y": 83.58752980400018
        },
        {
          "x": 48.86614173228347,
          "y": 84.29747983739401
        },
        {
          "x": 49.62204724409449,
          "y": 84.64658778194108
        },
        {
          "x": 50.37795275590551,
          "y": 84.64658778194108
        },
        {
          "x": 51.13385826771653,
          "y": 84.29747983739402
        },
        {
          "x": 51.889763779527556,
          "y": 83.5875298040002
        },
        {
          "x": 52.64566929133858,
          "y": 82.50221423639438
        },
        {
          "x": 53.401574803149614,
          "y": 81.0385089137705
        },
        {
          "x": 54.15748031496064,
          "y": 79.21864228776829
        },
        {
          "x": 54.91338582677166,
          "y": 77.09733442669581
        },
        {
          "x": 55.66929133858268,
          "y": 74.75869554773479
        },
        {
          "x": 56.425196850393704,
          "y": 72.30263277316003
        },
        {
          "x": 57.181102362204726,
          "y": 69.82451636525691
        },
        {
          "x": 57.93700787401575,
          "y": 67.39458441848669
        },
        {
          "x": 58.69291338582677,
          "y": 65.04409841155447
        },
        {
          "x": 59.4488188976378,
          "y": 62.763331130168254
        },
        {
          "x": 60.20472440944882,
          "y": 60.512662186745395
        },
        {
          "x": 60.960629921259844,
          "y": 58.24363497828231
        },
        {
          "x": 61.71653543307087,
          "y": 55.923300865653765
        },
        {
          "x": 62.47244094488189,
          "y": 53.55378255954258
        },
        {
          "x": 63.22834645669291,
          "y": 51.18027092329199
        },
        {
          "x": 63.98425196850393,
          "y": 48.88427163387047
        },
        {
          "x": 64.74015748031496,
          "y": 46.76369160002424
        },
        {
          "x": 65.49606299212599,
          "y": 44.905734199420735
        },
        {
          "x": 66.25196850393701,
          "y": 43.361096707601256
        },
        {
          "x": 67.00787401574803,
          "y": 42.127768799016806
        },
        {
          "x": 67.76377952755905,
          "y": 41.14984531875959
        },
        {
          "x": 68.51968503937007,
          "y": 40.33210635744022
        },
        {
          "x": 69.2755905511811,
          "y": 39.56618842325122
        },
        {
          "x": 70.03149606299212,
          "y": 38.760568261991196
        },
        {
          "x": 70.78740157480314,
          "y": 37.86546376205719
        },
        {
          "x": 71.54330708661418,
          "y": 36.88546295163478
        },
        {
          "x": 72.2992125984252,
          "y": 35.87663436550731
        },
        {
          "x": 73.05511811023622,
          "y": 34.929738091077326
        },
        {
          "x": 73.81102362204724,
          "y": 34.145353208921655
        },
        {
          "x": 74.56692913385827,
          "y": 33.60892148865418
        },
        {
          "x": 75.32283464566929,
          "y": 33.373229475859915
        },
        {
          "x": 76.07874015748031,
          "y": 33.45295919290391
        },
        {
          "x": 76.83464566929133,
          "y": 33.83167636329587
        },
        {
          "x": 77.59055118110237,
          "y": 34.477468831362884
        },
        {
          "x": 78.34645669291339,
          "y": 35.36079380216071
        },
        {
          "x": 79.10236220472441,
          "y": 36.46778769974018
        },
        {
          "x": 79.85826771653544,
          "y": 37.804356056869
        },
        {
          "x": 80.61417322834646,
          "y": 39.3899942596021
        },
        {
          "x": 81.37007874015748,
          "y": 41.24416763423793
        },
        {
          "x": 82.1259842519685,
          "y": 43.370817849661094
        },
        {
          "x": 82.88188976377953,
          "y": 45.74720416047185
        },
        {
          "x": 83.63779527559055,
          "y": 48.3216312849137
        },
        {
          "x": 84.39370078740157,
          "y": 51.021279941013326
        },
        {
          "x": 85.14960629921259,
          "y": 53.76755778326289
        },
        {
          "x": 85.90551181102362,
          "y": 56.493509417232616
        },
        {
          "x": 86.66141732283464,
          "y": 59.156921410261994
        },
        {
          "x": 87.41732283464566,
          "y": 61.74418764929034
        },
        {
          "x": 88.17322834645668,
          "y": 64.2632852251496
        },
        {
          "x": 88.9291338582677,
          "y": 66.72820229719684
        },
        {
          "x": 89.68503937007874,
          "y": 69.14043414885884
        },
        {
          "x": 90.44094488188976,
          "y": 71.47452342575579
        },
        {
          "x": 91.19685039370079,
          "y": 73.67351741948946
        },
        {
          "x": 91.95275590551181,
          "y": 75.65695638362831
        },
        {
          "x": 92.70866141732283,
          "y": 77.33966422390664
        },
        {
          "x": 93.46456692913385,
          "y": 78.65566608350493
        },
        {
          "x": 94.22047244094487,
          "y": 79.57938968841684
        },
        {
          "x": 94.9763779527559,
          "y": 80.13672726551428
        },
        {
          "x": 95.73228346456693,
          "y": 80.40148723133466
        },
        {
          "x": 96.48818897637796,
          "y": 80.4773332344211
        },
        {
          "x": 97.24409448818898,
          "y": 80.47001054558007
        },
        {
          "x": 98,
          "y": 80.45794011491631
        }
      ],
      [
        {
          "x": 2,
          "y": 79.99392189878509
        },
        {
          "x": 2.7559055118110236,
          "y": 80.06163151813183
        },
        {
          "x": 3.5118110236220472,
          "y": 80.22252867911004
        },
        {
          "x": 4.26771653543307,
          "y": 80.3613630196002
        },
        {
          "x": 5.0236220472440944,
          "y": 80.3209057721247
        },
        {
          "x": 5.7795275590551185,
          "y": 79.94370220479819
        },
        {
          "x": 6.535433070866142,
          "y": 79.11274512220155
        },
        {
          "x": 7.291338582677165,
          "y": 77.77989552412889
        },
        {
          "x": 8.047244094488189,
          "y": 75.97476601950132
        },
        {
          "x": 8.803149606299213,
          "y": 73.79268997670025
        },
        {
          "x": 9.559055118110237,
          "y": 71.36647957631251
        },
        {
          "x": 10.31496062992126,
          "y": 68.83108439332479
        },
        {
          "x": 11.070866141732283,
          "y": 66.29173324643705
        },
        {
          "x": 11.826771653543307,
          "y": 63.80436856240945
        },
        {
          "x": 12.58267716535433,
          "y": 61.37287832457093
        },
        {
          "x": 13.338582677165354,
          "y": 58.96226484833166
        },
        {
          "x": 14.094488188976378,
          "y": 56.522187118089
        },
        {
          "x": 14.850393700787404,
          "y": 54.01269241341576
        },
        {
          "x": 15.606299212598426,
          "y": 51.42408461897545
        },
        {
          "x": 16.36220472440945,
          "y": 48.785507538037265
        },
        {
          "x": 17.118110236220474,
          "y": 46.16090765620339
        },
        {
          "x": 17.874015748031496,
          "y": 43.63513641891921
        },
        {
          "x": 18.62992125984252,
          "y": 41.295713805427326
        },
        {
          "x": 19.385826771653544,
          "y": 39.21640650446808
        },
        {
          "x": 20.141732283464567,
          "y": 37.44726326636975
        },
        {
          "x": 20.897637795275593,
          "y": 36.012825965120435
        },
        {
          "x": 21.653543307086615,
          "y": 34.91706962362253
        },
        {
          "x": 22.409448818897637,
          "y": 34.15139377825685
        },
        {
          "x": 23.16535433070866,
          "y": 33.701448018276594
        },
        {
          "x": 23.921259842519685,
          "y": 33.54980822411544
        },
        {
          "x": 24.677165354330707,
          "y": 33.67393006442701
        },
        {
          "x": 25.433070866141733,
          "y": 34.04136122087091
        },
        {
          "x": 26.188976377952756,
          "y": 34.60582669125658
        },
        {
          "x": 26.944881889763778,
          "y": 35.307817025345294
        },
        {
          "x": 27.700787401574807,
          "y": 36.08164987523107
        },
        {
          "x": 28.45669291338583,
          "y": 36.868249309125616
        },
        {
          "x": 29.212598425196852,
          "y": 37.630149051386745
        },
        {
          "x": 29.968503937007874,
          "y": 38.36358440385448
        },
        {
          "x": 30.7244094488189,
          "y": 39.10273797228554
        },
        {
          "x": 31.480314960629922,
          "y": 39.91333153259324
        },
        {
          "x": 32.23622047244095,
          "y": 40.876174468252714
        },
        {
          "x": 32.99212598425197,
          "y": 42.06483220872692
        },
        {
          "x": 33.74803149606299,
          "y": 43.52398749542961
        },
        {
          "x": 34.503937007874015,
          "y": 45.25538876413948
        },
        {
          "x": 35.25984251968504,
          "y": 47.21625764608147
        },
        {
          "x": 36.01574803149606,
          "y": 49.33121718233643
        },
        {
          "x": 36.77165354330709,
          "y": 51.514411873036124
        },
        {
          "x": 37.52755905511811,
          "y": 53.69498700753516
        },
        {
          "x": 38.28346456692913,
          "y": 55.83770591319122
        },
        {
          "x": 39.039370078740156,
          "y": 57.95176755101026
        },
        {
          "x": 39.795275590551185,
          "y": 60.08451637667087
        },
        {
          "x": 40.55118110236221,
          "y": 62.3015825852827
        },
        {
          "x": 41.30708661417323,
          "y": 64.65948120875332
        },
        {
          "x": 42.06299212598425,
          "y": 67.17933540698591
        },
        {
          "x": 42.818897637795274,
          "y": 69.83025541664071
        },
        {
          "x": 43.574803149606296,
          "y": 72.52798357869008
        },
        {
          "x": 44.33070866141732,
          "y": 75.14961567738196
        },
        {
          "x": 45.08661417322834,
          "y": 77.56007549689555
        },
        {
          "x": 45.84251968503937,
          "y": 79.64223219949018
        },
        {
          "x": 46.59842519685039,
          "y": 81.32136459030261
        },
        {
          "x": 47.354330708661415,
          "y": 82.57650273579816
        },
        {
          "x": 48.11023622047244,
          "y": 83.43543565398767
        },
        {
          "x": 48.86614173228347,
          "y": 83.9554774470118
        },
        {
          "x": 49.62204724409449,
          "y": 84.19669434304497
        },
        {
          "x": 50.37795275590551,
          "y": 84.19669434304497
        },
        {
          "x": 51.13385826771653,
          "y": 83.95547744701182
        },
        {
          "x": 51.889763779527556,
          "y": 83.43543565398768
        },
        {
          "x": 52.64566929133858,
          "y": 82.57650273579817
        },
        {
          "x": 53.401574803149614,
          "y": 81.32136459030261
        },
        {
          "x": 54.15748031496064,
          "y": 79.6422321994902
        },
        {
          "x": 54.91338582677166,
          "y": 77.56007549689555
        },
        {
          "x": 55.66929133858268,
          "y": 75.14961567738199
        },
        {
          "x": 56.425196850393704,
          "y": 72.52798357869008
        },
        {
          "x": 57.181102362204726,
          "y": 69.83025541664074
        },
        {
          "x": 57.93700787401575,
          "y": 67.17933540698593
        },
        {
          "x": 58.69291338582677,
          "y": 64.65948120875335
        },
        {
          "x": 59.4488188976378,
          "y": 62.3015825852827
        },
        {
          "x": 60.20472440944882,
          "y": 60.084516376670855
        },
        {
          "x": 60.960629921259844,
          "y": 57.95176755101028
        },
        {
          "x": 61.71653543307087,
          "y": 55.83770591319122
        },
        {
          "x": 62.47244094488189,
          "y": 53.69498700753518
        },
        {
          "x": 63.22834645669291,
          "y": 51.51441187303613
        },
        {
          "x": 63.98425196850393,
          "y": 49.33121718233644
        },
        {
          "x": 64.74015748031496,
          "y": 47.21625764608147
        },
        {
          "x": 65.49606299212599,
          "y": 45.255388764139475
        },
        {
          "x": 66.25196850393701,
          "y": 43.523987495429594
        },
        {
          "x": 67.00787401574803,
          "y": 42.06483220872692
        },
        {
          "x": 67.76377952755905,
          "y": 40.876174468252735
        },
        {
          "x": 68.51968503937007,
          "y": 39.91333153259327
        },
        {
          "x": 69.2755905511811,
          "y": 39.10273797228554
        },
        {
          "x": 70.03149606299212,
          "y": 38.363584403854496
        },
        {
          "x": 70.78740157480314,
          "y": 37.63014905138676
        },
        {
          "x": 71.54330708661418,
          "y": 36.86824930912561
        },
        {
          "x": 72.2992125984252,
          "y": 36.08164987523107
        },
        {
          "x": 73.05511811023622,
          "y": 35.3078170253453
        },
        {
          "x": 73.81102362204724,
          "y": 34.605826691256595
        },
        {
          "x": 74.56692913385827,
          "y": 34.041361220870925
        },
        {
          "x": 75.32283464566929,
          "y": 33.67393006442701
        },
        {
          "x": 76.07874015748031,
          "y": 33.549808224115445
        },
        {
          "x": 76.83464566929133,
          "y": 33.70144801827659
        },
        {
          "x": 77.59055118110237,
          "y": 34.15139377825685
        },
        {
          "x": 78.34645669291339,
          "y": 34.917069623622524
        },
        {
          "x": 79.10236220472441,
          "y": 36.01282596512041
        },
        {
          "x": 79.85826771653544,
          "y": 37.447263266369724
        },
        {
          "x": 80.61417322834646,
          "y": 39.216406504468075
        },
        {
          "x": 81.37007874015748,
          "y": 41.2957138054273
        },
        {
          "x": 82.1259842519685,
          "y": 43.63513641891918
        },
        {
          "x": 82.88188976377953,
          "y": 46.16090765620334
        },
        {
          "x": 83.63779527559055,
          "y": 48.785507538037265
        },
        {
          "x": 84.39370078740157,
          "y": 51.42408461897545
        },
        {
          "x": 85.14960629921259,
          "y": 54.01269241341574
        },
        {
          "x": 85.90551181102362,
          "y": 56.522187118088986
        },
        {
          "x": 86.66141732283464,
          "y": 58.962264848331635
        },
        {
          "x": 87.41732283464566,
          "y": 61.37287832457092
        },
        {
          "x": 88.17322834645668,
          "y": 63.80436856240941
        },
        {
          "x": 88.9291338582677,
          "y": 66.291733246437
        },
        {
          "x": 89.68503937007874,
          "y": 68.83108439332482
        },
        {
          "x": 90.44094488188976,
          "y": 71.36647957631254
        },
        {
          "x": 91.19685039370079,
          "y": 73.79268997670023
        },
        {
          "x": 91.95275590551181,
          "y": 75.97476601950133
        },
        {
          "x": 92.70866141732283,
          "y": 77.77989552412892
        },
        {
          "x": 93.46456692913385,
          "y": 79.11274512220156
        },
        {
          "x": 94.22047244094487,
          "y": 79.94370220479819
        },
        {
          "x": 94.9763779527559,
          "y": 80.3209057721247
        },
        {
          "x": 95.73228346456693,
          "y": 80.36136301960023
        },
        {
          "x": 96.48818897637796,
          "y": 80.22252867911004
        },
        {
          "x": 97.24409448818898,
          "y": 80.06163151813182
        },
        {
          "x": 98,
          "y": 79.99392189878509
        }
      ],
      [
        {
          "x": 2,
          "y": 79.91324854077962
        },
        {
          "x": 2.7559055118110236,
          "y": 79.98719487100477
        },
        {
          "x": 3.5118110236220472,
          "y": 80.16583786702253
        },
        {
          "x": 4.26771653543307,
          "y": 80.33118337011994
        },
        {
          "x": 5.0236220472440944,
          "y": 80.3219035530971
        },
        {
          "x": 5.7795275590551185,
          "y": 79.97572314295138
        },
        {
          "x": 6.535433070866142,
          "y": 79.17083825631974
        },
        {
          "x": 7.291338582677165,
          "y": 77.85507870470266
        },
        {
          "x": 8.047244094488189,
          "y": 76.05541469607805
        },
        {
          "x": 8.803149606299213,
          "y": 73.866334543676
        },
        {
          "x": 9.559055118110237,
          "y": 71.42173337808379
        },
        {
          "x": 10.31496062992126,
          "y": 68.85940428764236
        },
        {
          "x": 11.070866141732283,
          "y": 66.28874051404757
        },
        {
          "x": 11.826771653543307,
          "y": 63.77052592873086
        },
        {
          "x": 12.58267716535433,
          "y": 61.3134184147681
        },
        {
          "x": 13.338582677165354,
          "y": 58.88638113780875
        },
        {
          "x": 14.094488188976378,
          "y": 56.44161247069632
        },
        {
          "x": 14.850393700787404,
          "y": 53.93988498863354
        },
        {
          "x": 15.606299212598426,
          "y": 51.3703016365202
        },
        {
          "x": 16.36220472440945,
          "y": 48.759064727414874
        },
        {
          "x": 17.118110236220474,
          "y": 46.16589350880041
        },
        {
          "x": 17.874015748031496,
          "y": 43.67078004030657
        },
        {
          "x": 18.62992125984252,
          "y": 41.35650410825851
        },
        {
          "x": 19.385826771653544,
          "y": 39.29294431279844
        },
        {
          "x": 20.141732283464567,
          "y": 37.527714582120474
        },
        {
          "x": 20.897637795275593,
          "y": 36.084751697902064
        },
        {
          "x": 21.653543307086615,
          "y": 34.96934887773498
        },
        {
          "x": 22.409448818897637,
          "y": 34.17594332521182
        },
        {
          "x": 23.16535433070866,
          "y": 33.69447209624291
        },
        {
          "x": 23.921259842519685,
          "y": 33.51238542483418
        },
        {
          "x": 24.677165354330707,
          "y": 33.61184656527194
        },
        {
          "x": 25.433070866141733,
          "y": 33.96421614710775
        },
        {
          "x": 26.188976377952756,
          "y": 34.52554793414088
        },
        {
          "x": 26.944881889763778,
          "y": 35.23681699487679
        },
        {
          "x": 27.700787401574807,
          "y": 36.03090633837864
        },
        {
          "x": 28.45669291338583,
          "y": 36.84560804734974
        },
        {
          "x": 29.212598425196852,
          "y": 37.63911077439159
        },
        {
          "x": 29.968503937007874,
          "y": 38.40276348256162
        },
        {
          "x": 30.7244094488189,
          "y": 39.16607667977196
        },
        {
          "x": 31.480314960629922,
          "y": 39.991036667837655
        },
        {
          "x": 32.23622047244095,
          "y": 40.956231545326446
        },
        {
          "x": 32.99212598425197,
          "y": 42.1348630929936
        },
        {
          "x": 33.74803149606299,
          "y": 43.57316426578791
        },
        {
          "x": 34.503937007874015,
          "y": 45.27610788687662
        },
        {
          "x": 35.25984251968504,
          "y": 47.205315605653766
        },
        {
          "x": 36.01574803149606,
          "y": 49.290305797313344
        },
        {
          "x": 36.77165354330709,
          "y": 51.44985671325466
        },
        {
          "x": 37.52755905511811,
          "y": 53.61676935745455
        },
        {
          "x": 38.28346456692913,
          "y": 55.757919501923595
        },
        {
          "x": 39.039370078740156,
          "y": 57.88274866382761
        },
        {
          "x": 39.795275590551185,
          "y": 60.03693646335911
        },
        {
          "x": 40.55118110236221,
          "y": 62.28279827931494
        },
        {
          "x": 41.30708661417323,
          "y": 64.67239687132808
        },
        {
          "x": 42.06299212598425,
          "y": 67.22195406524193
        },
        {
          "x": 42.818897637795274,
          "y": 69.89598752835138
        },
        {
          "x": 43.574803149606296,
          "y": 72.60666588336144
        },
        {
          "x": 44.33070866141732,
          "y": 75.22908260269583
        },
        {
          "x": 45.08661417322834,
          "y": 77.6280401553383
        },
        {
          "x": 45.84251968503937,
          "y": 79.68818614229664
        },
        {
          "x": 46.59842519685039,
          "y": 81.33820258565666
        },
        {
          "x": 47.354330708661415,
          "y": 82.56162135398293
        },
        {
          "x": 48.11023622047244,
          "y": 83.39113580023748
        },
        {
          "x": 48.86614173228347,
          "y": 83.88860860389754
        },
        {
          "x": 49.62204724409449,
          "y": 84.11759552834371
        },
        {
          "x": 50.37795275590551,
          "y": 84.11759552834371
        },
        {
          "x": 51.13385826771653,
          "y": 83.88860860389755
        },
        {
          "x": 51.889763779527556,
          "y": 83.3911358002375
        },
        {
          "x": 52.64566929133858,
          "y": 82.56162135398294
        },
        {
          "x": 53.401574803149614,
          "y": 81.33820258565666
        },
        {
          "x": 54.15748031496064,
          "y": 79.68818614229666
        },
        {
          "x": 54.91338582677166,
          "y": 77.6280401553383
        },
        {
          "x": 55.66929133858268,
          "y": 75.22908260269585
        },
        {
          "x": 56.425196850393704,
          "y": 72.60666588336144
        },
        {
          "x": 57.181102362204726,
          "y": 69.89598752835141
        },
        {
          "x": 57.93700787401575,
          "y": 67.22195406524193
        },
        {
          "x": 58.69291338582677,
          "y": 64.6723968713281
        },
        {
          "x": 59.4488188976378,
          "y": 62.28279827931494
        },
        {
          "x": 60.20472440944882,
          "y": 60.03693646335909
        },
        {
          "x": 60.960629921259844,
          "y": 57.88274866382763
        },
        {
          "x": 61.71653543307087,
          "y": 55.757919501923595
        },
        {
          "x": 62.47244094488189,
          "y": 53.61676935745457
        },
        {
          "x": 63.22834645669291,
          "y": 51.44985671325467
        },
        {
          "x": 63.98425196850393,
          "y": 49.29030579731335
        },
        {
          "x": 64.74015748031496,
          "y": 47.205315605653766
        },
        {
          "x": 65.49606299212599,
          "y": 45.276107886876616
        },
        {
          "x": 66.25196850393701,
          "y": 43.573164265787895
        },
        {
          "x": 67.00787401574803,
          "y": 42.1348630929936
        },
        {
          "x": 67.76377952755905,
          "y": 40.95623154532647
        },
        {
          "x": 68.51968503937007,
          "y": 39.99103666783768
        },
        {
          "x": 69.2755905511811,
          "y": 39.16607667977196
        },
        {
          "x": 70.03149606299212,
          "y": 38.402763482561625
        },
        {
          "x": 70.78740157480314,
          "y": 37.639110774391604
        },
        {
          "x": 71.54330708661418,
          "y": 36.845608047349735
        },
        {
          "x": 72.2992125984252,
          "y": 36.03090633837864
        },
        {
          "x": 73.05511811023622,
          "y": 35.23681699487679
        },
        {
          "x": 73.81102362204724,
          "y": 34.525547934140896
        },
        {
          "x": 74.56692913385827,
          "y": 33.96421614710776
        },
        {
          "x": 75.32283464566929,
          "y": 33.61184656527194
        },
        {
          "x": 76.07874015748031,
          "y": 33.51238542483419
        },
        {
          "x": 76.83464566929133,
          "y": 33.694472096242905
        },
        {
          "x": 77.59055118110237,
          "y": 34.17594332521182
        },
        {
          "x": 78.34645669291339,
          "y": 34.96934887773497
        },
        {
          "x": 79.10236220472441,
          "y": 36.08475169790204
        },
        {
          "x": 79.85826771653544,
          "y": 37.527714582120446
        },
        {
          "x": 80.61417322834646,
          "y": 39.29294431279843
        },
        {
          "x": 81.37007874015748,
          "y": 41.35650410825848
        },
        {
          "x": 82.1259842519685,
          "y": 43.67078004030654
        },
        {
          "x": 82.88188976377953,
          "y": 46.16589350880036
        },
        {
          "x": 83.63779527559055,
          "y": 48.759064727414874
        },
        {
          "x": 84.39370078740157,
          "y": 51.370301636520196
        },
        {
          "x": 85.14960629921259,
          "y": 53.939884988633516
        },
        {
          "x": 85.90551181102362,
          "y": 56.441612470696306
        },
        {
          "x": 86.66141732283464,
          "y": 58.886381137808726
        },
        {
          "x": 87.41732283464566,
          "y": 61.313418414768094
        },
        {
          "x": 88.17322834645668,
          "y": 63.77052592873082
        },
        {
          "x": 88.9291338582677,
          "y": 66.28874051404753
        },
        {
          "x": 89.68503937007874,
          "y": 68.8594042876424
        },
        {
          "x": 90.44094488188976,
          "y": 71.42173337808381
        },
        {
          "x": 91.19685039370079,
          "y": 73.86633454367599
        },
        {
          "x": 91.95275590551181,
          "y": 76.05541469607806
        },
        {
          "x": 92.70866141732283,
          "y": 77.85507870470269
        },
        {
          "x": 93.46456692913385,
          "y": 79.17083825631975
        },
        {
          "x": 94.22047244094487,
          "y": 79.97572314295138
        },
        {
          "x": 94.9763779527559,
          "y": 80.3219035530971
        },
        {
          "x": 95.73228346456693,
          "y": 80.33118337011997
        },
        {
          "x": 96.48818897637796,
          "y": 80.16583786702253
        },
        {
          "x": 97.24409448818898,
          "y": 79.98719487100476
        },
        {
          "x": 98,
          "y": 79.91324854077962
        }
      ],
      [
        {
          "x": 2,
          "y": 88.40974975710172
        },
        {
          "x": 2.7559055118110236,
          "y": 88.39028304213768
        },
        {
          "x": 3.5118110236220472,
          "y": 88.29074092383478
        },
        {
          "x": 4.26771653543307,
          "y": 87.99924614218776
        },
        {
          "x": 5.0236220472440944,
          "y": 87.36451614418114
        },
        {
          "x": 5.7795275590551185,
          "y": 86.23802842504766
        },
        {
          "x": 6.535433070866142,
          "y": 84.51513695971445
        },
        {
          "x": 7.291338582677165,
          "y": 82.16385723089816
        },
        {
          "x": 8.047244094488189,
          "y": 79.23392907624995
        },
        {
          "x": 8.803149606299213,
          "y": 75.84469372505563
        },
        {
          "x": 9.559055118110237,
          "y": 72.15643602973374
        },
        {
          "x": 10.31496062992126,
          "y": 68.33429533343144
        },
        {
          "x": 11.070866141732283,
          "y": 64.51536636001283
        },
        {
          "x": 11.826771653543307,
          "y": 60.787880573877445
        },
        {
          "x": 12.58267716535433,
          "y": 57.187086027972725
        },
        {
          "x": 13.338582677165354,
          "y": 53.707093954352665
        },
        {
          "x": 14.094488188976378,
          "y": 50.32325571825104
        },
        {
          "x": 14.850393700787404,
          "y": 47.0169927115659
        },
        {
          "x": 15.606299212598426,
          "y": 43.795098481812055
        },
        {
          "x": 16.36220472440945,
          "y": 40.698118739156826
        },
        {
          "x": 17.118110236220474,
          "y": 37.79645353159271
        },
        {
          "x": 17.874015748031496,
          "y": 35.17687826690577
        },
        {
          "x": 18.62992125984252,
          "y": 32.924909470955726
        },
        {
          "x": 19.385826771653544,
          "y": 31.10905569775127
        },
        {
          "x": 20.141732283464567,
          "y": 29.77148416906902
        },
        {
          "x": 20.897637795275593,
          "y": 28.9267280652848
        },
        {
          "x": 21.653543307086615,
          "y": 28.566926879747776
        },
        {
          "x": 22.409448818897637,
          "y": 28.669903200729806
        },
        {
          "x": 23.16535433070866,
          "y": 29.205883909723624
        },
        {
          "x": 23.921259842519685,
          "y": 30.139946906184974
        },
        {
          "x": 24.677165354330707,
          "y": 31.42971288583209
        },
        {
          "x": 25.433070866141733,
          "y": 33.02036935191359
        },
        {
          "x": 26.188976377952756,
          "y": 34.840741884360995
        },
        {
          "x": 26.944881889763778,
          "y": 36.80412101964663
        },
        {
          "x": 27.700787401574807,
          "y": 38.8158576304877
        },
        {
          "x": 28.45669291338583,
          "y": 40.786969451814784
        },
        {
          "x": 29.212598425196852,
          "y": 42.65021730721309
        },
        {
          "x": 29.968503937007874,
          "y": 44.37342797161298
        },
        {
          "x": 30.7244094488189,
          "y": 45.96501262546348
        },
        {
          "x": 31.480314960629922,
          "y": 47.468745048262925
        },
        {
          "x": 32.23622047244095,
          "y": 48.94828808911351
        },
        {
          "x": 32.99212598425197,
          "y": 50.46553373736253
        },
        {
          "x": 33.74803149606299,
          "y": 52.059269300986216
        },
        {
          "x": 34.503937007874015,
          "y": 53.73104981990084
        },
        {
          "x": 35.25984251968504,
          "y": 55.44318217620916
        },
        {
          "x": 36.01574803149606,
          "y": 57.12995792647186
        },
        {
          "x": 36.77165354330709,
          "y": 58.718911496579835
        },
        {
          "x": 37.52755905511811,
          "y": 60.15539052218671
        },
        {
          "x": 38.28346456692913,
          "y": 61.42233198141227
        },
        {
          "x": 39.039370078740156,
          "y": 62.54840000867158
        },
        {
          "x": 39.795275590551185,
          "y": 63.601235574277226
        },
        {
          "x": 40.55118110236221,
          "y": 64.66737124087095
        },
        {
          "x": 41.30708661417323,
          "y": 65.82481028390407
        },
        {
          "x": 42.06299212598425,
          "y": 67.11686798161851
        },
        {
          "x": 42.818897637795274,
          "y": 68.53571264344362
        },
        {
          "x": 43.574803149606296,
          "y": 70.02111272529342
        },
        {
          "x": 44.33070866141732,
          "y": 71.47510384243046
        },
        {
          "x": 45.08661417322834,
          "y": 72.78818049654687
        },
        {
          "x": 45.84251968503937,
          "y": 73.86886727962859
        },
        {
          "x": 46.59842519685039,
          "y": 74.66738314161992
        },
        {
          "x": 47.354330708661415,
          "y": 75.18598324912564
        },
        {
          "x": 48.11023622047244,
          "y": 75.47285892438644
        },
        {
          "x": 48.86614173228347,
          "y": 75.60180470888858
        },
        {
          "x": 49.62204724409449,
          "y": 75.6444797559181
        },
        {
          "x": 50.37795275590551,
          "y": 75.6444797559181
        },
        {
          "x": 51.13385826771653,
          "y": 75.60180470888858
        },
        {
          "x": 51.889763779527556,
          "y": 75.47285892438647
        },
        {
          "x": 52.64566929133858,
          "y": 75.18598324912566
        },
        {
          "x": 53.401574803149614,
          "y": 74.66738314161994
        },
        {
          "x": 54.15748031496064,
          "y": 73.8688672796286
        },
        {
          "x": 54.91338582677166,
          "y": 72.78818049654686
        },
        {
          "x": 55.66929133858268,
          "y": 71.47510384243049
        },
        {
          "x": 56.425196850393704,
          "y": 70.02111272529342
        },
        {
          "x": 57.181102362204726,
          "y": 68.53571264344365
        },
        {
          "x": 57.93700787401575,
          "y": 67.1168679816185
        },
        {
          "x": 58.69291338582677,
          "y": 65.82481028390409
        },
        {
          "x": 59.4488188976378,
          "y": 64.66737124087095
        },
        {
          "x": 60.20472440944882,
          "y": 63.6012355742772
        },
        {
          "x": 60.960629921259844,
          "y": 62.54840000867159
        },
        {
          "x": 61.71653543307087,
          "y": 61.42233198141227
        },
        {
          "x": 62.47244094488189,
          "y": 60.15539052218673
        },
        {
          "x": 63.22834645669291,
          "y": 58.71891149657984
        },
        {
          "x": 63.98425196850393,
          "y": 57.12995792647186
        },
        {
          "x": 64.74015748031496,
          "y": 55.44318217620916
        },
        {
          "x": 65.49606299212599,
          "y": 53.73104981990083
        },
        {
          "x": 66.25196850393701,
          "y": 52.0592693009862
        },
        {
          "x": 67.00787401574803,
          "y": 50.46553373736253
        },
        {
          "x": 67.76377952755905,
          "y": 48.94828808911353
        },
        {
          "x": 68.51968503937007,
          "y": 47.46874504826295
        },
        {
          "x": 69.2755905511811,
          "y": 45.96501262546349
        },
        {
          "x": 70.03149606299212,
          "y": 44.37342797161299
        },
        {
          "x": 70.78740157480314,
          "y": 42.65021730721311
        },
        {
          "x": 71.54330708661418,
          "y": 40.78696945181478
        },
        {
          "x": 72.2992125984252,
          "y": 38.8158576304877
        },
        {
          "x": 73.05511811023622,
          "y": 36.804121019646644
        },
        {
          "x": 73.81102362204724,
          "y": 34.84074188436102
        },
        {
          "x": 74.56692913385827,
          "y": 33.0203693519136
        },
        {
          "x": 75.32283464566929,
          "y": 31.429712885832092
        },
        {
          "x": 76.07874015748031,
          "y": 30.139946906184992
        },
        {
          "x": 76.83464566929133,
          "y": 29.205883909723628
        },
        {
          "x": 77.59055118110237,
          "y": 28.669903200729813
        },
        {
          "x": 78.34645669291339,
          "y": 28.566926879747765
        },
        {
          "x": 79.10236220472441,
          "y": 28.926728065284774
        },
        {
          "x": 79.85826771653544,
          "y": 29.77148416906899
        },
        {
          "x": 80.61417322834646,
          "y": 31.109055697751266
        },
        {
          "x": 81.37007874015748,
          "y": 32.9249094709557
        },
        {
          "x": 82.1259842519685,
          "y": 35.17687826690574
        },
        {
          "x": 82.88188976377953,
          "y": 37.796453531592654
        },
        {
          "x": 83.63779527559055,
          "y": 40.69811873915682
        },
        {
          "x": 84.39370078740157,
          "y": 43.79509848181204
        },
        {
          "x": 85.14960629921259,
          "y": 47.01699271156589
        },
        {
          "x": 85.90551181102362,
          "y": 50.323255718251026
        },
        {
          "x": 86.66141732283464,
          "y": 53.70709395435264
        },
        {
          "x": 87.41732283464566,
          "y": 57.18708602797272
        },
        {
          "x": 88.17322834645668,
          "y": 60.787880573877395
        },
        {
          "x": 88.9291338582677,
          "y": 64.51536636001279
        },
        {
          "x": 89.68503937007874,
          "y": 68.3342953334315
        },
        {
          "x": 90.44094488188976,
          "y": 72.15643602973378
        },
        {
          "x": 91.19685039370079,
          "y": 75.84469372505563
        },
        {
          "x": 91.95275590551181,
          "y": 79.23392907624996
        },
        {
          "x": 92.70866141732283,
          "y": 82.16385723089817
        },
        {
          "x": 93.46456692913385,
          "y": 84.51513695971445
        },
        {
          "x": 94.22047244094487,
          "y": 86.23802842504764
        },
        {
          "x": 94.9763779527559,
          "y": 87.36451614418112
        },
        {
          "x": 95.73228346456693,
          "y": 87.9992461421878
        },
        {
          "x": 96.48818897637796,
          "y": 88.29074092383478
        },
        {
          "x": 97.24409448818898,
          "y": 88.39028304213767
        },
        {
          "x": 98,
          "y": 88.40974975710172
        }
      ],
      [
        {
          "x": 2,
          "y": 87.89482665097951
        },
        {
          "x": 2.7559055118110236,
          "y": 87.9497482652566
        },
        {
          "x": 3.5118110236220472,
          "y": 88.05187812548213
        },
        {
          "x": 4.26771653543307,
          "y": 88.03106991610018
        },
        {
          "x": 5.0236220472440944,
          "y": 87.65783165197074
        },
        {
          "x": 5.7795275590551185,
          "y": 86.70808805952586
        },
        {
          "x": 6.535433070866142,
          "y": 85.02612645876413
        },
        {
          "x": 7.291338582677165,
          "y": 82.56813647255885
        },
        {
          "x": 8.047244094488189,
          "y": 79.41468971777516
        },
        {
          "x": 8.803149606299213,
          "y": 75.7497086204667
        },
        {
          "x": 9.559055118110237,
          "y": 71.81314921154409
        },
        {
          "x": 10.31496062992126,
          "y": 67.84189261230682
        },
        {
          "x": 11.070866141732283,
          "y": 64.0161175828595
        },
        {
          "x": 11.826771653543307,
          "y": 60.42603361757856
        },
        {
          "x": 12.58267716535433,
          "y": 57.06718928121013
        },
        {
          "x": 13.338582677165354,
          "y": 53.8637891668054
        },
        {
          "x": 14.094488188976378,
          "y": 50.711268964877256
        },
        {
          "x": 14.850393700787404,
          "y": 47.52421538120882
        },
        {
          "x": 15.606299212598426,
          "y": 44.27497880198623
        },
        {
          "x": 16.36220472440945,
          "y": 41.012004958449175
        },
        {
          "x": 17.118110236220474,
          "y": 37.85365455011917
        },
        {
          "x": 17.874015748031496,
          "y": 34.960867002667165
        },
        {
          "x": 18.62992125984252,
          "y": 32.498098027246414
        },
        {
          "x": 19.385826771653544,
          "y": 30.594762643192613
        },
        {
          "x": 20.141732283464567,
          "y": 29.318304121436256
        },
        {
          "x": 20.897637795275593,
          "y": 28.665598270112277
        },
        {
          "x": 21.653543307086615,
          "y": 28.573295530938648
        },
        {
          "x": 22.409448818897637,
          "y": 28.941930204817783
        },
        {
          "x": 23.16535433070866,
          "y": 29.66497254381171
        },
        {
          "x": 23.921259842519685,
          "y": 30.653452757709953
        },
        {
          "x": 24.677165354330707,
          "y": 31.84926878347724
        },
        {
          "x": 25.433070866141733,
          "y": 33.224753070931136
        },
        {
          "x": 26.188976377952756,
          "y": 34.77090086641345
        },
        {
          "x": 26.944881889763778,
          "y": 36.4802344199354
        },
        {
          "x": 27.700787401574807,
          "y": 38.331505957363056
        },
        {
          "x": 28.45669291338583,
          "y": 40.28209636405026
        },
        {
          "x": 29.212598425196852,
          "y": 42.27069571294226
        },
        {
          "x": 29.968503937007874,
          "y": 44.22891299010734
        },
        {
          "x": 30.7244094488189,
          "y": 46.09725894940121
        },
        {
          "x": 31.480314960629922,
          "y": 47.83954276642022
        },
        {
          "x": 32.23622047244095,
          "y": 49.45050267048101
        },
        {
          "x": 32.99212598425197,
          "y": 50.954060395674944
        },
        {
          "x": 33.74803149606299,
          "y": 52.39295809960432
        },
        {
          "x": 34.503937007874015,
          "y": 53.81348810256373
        },
        {
          "x": 35.25984251968504,
          "y": 55.25055106184551
        },
        {
          "x": 36.01574803149606,
          "y": 56.7179142950585
        },
        {
          "x": 36.77165354330709,
          "y": 58.20650705487008
        },
        {
          "x": 37.52755905511811,
          "y": 59.69067421131887
        },
        {
          "x": 38.28346456692913,
          "y": 61.13957421778656
        },
        {
          "x": 39.039370078740156,
          "y": 62.52929795198423
        },
        {
          "x": 39.795275590551185,
          "y": 63.85130837900061
        },
        {
          "x": 40.55118110236221,
          "y": 65.11436540775114
        },
        {
          "x": 41.30708661417323,
          "y": 66.33957585303675
        },
        {
          "x": 42.06299212598425,
          "y": 67.55067381166099
        },
        {
          "x": 42.818897637795274,
          "y": 68.76321927874419
        },
        {
          "x": 43.574803149606296,
          "y": 69.97658670666154
        },
        {
          "x": 44.33070866141732,
          "y": 71.17141006598129
        },
        {
          "x": 45.08661417322834,
          "y": 72.31306516112986
        },
        {
          "x": 45.84251968503937,
          "y": 73.35960539030097
        },
        {
          "x": 46.59842519685039,
          "y": 74.27111566231534
        },
        {
          "x": 47.354330708661415,
          "y": 75.01720368525328
        },
        {
          "x": 48.11023622047244,
          "y": 75.58033273089379
        },
        {
          "x": 48.86614173228347,
          "y": 75.9544794944255
        },
        {
          "x": 49.62204724409449,
          "y": 76.14045724577274
        },
        {
          "x": 50.37795275590551,
          "y": 76.14045724577274
        },
        {
          "x": 51.13385826771653,
          "y": 75.9544794944255
        },
        {
          "x": 51.889763779527556,
          "y": 75.58033273089382
        },
        {
          "x": 52.64566929133858,
          "y": 75.01720368525329
        },
        {
          "x": 53.401574803149614,
          "y": 74.27111566231535
        },
        {
          "x": 54.15748031496064,
          "y": 73.35960539030098
        },
        {
          "x": 54.91338582677166,
          "y": 72.31306516112984
        },
        {
          "x": 55.66929133858268,
          "y": 71.17141006598132
        },
        {
          "x": 56.425196850393704,
          "y": 69.97658670666152
        },
        {
          "x": 57.181102362204726,
          "y": 68.76321927874422
        },
        {
          "x": 57.93700787401575,
          "y": 67.55067381166097
        },
        {
          "x": 58.69291338582677,
          "y": 66.33957585303676
        },
        {
          "x": 59.4488188976378,
          "y": 65.11436540775115
        },
        {
          "x": 60.20472440944882,
          "y": 63.851308379000585
        },
        {
          "x": 60.960629921259844,
          "y": 62.52929795198425
        },
        {
          "x": 61.71653543307087,
          "y": 61.13957421778657
        },
        {
          "x": 62.47244094488189,
          "y": 59.6906742113189
        },
        {
          "x": 63.22834645669291,
          "y": 58.20650705487009
        },
        {
          "x": 63.98425196850393,
          "y": 56.71791429505849
        },
        {
          "x": 64.74015748031496,
          "y": 55.250551061845506
        },
        {
          "x": 65.49606299212599,
          "y": 53.81348810256372
        },
        {
          "x": 66.25196850393701,
          "y": 52.39295809960431
        },
        {
          "x": 67.00787401574803,
          "y": 50.954060395674944
        },
        {
          "x": 67.76377952755905,
          "y": 49.45050267048103
        },
        {
          "x": 68.51968503937007,
          "y": 47.83954276642025
        },
        {
          "x": 69.2755905511811,
          "y": 46.09725894940122
        },
        {
          "x": 70.03149606299212,
          "y": 44.228912990107354
        },
        {
          "x": 70.78740157480314,
          "y": 42.27069571294229
        },
        {
          "x": 71.54330708661418,
          "y": 40.282096364050254
        },
        {
          "x": 72.2992125984252,
          "y": 38.331505957363056
        },
        {
          "x": 73.05511811023622,
          "y": 36.48023441993541
        },
        {
          "x": 73.81102362204724,
          "y": 34.77090086641347
        },
        {
          "x": 74.56692913385827,
          "y": 33.22475307093114
        },
        {
          "x": 75.32283464566929,
          "y": 31.849268783477243
        },
        {
          "x": 76.07874015748031,
          "y": 30.65345275770997
        },
        {
          "x": 76.83464566929133,
          "y": 29.664972543811718
        },
        {
          "x": 77.59055118110237,
          "y": 28.941930204817794
        },
        {
          "x": 78.34645669291339,
          "y": 28.573295530938644
        },
        {
          "x": 79.10236220472441,
          "y": 28.665598270112255
        },
        {
          "x": 79.85826771653544,
          "y": 29.31830412143623
        },
        {
          "x": 80.61417322834646,
          "y": 30.59476264319261
        },
        {
          "x": 81.37007874015748,
          "y": 32.49809802724638
        },
        {
          "x": 82.1259842519685,
          "y": 34.96086700266713
        },
        {
          "x": 82.88188976377953,
          "y": 37.8536545501191
        },
        {
          "x": 83.63779527559055,
          "y": 41.01200495844916
        },
        {
          "x": 84.39370078740157,
          "y": 44.27497880198621
        },
        {
          "x": 85.14960629921259,
          "y": 47.52421538120881
        },
        {
          "x": 85.90551181102362,
          "y": 50.71126896487725
        },
        {
          "x": 86.66141732283464,
          "y": 53.86378916680538
        },
        {
          "x": 87.41732283464566,
          "y": 57.06718928121013
        },
        {
          "x": 88.17322834645668,
          "y": 60.42603361757852
        },
        {
          "x": 88.9291338582677,
          "y": 64.01611758285945
        },
        {
          "x": 89.68503937007874,
          "y": 67.84189261230688
        },
        {
          "x": 90.44094488188976,
          "y": 71.81314921154413
        },
        {
          "x": 91.19685039370079,
          "y": 75.7497086204667
        },
        {
          "x": 91.95275590551181,
          "y": 79.41468971777516
        },
        {
          "x": 92.70866141732283,
          "y": 82.56813647255886
        },
        {
          "x": 93.46456692913385,
          "y": 85.02612645876413
        },
        {
          "x": 94.22047244094487,
          "y": 86.70808805952585
        },
        {
          "x": 94.9763779527559,
          "y": 87.65783165197072
        },
        {
          "x": 95.73228346456693,
          "y": 88.03106991610022
        },
        {
          "x": 96.48818897637796,
          "y": 88.05187812548213
        },
        {
          "x": 97.24409448818898,
          "y": 87.94974826525659
        },
        {
          "x": 98,
          "y": 87.89482665097951
        }
      ],
      [
        {
          "x": 2,
          "y": 88.27204784151806
        },
        {
          "x": 2.7559055118110236,
          "y": 88.304573505381
        },
        {
          "x": 3.5118110236220472,
          "y": 88.34217484850296
        },
        {
          "x": 4.26771653543307,
          "y": 88.22236778377965
        },
        {
          "x": 5.0236220472440944,
          "y": 87.72741562249072
        },
        {
          "x": 5.7795275590551185,
          "y": 86.64769561109557
        },
        {
          "x": 6.535433070866142,
          "y": 84.8429286958409
        },
        {
          "x": 7.291338582677165,
          "y": 82.28388661642143
        },
        {
          "x": 8.047244094488189,
          "y": 79.06314009116129
        },
        {
          "x": 8.803149606299213,
          "y": 75.37260283801538
        },
        {
          "x": 9.559055118110237,
          "y": 71.45526547032644
        },
        {
          "x": 10.31496062992126,
          "y": 67.5457266507563
        },
        {
          "x": 11.070866141732283,
          "y": 63.816836662814026
        },
        {
          "x": 11.826771653543307,
          "y": 60.347300702391045
        },
        {
          "x": 12.58267716535433,
          "y": 57.11835325428759
        },
        {
          "x": 13.338582677165354,
          "y": 54.03877472891876
        },
        {
          "x": 14.094488188976378,
          "y": 50.98929802576766
        },
        {
          "x": 14.850393700787404,
          "y": 47.872274286195285
        },
        {
          "x": 15.606299212598426,
          "y": 44.6517384307924
        },
        {
          "x": 16.36220472440945,
          "y": 41.372728216890344
        },
        {
          "x": 17.118110236220474,
          "y": 38.15550853054375
        },
        {
          "x": 17.874015748031496,
          "y": 35.16800903797446
        },
        {
          "x": 18.62992125984252,
          "y": 32.58593171157277
        },
        {
          "x": 19.385826771653544,
          "y": 30.552858451960915
        },
        {
          "x": 20.141732283464567,
          "y": 29.15163783125985
        },
        {
          "x": 20.897637795275593,
          "y": 28.393960126418108
        },
        {
          "x": 21.653543307086615,
          "y": 28.22894031977455
        },
        {
          "x": 22.409448818897637,
          "y": 28.56574726340829
        },
        {
          "x": 23.16535433070866,
          "y": 29.301630489476157
        },
        {
          "x": 23.921259842519685,
          "y": 30.346095458483198
        },
        {
          "x": 24.677165354330707,
          "y": 31.63439238011469
        },
        {
          "x": 25.433070866141733,
          "y": 33.127872361623254
        },
        {
          "x": 26.188976377952756,
          "y": 34.80351963523264
        },
        {
          "x": 26.944881889763778,
          "y": 36.63847945748958
        },
        {
          "x": 27.700787401574807,
          "y": 38.59658697242129
        },
        {
          "x": 28.45669291338583,
          "y": 40.62253717543355
        },
        {
          "x": 29.212598425196852,
          "y": 42.6460717860702
        },
        {
          "x": 29.968503937007874,
          "y": 44.594651516604934
        },
        {
          "x": 30.7244094488189,
          "y": 46.40993149995732
        },
        {
          "x": 31.480314960629922,
          "y": 48.06202205808385
        },
        {
          "x": 32.23622047244095,
          "y": 49.55637112486976
        },
        {
          "x": 32.99212598425197,
          "y": 50.93074700821972
        },
        {
          "x": 33.74803149606299,
          "y": 52.24323114251532
        },
        {
          "x": 34.503937007874015,
          "y": 53.55512641536923
        },
        {
          "x": 35.25984251968504,
          "y": 54.91423296103703
        },
        {
          "x": 36.01574803149606,
          "y": 56.343574777385996
        },
        {
          "x": 36.77165354330709,
          "y": 57.838595846309346
        },
        {
          "x": 37.52755905511811,
          "y": 59.37287772923141
        },
        {
          "x": 38.28346456692913,
          "y": 60.90962816967311
        },
        {
          "x": 39.039370078740156,
          "y": 62.4145065318861
        },
        {
          "x": 39.795275590551185,
          "y": 63.86530211996827
        },
        {
          "x": 40.55118110236221,
          "y": 65.25548266862188
        },
        {
          "x": 41.30708661417323,
          "y": 66.59106012459895
        },
        {
          "x": 42.06299212598425,
          "y": 67.88266341372746
        },
        {
          "x": 42.818897637795274,
          "y": 69.13629318804063
        },
        {
          "x": 43.574803149606296,
          "y": 70.34644547775387
        },
        {
          "x": 44.33070866141732,
          "y": 71.49413602454273
        },
        {
          "x": 45.08661417322834,
          "y": 72.55033726504193
        },
        {
          "x": 45.84251968503937,
          "y": 73.48324953690371
        },
        {
          "x": 46.59842519685039,
          "y": 74.26645013040236
        },
        {
          "x": 47.354330708661415,
          "y": 74.88478246820564
        },
        {
          "x": 48.11023622047244,
          "y": 75.33587975454158
        },
        {
          "x": 48.86614173228347,
          "y": 75.62702153072263
        },
        {
          "x": 49.62204724409449,
          "y": 75.76887722336559
        },
        {
          "x": 50.37795275590551,
          "y": 75.76887722336559
        },
        {
          "x": 51.13385826771653,
          "y": 75.62702153072263
        },
        {
          "x": 51.889763779527556,
          "y": 75.3358797545416
        },
        {
          "x": 52.64566929133858,
          "y": 74.88478246820566
        },
        {
          "x": 53.401574803149614,
          "y": 74.26645013040236
        },
        {
          "x": 54.15748031496064,
          "y": 73.48324953690371
        },
        {
          "x": 54.91338582677166,
          "y": 72.5503372650419
        },
        {
          "x": 55.66929133858268,
          "y": 71.49413602454274
        },
        {
          "x": 56.425196850393704,
          "y": 70.34644547775386
        },
        {
          "x": 57.181102362204726,
          "y": 69.13629318804065
        },
        {
          "x": 57.93700787401575,
          "y": 67.88266341372746
        },
        {
          "x": 58.69291338582677,
          "y": 66.59106012459897
        },
        {
          "x": 59.4488188976378,
          "y": 65.2554826686219
        },
        {
          "x": 60.20472440944882,
          "y": 63.86530211996824
        },
        {
          "x": 60.960629921259844,
          "y": 62.41450653188612
        },
        {
          "x": 61.71653543307087,
          "y": 60.90962816967312
        },
        {
          "x": 62.47244094488189,
          "y": 59.37287772923144
        },
        {
          "x": 63.22834645669291,
          "y": 57.83859584630935
        },
        {
          "x": 63.98425196850393,
          "y": 56.34357477738599
        },
        {
          "x": 64.74015748031496,
          "y": 54.91423296103702
        },
        {
          "x": 65.49606299212599,
          "y": 53.555126415369216
        },
        {
          "x": 66.25196850393701,
          "y": 52.243231142515306
        },
        {
          "x": 67.00787401574803,
          "y": 50.93074700821972
        },
        {
          "x": 67.76377952755905,
          "y": 49.556371124869784
        },
        {
          "x": 68.51968503937007,
          "y": 48.06202205808387
        },
        {
          "x": 69.2755905511811,
          "y": 46.40993149995733
        },
        {
          "x": 70.03149606299212,
          "y": 44.59465151660495
        },
        {
          "x": 70.78740157480314,
          "y": 42.64607178607023
        },
        {
          "x": 71.54330708661418,
          "y": 40.62253717543354
        },
        {
          "x": 72.2992125984252,
          "y": 38.59658697242129
        },
        {
          "x": 73.05511811023622,
          "y": 36.63847945748959
        },
        {
          "x": 73.81102362204724,
          "y": 34.80351963523267
        },
        {
          "x": 74.56692913385827,
          "y": 33.12787236162326
        },
        {
          "x": 75.32283464566929,
          "y": 31.634392380114694
        },
        {
          "x": 76.07874015748031,
          "y": 30.346095458483216
        },
        {
          "x": 76.83464566929133,
          "y": 29.301630489476167
        },
        {
          "x": 77.59055118110237,
          "y": 28.5657472634083
        },
        {
          "x": 78.34645669291339,
          "y": 28.228940319774548
        },
        {
          "x": 79.10236220472441,
          "y": 28.393960126418083
        },
        {
          "x": 79.85826771653544,
          "y": 29.151637831259823
        },
        {
          "x": 80.61417322834646,
          "y": 30.55285845196091
        },
        {
          "x": 81.37007874015748,
          "y": 32.58593171157273
        },
        {
          "x": 82.1259842519685,
          "y": 35.16800903797442
        },
        {
          "x": 82.88188976377953,
          "y": 38.155508530543685
        },
        {
          "x": 83.63779527559055,
          "y": 41.37272821689033
        },
        {
          "x": 84.39370078740157,
          "y": 44.65173843079238
        },
        {
          "x": 85.14960629921259,
          "y": 47.87227428619528
        },
        {
          "x": 85.90551181102362,
          "y": 50.98929802576765
        },
        {
          "x": 86.66141732283464,
          "y": 54.038774728918746
        },
        {
          "x": 87.41732283464566,
          "y": 57.1183532542876
        },
        {
          "x": 88.17322834645668,
          "y": 60.34730070239101
        },
        {
          "x": 88.9291338582677,
          "y": 63.816836662813984
        },
        {
          "x": 89.68503937007874,
          "y": 67.54572665075635
        },
        {
          "x": 90.44094488188976,
          "y": 71.45526547032648
        },
        {
          "x": 91.19685039370079,
          "y": 75.37260283801538
        },
        {
          "x": 91.95275590551181,
          "y": 79.06314009116127
        },
        {
          "x": 92.70866141732283,
          "y": 82.28388661642144
        },
        {
          "x": 93.46456692913385,
          "y": 84.8429286958409
        },
        {
          "x": 94.22047244094487,
          "y": 86.64769561109556
        },
        {
          "x": 94.9763779527559,
          "y": 87.72741562249071
        },
        {
          "x": 95.73228346456693,
          "y": 88.22236778377969
        },
        {
          "x": 96.48818897637796,
          "y": 88.34217484850296
        },
        {
          "x": 97.24409448818898,
          "y": 88.30457350538099
        },
        {
          "x": 98,
          "y": 88.27204784151806
        }
      ],
      [
        {
          "x": 2,
          "y": 87.63142930321396
        },
        {
          "x": 2.7559055118110236,
          "y": 87.66473881753322
        },
        {
          "x": 3.5118110236220472,
          "y": 87.7046897938107
        },
        {
          "x": 4.26771653543307,
          "y": 87.58879239499605
        },
        {
          "x": 5.0236220472440944,
          "y": 87.0993003647613
        },
        {
          "x": 5.7795275590551185,
          "y": 86.02657758771021
        },
        {
          "x": 6.535433070866142,
          "y": 84.23032788668446
        },
        {
          "x": 7.291338582677165,
          "y": 81.68130215832836
        },
        {
          "x": 8.047244094488189,
          "y": 78.4720466092765
        },
        {
          "x": 8.803149606299213,
          "y": 74.79444683713947
        },
        {
          "x": 9.559055118110237,
          "y": 70.89146179507598
        },
        {
          "x": 10.31496062992126,
          "y": 66.99765502320206
        },
        {
          "x": 11.070866141732283,
          "y": 63.28583830606981
        },
        {
          "x": 11.826771653543307,
          "y": 59.834675058415975
        },
        {
          "x": 12.58267716535433,
          "y": 56.62535480393392
        },
        {
          "x": 13.338582677165354,
          "y": 53.56660992200697
        },
        {
          "x": 14.094488188976378,
          "y": 50.53912232870162
        },
        {
          "x": 14.850393700787404,
          "y": 47.445189354342325
        },
        {
          "x": 15.606299212598426,
          "y": 44.248789412548014
        },
        {
          "x": 16.36220472440945,
          "y": 40.99490119602495
        },
        {
          "x": 17.118110236220474,
          "y": 37.80372811309042
        },
        {
          "x": 17.874015748031496,
          "y": 34.843136089563075
        },
        {
          "x": 18.62992125984252,
          "y": 32.288761250747534
        },
        {
          "x": 19.385826771653544,
          "y": 30.284117704636763
        },
        {
          "x": 20.141732283464567,
          "y": 28.911984451078766
        },
        {
          "x": 20.897637795275593,
          "y": 28.183980585360466
        },
        {
          "x": 21.653543307086615,
          "y": 28.0491484729639
        },
        {
          "x": 22.409448818897637,
          "y": 28.41658309162176
        },
        {
          "x": 23.16535433070866,
          "y": 29.183459022437773
        },
        {
          "x": 23.921259842519685,
          "y": 30.259205881574967
        },
        {
          "x": 24.677165354330707,
          "y": 31.578997326691525
        },
        {
          "x": 25.433070866141733,
          "y": 33.10410739266351
        },
        {
          "x": 26.188976377952756,
          "y": 34.811442907597694
        },
        {
          "x": 26.944881889763778,
          "y": 36.678071581604236
        },
        {
          "x": 27.700787401574807,
          "y": 38.66775105972334
        },
        {
          "x": 28.45669291338583,
          "y": 40.72509907547628
        },
        {
          "x": 29.212598425196852,
          "y": 42.77978051269776
        },
        {
          "x": 29.968503937007874,
          "y": 44.7591798621575
        },
        {
          "x": 30.7244094488189,
          "y": 46.604876836003065
        },
        {
          "x": 31.480314960629922,
          "y": 48.2869073207182
        },
        {
          "x": 32.23622047244095,
          "y": 49.81064598217069
        },
        {
          "x": 32.99212598425197,
          "y": 51.21378920700219
        },
        {
          "x": 33.74803149606299,
          "y": 52.55434803108912
        },
        {
          "x": 34.503937007874015,
          "y": 53.893556638573706
        },
        {
          "x": 35.25984251968504,
          "y": 55.27914832340474
        },
        {
          "x": 36.01574803149606,
          "y": 56.73408226987583
        },
        {
          "x": 36.77165354330709,
          "y": 58.253739831649256
        },
        {
          "x": 37.52755905511811,
          "y": 59.81164228052298
        },
        {
          "x": 38.28346456692913,
          "y": 61.37093955653491
        },
        {
          "x": 39.039370078740156,
          "y": 62.897235848051835
        },
        {
          "x": 39.795275590551185,
          "y": 64.36826804590963
        },
        {
          "x": 40.55118110236221,
          "y": 65.77745436243534
        },
        {
          "x": 41.30708661417323,
          "y": 67.13076023408217
        },
        {
          "x": 42.06299212598425,
          "y": 68.4387712022742
        },
        {
          "x": 42.818897637795274,
          "y": 69.70744776670452
        },
        {
          "x": 43.574803149606296,
          "y": 70.9312491355717
        },
        {
          "x": 44.33070866141732,
          "y": 72.0911576489674
        },
        {
          "x": 45.08661417322834,
          "y": 73.15811584411468
        },
        {
          "x": 45.84251968503937,
          "y": 74.10029773459519
        },
        {
          "x": 46.59842519685039,
          "y": 74.89125792637314
        },
        {
          "x": 47.354330708661415,
          "y": 75.51582085307902
        },
        {
          "x": 48.11023622047244,
          "y": 75.97160447164575
        },
        {
          "x": 48.86614173228347,
          "y": 76.26587685514548
        },
        {
          "x": 49.62204724409449,
          "y": 76.40929976907435
        },
        {
          "x": 50.37795275590551,
          "y": 76.40929976907435
        },
        {
          "x": 51.13385826771653,
          "y": 76.26587685514549
        },
        {
          "x": 51.889763779527556,
          "y": 75.97160447164576
        },
        {
          "x": 52.64566929133858,
          "y": 75.51582085307903
        },
        {
          "x": 53.401574803149614,
          "y": 74.89125792637314
        },
        {
          "x": 54.15748031496064,
          "y": 74.10029773459519
        },
        {
          "x": 54.91338582677166,
          "y": 73.15811584411465
        },
        {
          "x": 55.66929133858268,
          "y": 72.09115764896741
        },
        {
          "x": 56.425196850393704,
          "y": 70.93124913557169
        },
        {
          "x": 57.181102362204726,
          "y": 69.70744776670455
        },
        {
          "x": 57.93700787401575,
          "y": 68.43877120227421
        },
        {
          "x": 58.69291338582677,
          "y": 67.1307602340822
        },
        {
          "x": 59.4488188976378,
          "y": 65.77745436243535
        },
        {
          "x": 60.20472440944882,
          "y": 64.3682680459096
        },
        {
          "x": 60.960629921259844,
          "y": 62.89723584805186
        },
        {
          "x": 61.71653543307087,
          "y": 61.370939556534914
        },
        {
          "x": 62.47244094488189,
          "y": 59.81164228052301
        },
        {
          "x": 63.22834645669291,
          "y": 58.25373983164926
        },
        {
          "x": 63.98425196850393,
          "y": 56.73408226987582
        },
        {
          "x": 64.74015748031496,
          "y": 55.27914832340474
        },
        {
          "x": 65.49606299212599,
          "y": 53.8935566385737
        },
        {
          "x": 66.25196850393701,
          "y": 52.55434803108911
        },
        {
          "x": 67.00787401574803,
          "y": 51.2137892070022
        },
        {
          "x": 67.76377952755905,
          "y": 49.81064598217072
        },
        {
          "x": 68.51968503937007,
          "y": 48.28690732071822
        },
        {
          "x": 69.2755905511811,
          "y": 46.604876836003086
        },
        {
          "x": 70.03149606299212,
          "y": 44.759179862157524
        },
        {
          "x": 70.78740157480314,
          "y": 42.7797805126978
        },
        {
          "x": 71.54330708661418,
          "y": 40.72509907547628
        },
        {
          "x": 72.2992125984252,
          "y": 38.667751059723344
        },
        {
          "x": 73.05511811023622,
          "y": 36.67807158160425
        },
        {
          "x": 73.81102362204724,
          "y": 34.81144290759773
        },
        {
          "x": 74.56692913385827,
          "y": 33.10410739266352
        },
        {
          "x": 75.32283464566929,
          "y": 31.578997326691535
        },
        {
          "x": 76.07874015748031,
          "y": 30.259205881574992
        },
        {
          "x": 76.83464566929133,
          "y": 29.183459022437788
        },
        {
          "x": 77.59055118110237,
          "y": 28.416583091621778
        },
        {
          "x": 78.34645669291339,
          "y": 28.049148472963903
        },
        {
          "x": 79.10236220472441,
          "y": 28.183980585360445
        },
        {
          "x": 79.85826771653544,
          "y": 28.911984451078744
        },
        {
          "x": 80.61417322834646,
          "y": 30.284117704636763
        },
        {
          "x": 81.37007874015748,
          "y": 32.2887612507475
        },
        {
          "x": 82.1259842519685,
          "y": 34.843136089563046
        },
        {
          "x": 82.88188976377953,
          "y": 37.803728113090365
        },
        {
          "x": 83.63779527559055,
          "y": 40.994901196024934
        },
        {
          "x": 84.39370078740157,
          "y": 44.248789412548
        },
        {
          "x": 85.14960629921259,
          "y": 47.445189354342325
        },
        {
          "x": 85.90551181102362,
          "y": 50.539122328701616
        },
        {
          "x": 86.66141732283464,
          "y": 53.56660992200696
        },
        {
          "x": 87.41732283464566,
          "y": 56.625354803933924
        },
        {
          "x": 88.17322834645668,
          "y": 59.83467505841595
        },
        {
          "x": 88.9291338582677,
          "y": 63.28583830606977
        },
        {
          "x": 89.68503937007874,
          "y": 66.99765502320213
        },
        {
          "x": 90.44094488188976,
          "y": 70.89146179507604
        },
        {
          "x": 91.19685039370079,
          "y": 74.79444683713947
        },
        {
          "x": 91.95275590551181,
          "y": 78.47204660927649
        },
        {
          "x": 92.70866141732283,
          "y": 81.68130215832838
        },
        {
          "x": 93.46456692913385,
          "y": 84.23032788668446
        },
        {
          "x": 94.22047244094487,
          "y": 86.0265775877102
        },
        {
          "x": 94.9763779527559,
          "y": 87.09930036476129
        },
        {
          "x": 95.73228346456693,
          "y": 87.58879239499609
        },
        {
          "x": 96.48818897637796,
          "y": 87.7046897938107
        },
        {
          "x": 97.24409448818898,
          "y": 87.6647388175332
        },
        {
          "x": 98,
          "y": 87.63142930321396
        }
      ]
    ],
    "hero": [
      {
        "x": 2,
        "y": 87.63142930321396
      },
      {
        "x": 2.7559055118110236,
        "y": 87.66473881753322
      },
      {
        "x": 3.5118110236220472,
        "y": 87.7046897938107
      },
      {
        "x": 4.26771653543307,
        "y": 87.58879239499605
      },
      {
        "x": 5.0236220472440944,
        "y": 87.0993003647613
      },
      {
        "x": 5.7795275590551185,
        "y": 86.02657758771021
      },
      {
        "x": 6.535433070866142,
        "y": 84.23032788668446
      },
      {
        "x": 7.291338582677165,
        "y": 81.68130215832836
      },
      {
        "x": 8.047244094488189,
        "y": 78.4720466092765
      },
      {
        "x": 8.803149606299213,
        "y": 74.79444683713947
      },
      {
        "x": 9.559055118110237,
        "y": 70.89146179507598
      },
      {
        "x": 10.31496062992126,
        "y": 66.99765502320206
      },
      {
        "x": 11.070866141732283,
        "y": 63.28583830606981
      },
      {
        "x": 11.826771653543307,
        "y": 59.834675058415975
      },
      {
        "x": 12.58267716535433,
        "y": 56.62535480393392
      },
      {
        "x": 13.338582677165354,
        "y": 53.56660992200697
      },
      {
        "x": 14.094488188976378,
        "y": 50.53912232870162
      },
      {
        "x": 14.850393700787404,
        "y": 47.445189354342325
      },
      {
        "x": 15.606299212598426,
        "y": 44.248789412548014
      },
      {
        "x": 16.36220472440945,
        "y": 40.99490119602495
      },
      {
        "x": 17.118110236220474,
        "y": 37.80372811309042
      },
      {
        "x": 17.874015748031496,
        "y": 34.843136089563075
      },
      {
        "x": 18.62992125984252,
        "y": 32.288761250747534
      },
      {
        "x": 19.385826771653544,
        "y": 30.284117704636763
      },
      {
        "x": 20.141732283464567,
        "y": 28.911984451078766
      },
      {
        "x": 20.897637795275593,
        "y": 28.183980585360466
      },
      {
        "x": 21.653543307086615,
        "y": 28.0491484729639
      },
      {
        "x": 22.409448818897637,
        "y": 28.41658309162176
      },
      {
        "x": 23.16535433070866,
        "y": 29.183459022437773
      },
      {
        "x": 23.921259842519685,
        "y": 30.259205881574967
      },
      {
        "x": 24.677165354330707,
        "y": 31.578997326691525
      },
      {
        "x": 25.433070866141733,
        "y": 33.10410739266351
      },
      {
        "x": 26.188976377952756,
        "y": 34.811442907597694
      },
      {
        "x": 26.944881889763778,
        "y": 36.678071581604236
      },
      {
        "x": 27.700787401574807,
        "y": 38.66775105972334
      },
      {
        "x": 28.45669291338583,
        "y": 40.72509907547628
      },
      {
        "x": 29.212598425196852,
        "y": 42.77978051269776
      },
      {
        "x": 29.968503937007874,
        "y": 44.7591798621575
      },
      {
        "x": 30.7244094488189,
        "y": 46.604876836003065
      },
      {
        "x": 31.480314960629922,
        "y": 48.2869073207182
      },
      {
        "x": 32.23622047244095,
        "y": 49.81064598217069
      },
      {
        "x": 32.99212598425197,
        "y": 51.21378920700219
      },
      {
        "x": 33.74803149606299,
        "y": 52.55434803108912
      },
      {
        "x": 34.503937007874015,
        "y": 53.893556638573706
      },
      {
        "x": 35.25984251968504,
        "y": 55.27914832340474
      },
      {
        "x": 36.01574803149606,
        "y": 56.73408226987583
      },
      {
        "x": 36.77165354330709,
        "y": 58.253739831649256
      },
      {
        "x": 37.52755905511811,
        "y": 59.81164228052298
      },
      {
        "x": 38.28346456692913,
        "y": 61.37093955653491
      },
      {
        "x": 39.039370078740156,
        "y": 62.897235848051835
      },
      {
        "x": 39.795275590551185,
        "y": 64.36826804590963
      },
      {
        "x": 40.55118110236221,
        "y": 65.77745436243534
      },
      {
        "x": 41.30708661417323,
        "y": 67.13076023408217
      },
      {
        "x": 42.06299212598425,
        "y": 68.4387712022742
      },
      {
        "x": 42.818897637795274,
        "y": 69.70744776670452
      },
      {
        "x": 43.574803149606296,
        "y": 70.9312491355717
      },
      {
        "x": 44.33070866141732,
        "y": 72.0911576489674
      },
      {
        "x": 45.08661417322834,
        "y": 73.15811584411468
      },
      {
        "x": 45.84251968503937,
        "y": 74.10029773459519
      },
      {
        "x": 46.59842519685039,
        "y": 74.89125792637314
      },
      {
        "x": 47.354330708661415,
        "y": 75.51582085307902
      },
      {
        "x": 48.11023622047244,
        "y": 75.97160447164575
      },
      {
        "x": 48.86614173228347,
        "y": 76.26587685514548
      },
      {
        "x": 49.62204724409449,
        "y": 76.40929976907435
      },
      {
        "x": 50.37795275590551,
        "y": 76.40929976907435
      },
      {
        "x": 51.13385826771653,
        "y": 76.26587685514549
      },
      {
        "x": 51.889763779527556,
        "y": 75.97160447164576
      },
      {
        "x": 52.64566929133858,
        "y": 75.51582085307903
      },
      {
        "x": 53.401574803149614,
        "y": 74.89125792637314
      },
      {
        "x": 54.15748031496064,
        "y": 74.10029773459519
      },
      {
        "x": 54.91338582677166,
        "y": 73.15811584411465
      },
      {
        "x": 55.66929133858268,
        "y": 72.09115764896741
      },
      {
        "x": 56.425196850393704,
        "y": 70.93124913557169
      },
      {
        "x": 57.181102362204726,
        "y": 69.70744776670455
      },
      {
        "x": 57.93700787401575,
        "y": 68.43877120227421
      },
      {
        "x": 58.69291338582677,
        "y": 67.1307602340822
      },
      {
        "x": 59.4488188976378,
        "y": 65.77745436243535
      },
      {
        "x": 60.20472440944882,
        "y": 64.3682680459096
      },
      {
        "x": 60.960629921259844,
        "y": 62.89723584805186
      },
      {
        "x": 61.71653543307087,
        "y": 61.370939556534914
      },
      {
        "x": 62.47244094488189,
        "y": 59.81164228052301
      },
      {
        "x": 63.22834645669291,
        "y": 58.25373983164926
      },
      {
        "x": 63.98425196850393,
        "y": 56.73408226987582
      },
      {
        "x": 64.74015748031496,
        "y": 55.27914832340474
      },
      {
        "x": 65.49606299212599,
        "y": 53.8935566385737
      },
      {
        "x": 66.25196850393701,
        "y": 52.55434803108911
      },
      {
        "x": 67.00787401574803,
        "y": 51.2137892070022
      },
      {
        "x": 67.76377952755905,
        "y": 49.81064598217072
      },
      {
        "x": 68.51968503937007,
        "y": 48.28690732071822
      },
      {
        "x": 69.2755905511811,
        "y": 46.604876836003086
      },
      {
        "x": 70.03149606299212,
        "y": 44.759179862157524
      },
      {
        "x": 70.78740157480314,
        "y": 42.7797805126978
      },
      {
        "x": 71.54330708661418,
        "y": 40.72509907547628
      },
      {
        "x": 72.2992125984252,
        "y": 38.667751059723344
      },
      {
        "x": 73.05511811023622,
        "y": 36.67807158160425
      },
      {
        "x": 73.81102362204724,
        "y": 34.81144290759773
      },
      {
        "x": 74.56692913385827,
        "y": 33.10410739266352
      },
      {
        "x": 75.32283464566929,
        "y": 31.578997326691535
      },
      {
        "x": 76.07874015748031,
        "y": 30.259205881574992
      },
      {
        "x": 76.83464566929133,
        "y": 29.183459022437788
      },
      {
        "x": 77.59055118110237,
        "y": 28.416583091621778
      },
      {
        "x": 78.34645669291339,
        "y": 28.049148472963903
      },
      {
        "x": 79.10236220472441,
        "y": 28.183980585360445
      },
      {
        "x": 79.85826771653544,
        "y": 28.911984451078744
      },
      {
        "x": 80.61417322834646,
        "y": 30.284117704636763
      },
      {
        "x": 81.37007874015748,
        "y": 32.2887612507475
      },
      {
        "x": 82.1259842519685,
        "y": 34.843136089563046
      },
      {
        "x": 82.88188976377953,
        "y": 37.803728113090365
      },
      {
        "x": 83.63779527559055,
        "y": 40.994901196024934
      },
      {
        "x": 84.39370078740157,
        "y": 44.248789412548
      },
      {
        "x": 85.14960629921259,
        "y": 47.445189354342325
      },
      {
        "x": 85.90551181102362,
        "y": 50.539122328701616
      },
      {
        "x": 86.66141732283464,
        "y": 53.56660992200696
      },
      {
        "x": 87.41732283464566,
        "y": 56.625354803933924
      },
      {
        "x": 88.17322834645668,
        "y": 59.83467505841595
      },
      {
        "x": 88.9291338582677,
        "y": 63.28583830606977
      },
      {
        "x": 89.68503937007874,
        "y": 66.99765502320213
      },
      {
        "x": 90.44094488188976,
        "y": 70.89146179507604
      },
      {
        "x": 91.19685039370079,
        "y": 74.79444683713947
      },
      {
        "x": 91.95275590551181,
        "y": 78.47204660927649
      },
      {
        "x": 92.70866141732283,
        "y": 81.68130215832838
      },
      {
        "x": 93.46456692913385,
        "y": 84.23032788668446
      },
      {
        "x": 94.22047244094487,
        "y": 86.0265775877102
      },
      {
        "x": 94.9763779527559,
        "y": 87.09930036476129
      },
      {
        "x": 95.73228346456693,
        "y": 87.58879239499609
      },
      {
        "x": 96.48818897637796,
        "y": 87.7046897938107
      },
      {
        "x": 97.24409448818898,
        "y": 87.6647388175332
      },
      {
        "x": 98,
        "y": 87.63142930321396
      }
    ],
    "compact": [
      {
        "x": 2,
        "y": 91.06626409896371
      },
      {
        "x": 2.7559055118110236,
        "y": 90.82411421016124
      },
      {
        "x": 3.5118110236220472,
        "y": 90.102031920954
      },
      {
        "x": 4.26771653543307,
        "y": 88.91301827328024
      },
      {
        "x": 5.0236220472440944,
        "y": 87.27840754414665
      },
      {
        "x": 5.7795275590551185,
        "y": 85.22737590329828
      },
      {
        "x": 6.535433070866142,
        "y": 82.79627290491239
      },
      {
        "x": 7.291338582677165,
        "y": 80.02779444184924
      },
      {
        "x": 8.047244094488189,
        "y": 76.97002008164974
      },
      {
        "x": 8.803149606299213,
        "y": 73.67534126959625
      },
      {
        "x": 9.559055118110237,
        "y": 70.19930961730219
      },
      {
        "x": 10.31496062992126,
        "y": 66.59943631553973
      },
      {
        "x": 11.070866141732283,
        "y": 62.93397456854551
      },
      {
        "x": 11.826771653543307,
        "y": 59.260716827644345
      },
      {
        "x": 12.58267716535433,
        "y": 55.635837521395004
      },
      {
        "x": 13.338582677165354,
        "y": 52.11280998631689
      },
      {
        "x": 14.094488188976378,
        "y": 48.741423475373196
      },
      {
        "x": 14.850393700787404,
        "y": 45.566922566507685
      },
      {
        "x": 15.606299212598426,
        "y": 42.62928713939098
      },
      {
        "x": 16.36220472440945,
        "y": 39.962666482054104
      },
      {
        "x": 17.118110236220474,
        "y": 37.594976190019885
      },
      {
        "x": 17.874015748031496,
        "y": 35.547661495654644
      },
      {
        "x": 18.62992125984252,
        "y": 33.83562568258305
      },
      {
        "x": 19.385826771653544,
        "y": 32.46731746207865
      },
      {
        "x": 20.141732283464567,
        "y": 31.44496676774113
      },
      {
        "x": 20.897637795275593,
        "y": 30.764954498085185
      },
      {
        "x": 21.653543307086615,
        "y": 30.418298420125993
      },
      {
        "x": 22.409448818897637,
        "y": 30.39123483275474
      },
      {
        "x": 23.16535433070866,
        "y": 30.665873741822043
      },
      {
        "x": 23.921259842519685,
        "y": 31.220904255819693
      },
      {
        "x": 24.677165354330707,
        "y": 32.032326678888914
      },
      {
        "x": 25.433070866141733,
        "y": 33.07418833457773
      },
      {
        "x": 26.188976377952756,
        "y": 34.31930144977235
      },
      {
        "x": 26.944881889763778,
        "y": 35.73992338891633
      },
      {
        "x": 27.700787401574807,
        "y": 37.3083820576804
      },
      {
        "x": 28.45669291338583,
        "y": 38.99763227874412
      },
      {
        "x": 29.212598425196852,
        "y": 40.781732253501296
      },
      {
        "x": 29.968503937007874,
        "y": 42.636232727715715
      },
      {
        "x": 30.7244094488189,
        "y": 44.53847503935119
      },
      {
        "x": 31.480314960629922,
        "y": 46.467797708672805
      },
      {
        "x": 32.23622047244095,
        "y": 48.40565450780114
      },
      {
        "x": 32.99212598425197,
        "y": 50.33564990522813
      },
      {
        "x": 33.74803149606299,
        "y": 52.243500322962035
      },
      {
        "x": 34.503937007874015,
        "y": 54.11693169244929
      },
      {
        "x": 35.25984251968504,
        "y": 55.9455252950894
      },
      {
        "x": 36.01574803149606,
        "y": 57.72052479280973
      },
      {
        "x": 36.77165354330709,
        "y": 59.43461768707792
      },
      {
        "x": 37.52755905511811,
        "y": 61.08170420824325
      },
      {
        "x": 38.28346456692913,
        "y": 62.656665871220575
      },
      {
        "x": 39.039370078740156,
        "y": 64.15514469867598
      },
      {
        "x": 39.795275590551185,
        "y": 65.57334248678897
      },
      {
        "x": 40.55118110236221,
        "y": 66.9078475627398
      },
      {
        "x": 41.30708661417323,
        "y": 68.15549435812895
      },
      {
        "x": 42.06299212598425,
        "y": 69.31325890434479
      },
      {
        "x": 42.818897637795274,
        "y": 70.37819115052832
      },
      {
        "x": 43.574803149606296,
        "y": 71.34738291406768
      },
      {
        "x": 44.33070866141732,
        "y": 72.2179683907642
      },
      {
        "x": 45.08661417322834,
        "y": 72.9871525578006
      },
      {
        "x": 45.84251968503937,
        "y": 73.65226156255878
      },
      {
        "x": 46.59842519685039,
        "y": 74.21080835105289
      },
      {
        "x": 47.354330708661415,
        "y": 74.66056637812024
      },
      {
        "x": 48.11023622047244,
        "y": 74.99964426351434
      },
      {
        "x": 48.86614173228347,
        "y": 75.22655469880445
      },
      {
        "x": 49.62204724409449,
        "y": 75.34027173474853
      },
      {
        "x": 50.37795275590551,
        "y": 75.34027173474853
      },
      {
        "x": 51.13385826771653,
        "y": 75.22655469880445
      },
      {
        "x": 51.889763779527556,
        "y": 74.99964426351434
      },
      {
        "x": 52.64566929133858,
        "y": 74.66056637812024
      },
      {
        "x": 53.401574803149614,
        "y": 74.21080835105289
      },
      {
        "x": 54.15748031496064,
        "y": 73.65226156255878
      },
      {
        "x": 54.91338582677166,
        "y": 72.9871525578006
      },
      {
        "x": 55.66929133858268,
        "y": 72.21796839076421
      },
      {
        "x": 56.425196850393704,
        "y": 71.34738291406771
      },
      {
        "x": 57.181102362204726,
        "y": 70.37819115052834
      },
      {
        "x": 57.93700787401575,
        "y": 69.31325890434478
      },
      {
        "x": 58.69291338582677,
        "y": 68.15549435812898
      },
      {
        "x": 59.4488188976378,
        "y": 66.90784756273982
      },
      {
        "x": 60.20472440944882,
        "y": 65.57334248678897
      },
      {
        "x": 60.960629921259844,
        "y": 64.155144698676
      },
      {
        "x": 61.71653543307087,
        "y": 62.656665871220575
      },
      {
        "x": 62.47244094488189,
        "y": 61.081704208243266
      },
      {
        "x": 63.22834645669291,
        "y": 59.43461768707793
      },
      {
        "x": 63.98425196850393,
        "y": 57.72052479280974
      },
      {
        "x": 64.74015748031496,
        "y": 55.945525295089425
      },
      {
        "x": 65.49606299212599,
        "y": 54.11693169244929
      },
      {
        "x": 66.25196850393701,
        "y": 52.24350032296204
      },
      {
        "x": 67.00787401574803,
        "y": 50.33564990522814
      },
      {
        "x": 67.76377952755905,
        "y": 48.405654507801174
      },
      {
        "x": 68.51968503937007,
        "y": 46.467797708672826
      },
      {
        "x": 69.2755905511811,
        "y": 44.53847503935121
      },
      {
        "x": 70.03149606299212,
        "y": 42.636232727715736
      },
      {
        "x": 70.78740157480314,
        "y": 40.78173225350133
      },
      {
        "x": 71.54330708661418,
        "y": 38.99763227874412
      },
      {
        "x": 72.2992125984252,
        "y": 37.308382057680404
      },
      {
        "x": 73.05511811023622,
        "y": 35.73992338891636
      },
      {
        "x": 73.81102362204724,
        "y": 34.319301449772375
      },
      {
        "x": 74.56692913385827,
        "y": 33.074188334577734
      },
      {
        "x": 75.32283464566929,
        "y": 32.03232667888892
      },
      {
        "x": 76.07874015748031,
        "y": 31.220904255819693
      },
      {
        "x": 76.83464566929133,
        "y": 30.66587374182204
      },
      {
        "x": 77.59055118110237,
        "y": 30.391234832754755
      },
      {
        "x": 78.34645669291339,
        "y": 30.418298420125996
      },
      {
        "x": 79.10236220472441,
        "y": 30.76495449808517
      },
      {
        "x": 79.85826771653544,
        "y": 31.44496676774111
      },
      {
        "x": 80.61417322834646,
        "y": 32.467317462078654
      },
      {
        "x": 81.37007874015748,
        "y": 33.83562568258304
      },
      {
        "x": 82.1259842519685,
        "y": 35.547661495654644
      },
      {
        "x": 82.88188976377953,
        "y": 37.594976190019835
      },
      {
        "x": 83.63779527559055,
        "y": 39.962666482054104
      },
      {
        "x": 84.39370078740157,
        "y": 42.62928713939098
      },
      {
        "x": 85.14960629921259,
        "y": 45.566922566507685
      },
      {
        "x": 85.90551181102362,
        "y": 48.741423475373175
      },
      {
        "x": 86.66141732283464,
        "y": 52.11280998631688
      },
      {
        "x": 87.41732283464566,
        "y": 55.635837521395
      },
      {
        "x": 88.17322834645668,
        "y": 59.2607168276443
      },
      {
        "x": 88.9291338582677,
        "y": 62.933974568545466
      },
      {
        "x": 89.68503937007874,
        "y": 66.59943631553975
      },
      {
        "x": 90.44094488188976,
        "y": 70.19930961730223
      },
      {
        "x": 91.19685039370079,
        "y": 73.67534126959625
      },
      {
        "x": 91.95275590551181,
        "y": 76.97002008164972
      },
      {
        "x": 92.70866141732283,
        "y": 80.02779444184922
      },
      {
        "x": 93.46456692913385,
        "y": 82.79627290491237
      },
      {
        "x": 94.22047244094487,
        "y": 85.22737590329824
      },
      {
        "x": 94.9763779527559,
        "y": 87.27840754414662
      },
      {
        "x": 95.73228346456693,
        "y": 88.91301827328027
      },
      {
        "x": 96.48818897637796,
        "y": 90.102031920954
      },
      {
        "x": 97.24409448818898,
        "y": 90.82411421016123
      },
      {
        "x": 98,
        "y": 91.06626409896371
      }
    ]
  }
}
